export default { en: {
quicklaunch_cancel_timer_title:"Cancel Timer",
global_submit:"Submit",
global_apply:"Apply",
global_logIn:"Log In",
global_signUp:"Sign Up",
global_joinALesson:"Join a Lesson",
global_areYouStudent_question:"Are you a student?",
global_imTeacher:"I\u2019m a Teacher",
global_imStudent:"I\u2019m a Student",
global_OR:"or",
global_form_email:"Email",
global_form_password:"Password",
global_form_confirmPassword:"Confirm Password",
global_form_optionalField:"This is an optional field",
global_form_requiredField:"Required",
global_form_invalidEmail:"Please enter a valid email address.",
global_form_referralCode_question:"Referral Code?",
global_form_emailIsRequired:"Email is required",
global_form_passwordIsRequired:"Password is required",
studentJoin_explanation:"Your teacher will give you a CODE to join the lesson",
studentJoin_dontHaveAPin:"Don't have a CODE? Use MAGIC",
logIn_title:"Teacher Log In",
logIn_forgotPassword_question:"Forgot your password?",
logIn_rememberMe:"Remember me",
logIn_logInWithOffice:"Log in with Office 365",
logIn_logInWithGoogle:"Log in with Google",
forgotPassword_title:"Reset Your Password",
forgotPassword_explanation_start:"Enter the",
forgotPassword_explanation_bold:"Email Address",
forgotPassword_explanation_end:"you used to create an account, and we will send you instructions on how to change your password.",
forgotPassword_forgotEmail:"Forgot your email? Contact us at",
signUp_signUpWithOffice:"Sign up with Office 365",
signUp_signUpWithGoogle:"Sign up with Google",
signUp_signUpWithEmail:"Sign up with Email",
signUp_form_mustAcceptTerms:"You must confirm your age and accept our terms & conditions.",
signUp_title:"Teacher Sign Up",
signUp_terms_start:"I agree to Nearpod\u00b4s",
signUp_terms_link:"terms & conditions",
signUp_terms_end:"and I am over 13 years old",
signUp_form_firstName:"First Name",
signUp_form_lastName:"Last Name",
signUp_form_schoolEmail:"School Email",
signUp_studentAlertMessage:"You don't need to sign up to join a lesson.",
signUp_google_title:"Teacher Sign Up with Google",
signUp_office_title:"Teacher Sign Up with Office 365",
logInNewPassword_passwordDontMatch:"Password does not match.",
logInNewPassword_title:"Please Enter Your New Password",
global_joinASession:"Join a Session",
global_join:"Join",
global_invalidReferral:"Referral code is invalid.",
global_form_firstNameIsRequired:"First name is required",
global_form_lastNameIsRequired:"Last name is required",
header_myLibrary_link:"My Library",
header_create_link:"Create",
header_explore_link:"Explore",
header_subs_link:"Sub Plans",
binders_sort_option_name:"Sub Plan Name",
binders_sort_option_sub:"Assigned Sub",
binders_sort_option_date:"Date(s)",
binders_sort_option_status:"Status",
binders_sort_title:"Sort by:",
binders_newAssignmentBtn:"+ New Sub Plan",
binders_listHeader_name:"Sub Plan Name",
binders_listHeader_sub:"Assigned Sub",
binders_listHeader_date:"Date(s)",
binders_listHeader_status:"Status",
binders_list_emptyMsg:"Let's get started!",
binders_status_draft:"Draft",
binders_status_sent:"Sent",
binders_status_reviewed:"Reviewed",
binders_status_inProcess:"In Process",
binders_status_completed:"Completed",
binders_list_emptyMsg_link:"Click here to create your first Sub Plan.",
binders_createModal_title:"Name Sub Plan",
global_cancel:"Cancel",
global_create:"Create",
binders_sendAssignment:"Send Sub Plan",
binders_addLessons:"Add Lessons",
binders_notesTooltip_text:"Add notes for each lesson to clarify any questions for the sub.",
binders_lessons_emptyMsg:"You have not assigned any lessons yet.",
binders_lessons_emptyMsg_link:"Start adding Lessons.",
binders_lessons_titleDropdown_school:"School Info",
binders_lessons_titleDropdown_classroom:"Classroom Info",
binders_lessons_titleDropdown_assignment:"Sub Plan Info",
binders_lessons_titleDropdown_delete:"Delete Sub Plan",
binders_lessons_info_date:"Date(s)",
binders_lessons_info_sub:"Sub",
binders_lessons_info_link:"Select",
binders_lessons_title:"Sub Plan Lessons",
global_tooltip_gotIt:"Got It",
binders_npp_addNotes:"Add Notes",
binders_npp_editNotes:"Edit Notes",
binders_npp_preview:"Preview",
binders_notesModal_title:"Add Lesson Notes for",
binders_notesModal_desc:"Include any details for your substitute about this Lesson.",
binders_notesModal_placeholder:"E.g. What does your substitute need to know about this Lesson?",
binders_deleteBinder_title:"Delete Sub Plan",
binders_deleteBinder_msg:"Are you sure you want to delete this Sub Plan? You will not be able to retrieve the Sub Plan or reports in the future.",
global_date_picker_placeholder:"From MM\/DD\/YYYY to MM\/DD\/YYYY",
binders_form_school_information_title:"School Information",
binders_form_school_information_tooltip:"This information is saved to your profile and can be edited at any time.",
binders_form_school_name_label:"School Name",
binders_form_school_name_placeholder:"School Name",
binders_form_school_address_label:"School Address",
binders_form_school_address_placeholder:"Address",
binders_form_city_label:"City",
binders_form_city_placeholder:"City",
binders_form_state_label:"State",
binders_form_state_placeholder:"Select",
binders_form_zip_code_label:"ZIP Code",
binders_form_zip_code_placeholder:"ZIP",
binders_form_school_contact_label:"School Contact",
binders_form_school_contact_detail:"Who can the Sub call with questions?",
binders_form_school_contact_placeholder:"Full Name",
binders_form_school_contact_phone_placeholder:"Phone",
binders_form_school_contact_role_placeholder:"Role",
binders_form_classroom_information_title:"Classroom Information",
binders_form_classroom_information_tooltip:"This information will be saved for future use and can be edited any time.",
binders_form_class_notes_label:"Class Notes",
binders_form_class_notes_detail:"Where to find devices & other info",
binders_form_class_notes_placeholder:"What should the sub know about your classroom? Are there any notes about particular students or classroom management procedures?",
binders_form_emergency_procedures_label:"Emergency Procedures",
binders_form_emergency_procedures_placeholder:"Anything that the sub should know if there\u2019s a fire drill? Is there a teacher to reach out to for help?",
binders_form_classroom_assistance_label:"Classroom Assistance",
binders_form_classroom_assistance_detail:"Who can the Sub go to for help?",
binders_form_classroom_assistance_name_placeholder:"Full name",
binders_form_classroom_assistance_phone_placeholder:"Phone or room number",
binders_form_classroom_assistance_role_placeholder:"Role",
binders_form_classroom_information_upload:"Upload File",
binders_form_classroom_information_replace:"Replace",
binders_form_classroom_information_upload_tooltip:"Attach a JPG or PDF with any additional info that the sub may need.",
binders_form_assignment_information_title:"Sub Plan Information",
binders_form_assignment_information_tooltip:"Can be completed any time before completing the Sub Plan.",
binders_form_assignment_name_label:"Sub Plan Name",
binders_form_assignment_name_placeholder:"Sub Plan Name",
binders_form_assignment_dates_label:"Date(s) of Absence",
binders_form_assignment_sub_title:"If you know who your Sub is, please enter your Sub contact info.",
binders_form_assignment_sub_tooltip:"A Sub can view the Sub Plan once sent. ",
binders_form_sub_information_label:"Sub Contact Information",
binders_form_sub_information_person_title_placeholder:"Select",
binders_form_sub_information_first_name_placeholder:"First name",
binders_form_sub_information_last_name_placeholder:"Last name",
binders_form_sub_information_email_placeholder:"Email",
binders_form_sub_information_phone_placeholder:"Cell phone",
binders_form_assignment_admin_title:"If you don't know who your Sub is, please enter your School Admin or Sub Coordinator info.",
binders_form_assignment_admin_tooltip:"A School Admin can view the Sub Plan once sent.",
binders_form_assignment_admin_label:"School Admin Contact Information",
binders_form_admin_first_name_placeholder:"First name",
binders_form_admin_last_name_placeholder:"Last name",
binders_form_admin_email_placeholder:"Email",
binders_form_admin_role_placeholder:"Role",
binders_form_cell_notifications_title:"Enter your cell number to receive Sub Plan notifications by text.",
binders_form_cell_notifications_placeholder:"555-888-1234",
binders_form_next_button:"Next",
binders_form_send_button:"Send Sub Plan",
global_folder:"Folder",
global_lessons_sort_recent:"Recent",
global_lessons_sort_name:"Name",
global_lessons_sort_author:"Author",
global_lessons_sort_size:"Size",
global_lessons_no_results:"No results for your search. Try again.",
global_lessons_no_selected:"No lessons selected yet.",
global_add:"Add",
binders_lessons_picker_title:"Add lessons to",
binders_lessons_picker_search_placeholder:"Search My Library",
global_save:"Save",
global_delete:"Delete",
global_date_from:"From ",
global_date_to:" to ",
binders_lessonsAdded_singular:"Lesson was successfully added.",
binders_lessonsAdded_plural:"Lessons were successfully added.",
teacher_private_library_search_toolbar_title_library:"School Library",
teacher_private_library_search_toolbar_sort_by:"Sort by:",
search_input_filter:"Filter",
search_input_placeholder:"Search by Teacher or Keyword",
search_input_filters_modal_clear:"Clear all",
search_input_filters_modal_search:"Search",
teacher_private_library_root_lessons_container_empty_cta:"Add Lessons!",
teacher_private_library_root_lessons_container_empty:"There are no lessons in this library yet. Go to My Library to add lessons yourself or contact your Nearpod Admin to manage setup.",
teacher_private_library_npp_hover_layer_preview_btn_text:"Preview",
cart_button_decorator_cartButtonText_show_in_my_library:"Show In My Library",
cart_button_decorator_cartButtonText_add_to_my_library:"Add To My Library",
cart_button_decorator_cartButtonText_adding_to_cart:"Adding to cart",
cart_button_decorator_cartButtonText_removing_from_cart:"Removing from cart",
cart_button_decorator_cartButtonText_remove_from_cart:"Remove from cart",
cart_button_decorator_cartButtonText_purchase_for:"Purchase for $",
private_library_sort_options_date:"Recently Added",
private_library_sort_options_name:"Lesson Title",
private_library_sort_options_author:"Author",
private_library_sort_options_size:"Size",
admin_private_library_info_title:"School Library",
admin_private_library_info_description:"Create a Nearpod library exclusively for your school or district! You'll be able to easily share custom or downloaded lessons in a central place with all of your colleagues.",
admin_search_add_toolbar_button_area:"+ Add to Library",
admin_search_add_toolbar_button_dropdown_find_lessons:"Find Lessons",
admin_search_add_toolbar_button_dropdown_new_folder:"New Folder",
admin_search_add_toolbar_search:"Search by Teacher or Keyword",
admin_search_add_toolbar_sort_label:"Sort by:",
admin_npp_more_actions_menu_item_btn_label_add:"Add to folder",
admin_npp_more_actions_menu_item_btn_label_remove:"Remove from folder",
admin_npp_more_actions_menu_item_btn_label_delete:"Delete",
admin_private_library_npp_preview:"Preview",
private_library_breadcrumb_list_item:"School Library",
private_library_breadcrumb_dropdown_add:"Add Lessons",
private_library_breadcrumb_dropdown_rename:"Rename Folder",
private_library_breadcrumb_dropdown_delete:"Delete Folder",
private_library_breadcrumb_dropdown_color:"Folder Color",
admin_private_library_folder_button:"Add Lessons",
private_library_find_lessons_modal_header_title:"Find Lessons for Your ",
results_box_header_sort_label:"Sort by:",
admin_private_library_find_lessons_results_npp_preview:"Preview",
admin_private_library_find_lessons_results_npp_unselect:"Unselect",
private_library_npp_free:"Free",
private_library_npp_teacherlesson:"Teacher Lesson",
private_library_npp_nearpodstore:"Nearpod Store",
private_library_settings_edit_title:"School Library Settings",
private_library_settings_edit_name:"Library Name",
private_library_settings_edit_toggle:"Allow teachers to add lessons to the School Library",
private_library_settings_edit_toggle_tooltip:"Enabling this settings allows teachers to add lessons to this Library.",
private_library_settings_edit_submit:"Save",
active_filters_lessons_from:" results for:",
private_library_sort_options_relevance:"Relevance",
admin_private_library_find_lessons_results_npp_select:"Select Lesson",
add_lessons_toolbar_hint_button:"Ok, Got it!",
add_lessons_toolbar_hint_text:"Click here to add the selected lessons to your School Library!",
add_lessons_toolbar_button:"Add lessons",
add_lessons_toolbar_select_label:"Show all selected",
private_library_name_folder_modal_rename:"Rename",
private_library_name_folder_modal_name:"Name",
delete_lesson_title:"Delete Lesson",
delete_lesson_message:"Are you sure you want to delete this lesson?",
delete_folder_title:"Delete folder ",
delete_folder_message:"Are you sure you want to delete this folder? All lessons will remain in your library.",
main_header_dropdown_item:"Nearpod Store",
preview_toolbar_info:"Info",
preview_toolbar_share:"Share",
preview_toolbar_wishlist:"Wish List",
preview_toolbar_author:"Author Name",
preview_toolbar_info_details:"students reached",
long_description_title:"About This Lesson",
global_no:"No",
global_yes:"Yes",
cart_remove_alert:"Are you sure you want to remove this item from your cart?",
share_title:"Share",
global_to:"To",
share_email_share_title:"Or send via email account:",
global_send:"Send",
share_link_disclosure1:"or",
share_link_disclosure2:"to copy link",
share_embed_label:"Insert code: ",
bundle_lessons_title:"Lessons in this Bundle",
bundle_lessons_hide:"hide",
bundle_lessons_see:"see full bundle content",
private_library_find_lessons_modal_empty:"No lessons found. Try a different search!",
teacher_private_library_search_toolbar_title_district:"District Library",
binders_createModal_termsText:"I agree to the Nearpod for Subs ",
binders_createModal_termsLink:"terms and conditions",
global_confirm:"Confirm",
paidLessons_modal_title:"Heads up! You are adding paid lessons",
paidLessons_modal_text:"Teachers will have to pay for paid lessons out of pocket. Do you want to proceed?",
private_library_folder_created:"Folder created",
private_library_folder_deleted:"Folder deleted",
private_library_folder_lessonAdded:"Lesson added to folder",
private_library_folder_lessonRemoved:"Lesson removed from folder",
private_library_lessonDeleted:"Lesson deleted",
private_library_cart_itemRemoved:"Item removed from cart",
private_library_lessonsAdded:"Lessons successfully added",
private_library_cart_itemAdded:"was successfully added to your shopping cart",
private_library_search_placeholder:"Search",
private_library_admin_lessonsNumber_text:"Lessons",
private_library_findLessons_selectAll:"Select All",
private_library_findLessons_unselectAll:"Unselect All",
private_library_admin_addToLibrary_hintText:"Find lessons to add to your school or district library here!",
private_library_admin_addToLibrary_hintButton:"Ok, got it!",
private_library_admin_emptyMsg_1:"There are no lessons in this library yet.",
private_library_admin_emptyMsg_2:"for teachers across your school or district to use!",
private_library_admin_emptyMsg_link:"Add lessons",
private_library_explore_tooltip:"Check out your School Library or District Library to explore lessons shared by your colleagues!",
admin_district_library_info_title:"District Library",
private_library_title_schoolLibrary:"School Library",
private_library_title_districtLibrary:"District Library",
my_account_profile_title:"Profile",
my_account_advanced_title:"Advanced",
my_account_notifications_title:"Notifications",
my_account_notifications_content_subtitle_email:"Email Notifications",
my_account_notifications_content_description_email:"Manage your email notifications by clicking on the button below.",
my_account_notifications_content_button_text:"Manage Notifications",
my_account_profile_header_image_tooltip:"Profile image supports JPG or PNG files up to ",
my_account_profile_header_image_tooltip_btn:"Update Image",
add_to_folder_title:"Add to Folder",
add_to_folder_result_list_no_matches:"You have no folders yet",
add_to_folder_result_list_no_matches_link:"create one",
add_to_folder_new_folder_link:"Create New Folder",
add_to_folder_add_lessons:"Add Lessons",
global_back:"Back",
global_logOut:"Log Out",
sidebar_menu_following:"Following",
sidebar_menu_wishList:"Wish List",
sidebar_menu_accountPreferences:"Account Preferences",
sidebar_menu_manage:"Manage",
sidebar_menu_get_the_school_edition:"Get the School Edition",
sidebar_menu_free_trial_expired:"Your Free Trial has expired",
lessons_picker_result_list_item_bundle:"Bundle",
suggestion_list_new_item:"Can't find your school?",
suggestion_list_new_item_link:"Add it now!",
paid_lessons_add_title:"Paid Lessons",
paid_lessons_add_message:"You're including paid lessons",
private_library_name_folder_modal_placeholder:"Untitled Folder",
private_library_settings_edit_placeholder:"Library Name",
private_library_settings_edit_message:"Library name is required",
binders_deleteLesson_title:"Delete lesson",
binders_deleteLesson_msg:"Are you sure?",
global_edit:"Edit",
binders_form_assignment_admin_salutation_placeholder:"Select",
global_ok:"OK",
global_checkout:"Checkout",
item_added_alert_message:"Was successfully added to your shopping cart.",
lesson_preview_modal_secondaty_title:"Preview",
my_account_menu_navigation_profile:"Profile",
my_account_menu_navigation_advanced:"Advanced",
my_account_menu_navigation_notifications:"Notifications",
global_upgrade:"Upgrade",
my_account_menu_upgrade_container_get_the_school_edition:"Get the School Edition",
my_account_profile_personal_form_subtitle:"Personal Information",
my_account_profile_personal_form_first_name_label:"First Name",
my_account_profile_personal_form_last_name_label:"Last Name",
my_account_profile_personal_form_email_label:"Email",
my_account_profile_personal_form_change_password_btn_text:"Change password",
my_account_profile_personal_form_current_password_label:"Current Password",
my_account_profile_personal_form_new_password_label:"New Password",
my_account_profile_personal_form_confirm_new_password_label:"Confirm New Password",
global_saveChanges:"Save changes",
my_account_profile_school_form_subtitle:"School Information",
my_account_profile_school_form_country_label:"Country",
my_account_profile_school_form_state_label:"State",
my_account_profile_school_form_state_placeholder:"Select State",
my_account_profile_school_form_city_label:"City",
my_account_profile_school_form_city_placeholder:"Enter city",
my_account_profile_school_form_school_label:"School",
my_account_profile_school_form_school_placeholder:"Enter school name",
my_account_profile_teacher_form_subtitle:"Teacher Information",
my_account_profile_teacher_form_grades_label:"Grades",
my_account_profile_teacher_form_grades_placeholder:"Select Grades",
my_account_profile_teacher_form_subjects_label:"Subjects",
my_account_profile_teacher_form_subjects_placeholder:"Select Subjects",
vft_banner_content_text_title:"Introducing Virtual Field Trips",
vft_banner_content_text_subtitle:"Nearpod VRs Virtual Field Trips bring to your classroom real-world experiences that will inspire your students to learn and think more deeply.",
vft_banner_content_quote_img:"My students and I are currently obsessed with the FieldTrip feature on @nearpod for virtual field trip experiences!",
vft_banner_content_quote_text:"- Lisa B - Social Studies Teacher, Hershey, PA",
vft_banner_content_video_error:"Your browser does not support the video tag.",
vft_header_logo_text:"Nearpod vr",
vft_pick_title:"Build a Virtual Fieldtrip in 30 seconds!",
vft_pick_step1_title:"1. Where do you want to go?",
vft_pick_step2_title:"2. Add a reflection question.",
global_create_your_lesson:"Create your lesson",
share_email:"Email",
share_social:"Social",
share_link:"Link",
share_embed:"Embed",
share_email_area_input_placeholder:"Email",
my_account_menu_upgrade_trial_link_free_gold:"Free Upgrade to Gold",
my_account_menu_upgrade_trial_link:"Get another 30 days!",
admin_private_library_lessonAddedToFolder:"Your lesson was successfully added to the folder",
admin_private_library_lessonsAddedToFolder:"Your lessons were successfully added to the folder",
private_library_search_noResults_1:"No lessons match your criteria. Please try ",
private_library_folder_emptyMsg_1:"There are no lessons yet in this folder. ",
private_library_folder_emptyMsg_2:"Add some",
private_library_search_noResults_2:"another search",
private_library_lessonsPicker_district_placeholder:"Search District Library lessons\u2026",
private_library_lessonsPicker_school_placeholder:"Search School Library lessons\u2026",
private_library_find_lessons_tooltipText:"Use the filters and search bar to find lessons from your teachers or the Nearpod store.",
private_library_find_lessons_tooltipButtonText:"Ok, Got It!",
private_library_folder_renamed:"Folder Renamed",
my_account_profile_header_image_invalid_type:"Invalid file type",
global_required:"Required field.",
my_account_profile_personal_form_newPassword_confirm_not_match:"Password does not match.",
global_form_email_too_long:"Email too long (80 chars max)",
private_library_settings_district_edit_title:"District Library Settings",
intercom_school_newMessage:"Hi, I'm interested in getting the School Edition",
my_account_base_storage_you_have_used:"You have used",
global_of:"of",
my_account_advanced_text_learn_more:"Learn more",
my_account_advanced_confirm_message_notes:"Nearpod Team, I am interested in learning more about the new Student Notes feature available to School and District accounts. Please contact me with more information about how to get this new functionality for my institution. Thank you!",
private_library_lessonAdded:"Lesson successfully added",
mail_invalid_domain:"Please enter a valid email address.",
my_account_profile_header_image_uploading:"Uploading...",
sidebar_menu_contact_us:"Contact Us",
logIn_signUp_label:"Don't have an account?",
signUp_logIn_label:"Already have an account?",
my_account_profile_header_image_mb:"Mb",
themes_menu_tooltip:"New! Add color and style to slides by using Themes!",
long_description_title_bundle:"About this Bundle",
logInNewPassword_title_2:"Please Set Your New Password",
global_skip:"Skip",
onboarding_welcome_line1:"Welcome to Nearpod,",
onboarding_welcome_line2:"We're so glad you're here! Join tens of thousands of teachers who use Nearpod to inspire and engage their students every day!",
onboarding_welcome_line3:"Let's start by finding the perfect lessons for you.",
onboarding_welcome_btn:"Find Lessons",
onboarding_step1_line1:"What grade(s) do you teach?",
onboarding_step1_line2:"We have Nearpod lessons for all grades, packed with engaging content like VR field trips, interactive quizzes, and much more!",
onboarding_step1_btn:"Next",
onboarding_step2_line1:"What subject(s) do you teach?",
onboarding_step2_line2:"Nearpod lessons are standards-aligned, created by top publishers and expert teachers across many subjects!",
onboarding_step2_btn:"Get Lessons!",
onboarding_step3_loading_text:"One moment... we\u2019re customizing the best Nearpod lessons for you!",
onboarding_lessons_line1:"Ta-da! Check out these great lessons we found for you.",
onboarding_lessons_line2_part1:"Preview any of these lessons and",
onboarding_lessons_line2_part2:"select 3 favorites",
onboarding_lessons_line2_part3:"to add to your library for FREE!",
onboarding_preview_line1:"You\u2019re previewing how students would see this lesson on their computers or devices.",
onboarding_preview_line2_part1:"Nearpod is completely",
onboarding_preview_line2_part2:"free",
onboarding_preview_line2_part3:"for students!",
onboarding_toolbar_selectLessons_part1:"Select",
onboarding_toolbar_selectLessons_part2_singular:"more lesson",
onboarding_toolbar_lessonsReady:"Your lessons are ready to be added!",
onboarding_toolbar_btn:"Add to Your Library",
onboarding_toolbar_selectLessons_part2_plural:"more lessons",
school_search_form_country_label:"Country",
school_search_form_state_label:"State",
school_search_form_state_placeholder:"Select State",
school_search_form_city_label:"City",
school_search_form_city_placeholder:"Enter city",
school_search_form_school_label:"School",
school_search_form_school_placeholder:"Enter school name",
admin_onboarding_welcome_start:"Start Your School Trial",
admin_onboarding_welcome_change:"No, that's not my school",
admin_onboarding_welcome_subtitle:"Select your school to start a trial:",
admin_onboarding_start_trial_subtitle:"Check out the perks of School Edition with your personal success manager.",
admin_onboarding_start_trial_btn:"Get Started!",
admin_onboarding_invite_teachers_title:"Invite teachers to join your free trial",
admin_onboarding_invite_teachers_form_subtitle:"They will receive an invitation to join your trial for free.",
admin_onboarding_invite_teachers_form_first_name_placeholder:"Teacher first name",
admin_onboarding_invite_teachers_form_last_name_placeholder:"Teacher last name",
admin_onboarding_invite_teachers_form_email_placeholder:"Teacher email",
admin_onboarding_invite_teachers_form_save:"Add colleague",
admin_onboarding_invite_teachers_lonely_btn:"It's lonely here",
admin_onboarding_invite_teachers_add_btn:"+ Add more teachers",
admin_onboarding_invite_teachers_send_btn:"Send Invitations",
admin_onboarding_invite_teachers_animation_title:"Sharing with your colleagues!",
admin_onboarding_invite_teachers_animation_subtitle:"Your teachers will receive login credentials and instantly enjoy the benefits of School Edition.",
admin_onboarding_invite_teachers_confirm_btn_one:"Send anyway",
admin_onboarding_invite_teachers_confirm_btn_two:"Add more teachers",
admin_onboarding_invite_teachers_confirm_title:"Are you sure you don't want to invite more teachers?",
admin_onboarding_invite_teachers_confirm_message:"We recommend having at least 3 teachers in your school to get the most out of your trial.",
admin_onboarding_start_unlimited_title:"Let's start building the School Library!",
admin_onboarding_start_unlimited_subtitle_part1:"The",
admin_onboarding_start_unlimited_btn:"Let's take a look!",
admin_onboarding_share_lessons_select:"Select at least 3 lessons",
admin_onboarding_share_lessons_ready:"Your lessons are ready to add to your School Library",
admin_onboarding_share_lessons_btn:"Share lessons",
admin_onboarding_share_lessons_tooltip:"Your School Library is a central library for teachers to share lessons school-wide",
admin_onboarding_share_lessons_title:"Here are some of Nearpod's top lessons. Start sharing!",
admin_onboarding_share_lessons_animation_title_part1:"Unlocking our",
admin_onboarding_congratulations_title:"Congratulations! Your School Edition is off to a great start.",
admin_onboarding_congratulations_subtitle:"What's next?",
admin_onboarding_congratulations_contact_message:"Let's start discussing best practices, customized trainings, and more!",
admin_onboarding_congratulations_contact_btn:"Chat with an expert",
admin_onboarding_congratulations_lessons_btn:"Get more free lessons",
admin_onboarding_congratulations_lessons_message:"7000+ lessons - all available for free! Download to your heart's content.",
admin_onboarding_congratulations_admin_btn:"Go to Admin Dashboard",
admin_onboarding_contact_form_text_is_required:"Text is required",
admin_onboarding_contact_form_phone_is_required:"Phone is required",
admin_onboarding_contact_form_last_name:"Last Name",
admin_onboarding_contact_form_phone_placeholder:"Phone",
admin_onboarding_contact_form_email:"Email",
admin_onboarding_contact_form_text_label:"What can we help you with?",
admin_onboarding_contact_form_text_placeholder:"Text",
admin_onboarding_contact_title_part1:"Hi",
admin_onboarding_contact_subtitle_part1:"We'll reach out to you shortly! You can also book an appointment directly with your Customer Success",
admin_onboarding_user_invite_hint_button:"Ok, got it!",
admin_onboarding_toolbar_hint_text:"Click here when you're ready to send your invites. The more the merrier!",
admin_onboarding_contact_form_first_name:"First Name",
admin_onboarding_user_invite_tooltip:"That\u2019s you! You are already added to your Nearpod School as an Admin.",
admin_onboarding_user_invite_hint_text:"Your colleagues are already using Nearpod - select which teachers you would like to invite to join your School Edition!",
admin_onboarding_welcome_title_before:"Get your free",
admin_onboarding_welcome_title_after:"day trial of Nearpod School Edition!",
admin_onboarding_start_trial_title_before:"Welcome to School Edition,",
admin_onboarding_start_trial_title_after:"!",
admin_onboarding_start_unlimited_text_part1:"By the way, your school now has",
admin_onboarding_start_unlimited_text_part2:"unlimited, free access",
admin_onboarding_start_unlimited_text_part3:"to 7000+ Nearpod lessons!",
admin_onboarding_start_trial_text:"Hi there! Let's get started with your new School Edition trial.",
admin_onboarding_invite_teachers_form_title:"Add a colleague to your School Edition trial",
admin_onboarding_invite_teachers_subtitle_part1:"Add up to",
admin_onboarding_invite_teachers_subtitle_part2:"teachers",
admin_onboarding_invite_teachers_subtitle_part3:"to your School Edition trial for free.",
admin_onboarding_invite_teachers_toolbar_text:"invites available",
admin_onboarding_toolbar_tooltip_part1:"Questions? Contact me at:",
admin_onboarding_toolbar_tooltip_part2:"valeriad@nearpod.com",
admin_onboarding_toolbar_tooltip_part3:"or 855-632-7763",
admin_onboarding_toolbar_tooltip_part4:"ext. 2251",
admin_onboarding_share_lessons_subtitle_part1:"Add as many lessons to your School Library as you'd like. They're all free!",
admin_onboarding_share_lessons_subtitle_part2:"Nearpod School Library",
binders_lessonCodes_title:"This lesson is assigned to more than one class.",
binders_lessonCodes_subtitle:"Please Note: Lessons can take up to 10 min to launch automatically",
binders_lessonCodes_sentColumn:"Sub Plan sent on",
binders_lessonCodes_pincodeColumn:"Class Code",
binders_lessonCodes_availableColumn:"Available for",
binders_lessonNotes_missingLessons:"Please select number of lessons.",
binders_message_newBinder:"Congratulations! You are now ready to add Lessons to your Sub Plan.",
binders_message_notesSaved:"Your notes have been saved!",
binders_message_subSent:"Congratulations! Your Sub Plan has been sent and Lessons launched in Student-Paced mode.",
binders_lessons_info_admin:"Admin: ",
binders_button_dashboard:"Sub Plan Dashboard",
button_reports:"Reports",
binders_sort_option_recent:"Recent",
binders_button_sendSub:"Send Sub Plan",
binders_button_viewSub:"View Sub Plan",
binders_createModal_placeholder:"Eg: Sick Day, Emergency Reading Plans...",
binders_lessons_picker_search_title:"Add Lessons from your Library to ",
binders_notesModal_lessons_1:"One class",
binders_notesModal_lessons_2:"Two classes",
binders_notesModal_lessons_3:"Three classes",
binders_notesModal_lessons_4:"Four classes",
binders_notesModal_lessons_5:"Five classes",
binders_notes_lessons_title:"How many classes should get this Lesson? Each class will get a different Lesson Code.",
binders_notes_lessons_placeholder:"How many classes will receive the assigned lesson?",
binders_welcome_step1_title:"Now It's Your Turn! Email yourself a Sub Plan Now...",
binders_welcome_step2_title:"Examples might include emergency procedures, detailed classroom notes, or a seating chart.",
global_close:"Close",
binders_message_notesComplete:"Your Lesson Notes have been saved. All Lessons have been successfully added to your Sub Plan!",
binders_npp_viewCodes:"View Lesson Codes",
admin_onboarding_invite_animation_text:"Welcome to",
admin_onboarding_preview_line2:"All lessons are completely free with your School Edition.",
binders_message_subPlanSaved:"Your Sub Plan has been saved.",
binders_message_requiredFields:"Please complete the required fields below.",
binders_message_addLesson:"You need to add at least a lesson to your Sub Plan.",
binders_message_subPlanSent:"Sub Plan sent!",
binders_message_firstSubPlan:"Congratulations! You are now ready to create a Sub Plan.",
binders_message_error:"There was an error",
binders_video_tooltip:"Click to learn more",
admin_onboarding_contact_top_title:"Get the most out of your trial by consulting with your personal Nearpod success manager.",
admin_onboarding_contact_form_role_title:"Role",
admin_onboarding_contact_form_role_title_placeholder:"Select role",
admin_onboarding_contact_form_phone_number:"Phone (optional)",
admin_onboarding_contact_form_days:"Best days of the week to call?",
admin_onboarding_contact_form_days_placeholder:"Select days",
admin_onboarding_contact_form_times:"Best times of day to call (EST)?",
admin_onboarding_contact_form_times_placeholder:"Select times",
admin_onboarding_contact_form_discuss:"What would you like to discuss?",
admin_onboarding_invite_teachers_form_first_name:"First name",
admin_onboarding_invite_teachers_form_last_name:"Last name",
admin_onboarding_invite_teachers_form_email:"Email",
admin_onboarding_contact_form_day_monday:"Monday",
admin_onboarding_contact_form_day_tuesday:"Tuesday",
admin_onboarding_contact_form_day_wednesday:"Wednesday",
admin_onboarding_contact_form_day_thursday:"Thursday",
admin_onboarding_contact_form_day_friday:"Friday",
admin_onboarding_toolbar_hint_button:"Ok, got it!",
admin_onboarding_contact_form_validation_title:"Thank you!",
admin_onboarding_contact_form_validation_subtitle:"We will be in touch with you soon.",
admin_onboarding_contact_form_validation_button:"Go to Admin Dashboard",
admin_onboarding_contact_title_part2:"let's find a time to talk.",
admin_onboarding_contact_subtitle_part2:"Manager here:",
admin_onboarding_invite_teachers_toolbar_text_singular:"invite available",
admin_onboarding_contact_form_role_is_required:"Role is required",
admin_onboarding_contact_form_hours_are_required:"Hours are required",
admin_onboarding_contact_form_days_are_required:"Days are required",
admin_onboarding_invite_teachers_form_duplicated:"Email already added",
admin_onboarding_contact_back_button:"Back to School Trial",
admin_onboarding_contact_subtitle_link:"https:\/\/app.grooveapp.com\/meetings\/valeriad\/30min",
admin_onboarding_toolbar_phone:"8556327763",
create_toolbar_help_placeholder:"Help us improve Nearpod by sending us feedback",
create_toolbar_help_button:"Feedback",
help_box_error:"Please type something before sending this!",
global_preview:"Preview",
drag_picker_text:"Drop any files here!",
global_show_more:"Show more",
quiz_will_save_after_uploading:"Quiz will save after files are done uploading\u2026",
global_generic_error:"Something went wrong. Please try again later.",
quiz_answers_limit:"Questions can contain up to 15 answer choices only.",
quiz_questions_limit:"Quizzes can contain up to 50 questions only. If you want to ask more questions, create a 2nd quiz.",
quiz_answers_minimum:"Please include at least two answer choices.",
quiz_questions_minimum:"There has to be at least one question for this activity.",
quiz_complete_fields:"Please complete the required fields below.",
quiz_answer_drag_tooltip:"Drag to reorder",
quiz_answer_delete_tooltip:"Delete",
quiz_collapse:"Collapse All",
quiz_expand:"Expand All",
quiz_add_question:"+ Add Question",
quiz_question_drag_tooltip:"Drag to reorder",
quiz_question_title_part1:"Question",
quiz_question_title_part2:"of",
quiz_question_duplicate_tooltip:"Duplicate",
quiz_question_delete_tooltip:"Delete",
quiz_question_textarea_placeholder:"Enter your question here",
quiz_answer_textarea_placeholder:"Answer option",
quiz_add_answer:"+ Add Answer",
global_image:"Image",
global_video:"Video",
global_audio:"Audio",
global_pdf_viewer:"PDF Viewer",
global_web_content:"Web Content",
quiz_question_add_reference:"Add reference",
global_retry:"Retry",
share_email_checkbox_tooltip:"This adds the lesson to the recipient\u2019s Nearpod library",
quiz_question_reference_media_upload_failed:"Upload failed",
admin_onboarding_welcome_confirm_subtitle:"Thanks for submitting your new Nearpod School. Our team is currently validating your submission and will reach out shortly!",
signUp_form_recaptcha_error:"Please re-enter the captcha",
cart_button_decorator_cartButtonText_downloading:"Downloading",
storefront_success_update_notification:"Your Public Library has been successfully updated!",
binders_welcome_step0_title:"This simple video will show you how to create and send a Sub Plan with Nearpod.",
binders_welcome_step1_modal_title:"Send yourself a sample Sub Plan",
binders_welcome_step1_modal_button:"Send Sub Plan",
storefront_remove_lesson_title:"Remove lesson",
storefront_remove_lesson_message:"Are you sure you want to remove this lesson?",
storefront_remove_lesson_confirm:"Remove",
storefront_add_lessons_title:"Add Lessons to My Public Library",
storefront_add_lessons_subtitle:"You can only add your custom lessons to the public library.",
quiz_service_error_message:"Sorry, something went wrong. Please try again.",
admin_onboarding_start_unlimited_subtitle_part2:"School Library",
admin_onboarding_start_unlimited_subtitle_part3:"allows you to share and organize lessons with your entire school.",
storefront_add_lessons_placeholder:"Search my lessons",
storefront_npp_hoverLayer_rearrange:"Drag to rearrange",
onboarding_back_to_lessons:"Back to Lessons",
private_library_name_folder_modal_name_1:"Name Folder",
private_library_name_subfolder_modal_placeholder:"Untitled Subfolder",
private_library_name_subfolder_modal_name:"Name Subfolder",
admin_search_add_toolbar_button_dropdown_new_subfolder:"New Subfolder",
private_library_breadcrumb_dropdown_rename_subfolder:"Rename Subfolder",
private_library_breadcrumb_dropdown_delete_subfolder:"Delete Subfolder",
storefront_header_share_button:"Share",
storefront_header_date_prefix:"Since",
storefront_header_introduction_placeholder:"Write an introduction for yourself here.",
storefront_header_introduction_expand_button:"Read more",
storefront_header_introduction_collapse_button:"Read less",
storefront_header_lessons_title:"Lessons",
storefront_header_grades_title:"Grades",
storefront_header_subjects_title:"Subjects",
storefront_header_grades_button:"Add grades",
storefront_header_subjects_button:"Add subjects",
storefront_header_add_lessons_button:"Add Lessons",
storefront_header_follow_button:"Follow",
private_library_breadcrumb_dropdown_add_subfolder:"Add Subfolder",
header_library_publicLibrary:"Public Library",
public_header_placeholder_join:"Enter CODE",
public_header_signup:"Sign up",
public_header_login:"Log In",
information_modal_title_join:"Information",
information_modal_message_join:"Please enter a valid CODE",
storefront_header_following_button:"Following",
private_library_settings_edit_toggle_district:"Allow teachers to add lessons to the District Library",
storefront_empty_view_text_owner:"Your Public Library is empty.",
storefront_empty_view_text_visitor:"This teacher has not set up their Public Library yet!",
user_loggedIn_confirm_title:"Sign in required",
user_loggedIn_confirm_message:"To continue, please login or sign up.",
storefront_empty_view_button:"Add Lessons Now!",
storefront_npp_hoverLayer_remove:"Remove",
storefront_npp_hoverLayer_preview:"Preview",
storefront_header_empty_stat:"None",
storefront_header_followers:"Followers",
storefront_header_downloads:"Downloads",
add_to_subfolder_title:"Add to Subfolder",
add_to_subfolder_new_folder_link:"Create New Subfolder",
remove_from_subfolder_title:"Remove from Subfolder",
quiz_cancelConfirm:"Are you sure you want to cancel? You will lose your changes.",
cart_button_hoverLayer_added:"Lesson added!",
draw_it_will_save_after_uploading:"Draw It will save after files are done uploading\u2026",
draw_it_instructions_placeholder:"Instructions (optional)",
npp_label_new_lesson:"New Lesson!",
npp_label_new_bundle:"New Bundle!",
npp_label_new_lesson_added:"New Lesson Added!",
npp_label_new_lessons_added:"New Lessons Added!",
draw_it_drag_and_drop_message:"Students can draw on an empty canvas if no background image is uploaded.",
draw_it_drag_and_drop_button:"Upload background image",
picker_connector_or:"or",
picker_audio_title:"Upload your audios",
picker_options_title:"Choose from any of these options",
picker_audio_recorder_title:"Record your audio",
picker_gif_title:"Upload your GIFs",
picker_gif_search_placeholder:"Search Gifs with Google SafeSearch",
picker_image_title:"Upload your images",
picker_image_search_placeholder:"Search Images with Google SafeSearch",
picker_pdf_title:"Upload your PDFs",
picker_video_title:"Upload your videos",
picker_video_search_placeholder:"Search Videos with YouTube Safe Search",
picker_webpage_title:"Upload your web content",
picker_webpage_error_invalid_url:"Please include a valid URL.",
picker_webpage_error_invalid_website:"Please type a valid website.",
picker_webpage_subtitle:"Enter the website URL that students will see.",
picker_webpage_test_link:"Test this link",
picker_webpage_add_anyway:"Add to my presentation anyway.",
picker_webpage_note_part1:"Please note that Flash websites will not work on iOS devices.",
picker_webpage_note_part2:"Remember: some websites might be blocked by your school.",
draw_it_cancelConfirm:"Are you sure you want to cancel? You will lose your changes.",
privateLibrary_admin_lessonAddedGoToLibrary:"Manage Library",
privateLibrary_admin_lessonAddedStayExplore:"View Library",
privateLibrary_admin_lessonAddedToDistrict:"Your lesson was added to the District Library! Would you like to manage or view the District Library now?",
privateLibrary_admin_lessonAddedToSchool:"Your lesson was added to the School Library! Would you like to manage or view the School Library now?",
privateLibrary_cantAddLessonMessage:"This lesson is already in the ",
preview_toolbar_districtLibrary:"District Library",
preview_toolbar_schoolLibrary:"School Library",
binders_notesModal_lessons_6:"Six classes",
binders_notesModal_lessons_7:"Seven classes",
binders_notesModal_lessons_8:"Eight classes",
binders_notesModal_lessons_9:"Nine classes",
binders_notesModal_lessons_10:"Ten classes",
cart_not_enough_space_intercom_message:"I am interested in learning more about upgrading my account. Please contact me with more information about any new features as well as how to get this functionality active for my account. Thank you!",
poll_cancelConfirm:"Are you sure you want to cancel? You will lose your changes.",
poll_will_save_after_uploading:"Poll will save after files are done uploading...",
create_toolbar_settings:"Settings",
private_library_bundleAdded:"Bundle Successfully Downloaded",
private_library_bundleDeleted:"Bundle deleted",
delete_bundle_title:"Delete Bundle",
delete_bundle_message:"Are you sure you want to delete this Bundle?",
poll_save_settings_success:"Settings successfully updated!",
student_join_title:"Students",
multiple_school_libraries_dropdown_settings:"School Library Settings",
multiple_school_libraries_dropdown_switch:"Switch School Library",
multiple_school_libraries_switch_modal_title:"View School Library",
poll_settings_message:"Allow students to select multiple options",
poll_settings_button_save:"Save",
multiple_school_libraries_switch_modal_placeholder:"School Name",
studentJoin_explanation_ios:"Get a CODE from your teacher to join a lesson.",
studentJoin_dontHaveAPin_ios:"Or, type \"MAGIC\" to experience Nearpod at your own pace.",
public_header_placeholder_join_ios:"Enter lesson CODE",
privateLibrary_admin_bundleAddedToSchool:"Your bundle was added to the School Library! Would you like to manage or view the School Library now?",
privateLibrary_admin_bundleAddedToDistrict:"Your bundle was added to the District Library! Would you like to manage or view the District Library now?",
school_onboarding_overlay:"Welcome to your School Library!",
matching_pairs_back_to_results:"Back to results",
matching_pairs_dashboard_student:"Student",
matching_pairs_dashboard_matches
:"Matches",
matching_pairs_dashboard_tries:"Tries",
matching_pairs_ct_add_pair:"Add pair",
matching_pairs_ct_add_pair_error:"Please include 2 pairs of items",
matching_pairs_dashboard_view_pairs:"View pairs",
matching_pairs_zoom_tooltip
:"",
matching_pairs_zoom_tooltip_confirm:"",
matching_pairs_settings_title:"Matching Pairs settings",
matching_pairs_settings_cancel
:"Cancel",
matching_pairs_settings_confirm
:"Save",
matching_pairs_ct_instructions
:"Instructions (optional)",
matching_pairs_ct_title
:"Matching Pairs",
matching_pairs_ct_input_add_image:"Add an image",
matching_pairs_ct_input_add_text:"Enter text",
matching_pairs_ct_input_add_or:"or",
matching_pairs_ct_delete_pair:"Delete pair",
matching_pairs_ct_add_another_pair
:"Add another pair",
matching_pairs_service_error
:"Sorry, something went wrong. Please try again.",
matching_pairs_back:"Back to pairs",
matching_pairs_well_done
:"Well done!",
matching_pairs_student_complete:"You may review the correct pairs or continue with the lesson.",
matching_pairs_student_wait:"Wait for your teacher to continue with the lesson.",
matching_pairs_student_confirm:"Got it",
matching_pairs_ct_delete_cancel:"Cancel",
matching_pairs_ct_delete_title
:"Delete pair",
matching_pairs_ct_delete_confirmation_title:"Are you sure?",
matching_pairs_ct_delete_confirmation_information:"This pair will be deleted permanently",
matching_pairs_service_pair_added:"Pair was successfully added.",
matching_pairs_service_pair_error:"Please complete the required fields below.",
matching_pairs_settings_random_prompt:"Randomize card placement for each student. This prevents students from copying from students sitting next to them.",
matching_pairs_settings_random_title:"Randomize cards",
matching_pairs_pairs:"Pairs",
matching_pairs_ct_done:"Done",
matching_pairs_ct_delete_confirm:"Delete",
global_joinASession_ios:"Join a Session",
header_reports_link:"Reports",
header_learn_link:"Learn",
privateLibrary_cantAddBundleMessage:"This bundle is already in the ",
cart_button_decorator_cartButtonText_preview:"Preview",
private_library_lesson_added_to_single_library:"Lesson Added to this School Library",
private_library_lesson_added_to_multiple_libraries:"Lesson Added to all School Libraries",
private_library_lessons_added_to_single_library:"Lessons Added to this School Library",
private_library_lessons_added_to_multiple_libraries:"Lessons Added to all School Libraries",
addLessons_multipleSchools_modal_title:"Would you like to add these Lessons to all your School Libraries?",
addLesson_multipleSchools_modal_title:"Would you like to add this Lesson to all your School Libraries?",
district_onboarding_overlay:"Welcome to your District Library!",
delete_bundle_multiple_school_message:"Do you want to Delete this Bundle from all School Libraries?",
delete_lesson_multiple_school_message:"Do you want to Delete this Lesson from all School Libraries?",
delete_single_library_option:"Only This Library",
delete_multiple_libraries_option:"Delete From All",
private_library_bundle_multipleLibraries_deleted:"Bundle deleted from all School Libraries",
private_library_lesson_multipleLibraries_deleted:"Lesson deleted from all School Libraries",
header_HowItWorks_link:"How It Works",
header_ForStudents:"For Students",
header_EnterCODEToJoinALesson_placeholder:"Enter CODE",
header_SignIn_link:"Sign In",
header_SignUpForFree_link:"Sign Up For Free",
header_ExploreLessons_link:"Explore Lessons",
poll_settings_description:"If not selected the poll answer will be limited to only one option per student.",
poll_edit_settings_modal_title:"Poll Settings",
verify_account_text_part1:"We just sent you an email to verify your",
verify_account_text_part3
:"account:",
verify_account_text_part2:"Nearpod",
create_your_own_lesson_text:"Create your own lesson",
explore_our_lessons_and_one_free_text:"Explore our lessons and add one for FREE",
explore_our_lessons_text:"Explore our lessons",
matching_pairs_ct_pair_added:"Pair was successfully added",
matching_pairs_ct_complete:"Please complete the required fields below.",
matching_pairs_ct_delete_removed:"The pair was successfully removed",
matching_pairs_ct_addTextImage:"Add Text or Image",
matching_pairs_ct_pair:"Pair",
matching_pairs_countdown_letsGo:"Let's Go",
timer_modal_title:"Activity Timer",
timer_modal_text:"Your students will have this much time to complete the activity.",
timer_modal_minutes:"min",
timer_modal_seconds:"sec",
timer_modal_cancel:"Cancel",
timer_modal_add:"Add",
matching_pairs_preview_back:"Back to Pairs",
matching_pairs_preview_title:"Pairs",
timer_addBtn:"Add Timer",
activity_timer_timeIsUp:"Time's Up!",
matchingPairs_timer_answersSubmitted:"Please wait for your teacher to",
activity_timer_timeFor:"Time for",
activity_timer_youWillHave:"You will have",
activity_timer_readySet:"Wait for your teacher. Ready, set...",
activity_timer_min:"min",
activity_timer_sec:"sec",
matchingPairs_timer_answersSubmitted2:"continue with the lesson.",
activity_timer_timeForMatchingPairs2:"Matching Pairs!",
timer_startActivityBtn:"Start activity",
matchingPairs_wellDone_tries:"Tries",
matching_pairs_dashboard_title:"Classroom Results",
private_library_npp_nearpodlibrary:"NP Lesson Library",
main_header_dropdown_nearpodLibrary:"Nearpod Library",
private_library_find_lessons_tooltipText2:"Use the filters and search bar to find lessons from your teachers or the Nearpod Library.",
my_library_lessons_title:"My Lessons",
my_library_tips_and_tricks_title:"Tips And Tricks",
lessons_list_header_sort_title:"Sort by:",
my_library_name_folder_modal_placeholder:"Untitled Folder",
my_library_name_folder_modal_title:"Name Folder",
my_library_name_folder_modal_creating:"Creating...",
my_library_name_folder_modal_renaming:"Renaming...",
my_library_name_folder_modal_rename:"Rename",
share_google:"Google Classroom",
share_remind:"Remind",
lessons_list_npp_long_label_view_only:"View Only",
lessons_list_npp_long_label_unsaved:"Unsaved",
lessons_list_npp_live_session_tooltip:"Hover over this thumbnail to launch a Live lesson! Click \"Preview\" to see the lesson before launching.",
lessons_list_npp_status_removing:"Removing",
lessons_list_npp_status_deleting:"Deleting",
lessons_list_npp_status_saving:"Saving",
lessons_list_npp_preview:"Preview",
lessons_list_npp_action_save_changes:"Save Changes",
lessons_list_npp_action_start_training:"Start Training",
lessons_list_npp_action_student_paced:"Student-Paced",
lessons_list_npp_action_live_lesson:"Live Lesson",
lessons_list_npp_action_view:"View",
npp_grades:"Grades",
npp_free:"Free",
lessons_list_npp_live_session_tooltip_button:"Ok, got it!",
lessons_list_header_action_share:"Share",
lessons_list_header_action_remove:"Remove",
lessons_list_header_action_add_lessons:"Add Lessons",
lessons_list_header_action_rename:"Rename",
lessons_list_more_actions_school_library_label:"School Library",
lessons_list_more_actions_district_library_label:"District Library",
lessons_list_more_actions_public_library_label:"Public Library",
lessons_list_more_actions_folder_label:"Folder",
lessons_list_more_actions_duplicate_label:"Duplicate",
lessons_list_more_actions_add_label:"Add To",
lessons_list_more_actions_add_district_library_label:"Add To District Library",
lessons_list_more_actions_add_school_library_label:"Add To School Library",
lessons_list_more_actions_add_folder_label:"Add To Folder",
lessons_list_more_actions_remove_folder_label:"Remove from Folder",
lessons_list_more_actions_export_pdf_label:"Export PDF",
lessons_list_more_actions_reports_label:"Reports",
lessons_list_more_actions_delete_label:"Delete",
my_library_student_paced_launch_modal_valid_from:"Valid from",
my_library_student_paced_launch_modal_valid_to:"until",
homework_share_code_text:"Join with this CODE at Nearpod.com or in the app",
my_library_launch_session_date_title:"Launched on",
my_library_launch_session_code_title:"CODE",
my_library_launch_session_expire_title:"Expires in",
my_library_launch_session_date_text:"at",
my_library_launch_live_session_new:"Launch new live lesson",
my_library_launch_live_session_resume:"Resume",
my_library_launch_student_paced_new:"Launch new Student-paced lesson",
my_library_launch_student_paced_share:"Share",
my_library_launch_session_title:"This lesson has more than one active session. What would you like to do?",
my_library_launch_session_subtitle:"Or resume any of these active sessions?",
my_library_delete_lesson_message_1:"Are you sure you want to delete this Self-paced?",
my_library_delete_lesson_message_2:"Deleting this lesson will delete all reports, expire all active CODES, and remove it from all folders and your Public Library.",
my_library_delete_lesson_message_3:"Deleting this lesson will delete all reports, expire all active CODES, and remove it from all folders.",
my_library_edit_store_lesson_message:"To keep a copy of the original, duplicate the lesson before editing it.",
my_library_edit_store_lesson_title:"You are about to edit a downloaded lesson.",
my_library_edit_store_lesson_button_2:"Duplicate Lesson",
my_library_edit_store_lesson_button_1:"Edit Lesson",
my_library_export_pdf_message:"Save PDF to",
my_library_export_pdf_local_drive:"Local Drive",
my_library_export_pdf_google_drive:"Google Drive",
my_library_active_session_message:"This lesson has an active session. Do you want to resume it?",
my_library_added_to_private_library_message_part_1:"Your lesson was added to the",
my_library_added_to_private_library_message_part_2:"! Would you like to see your lesson in",
my_library_added_to_private_library_button_1:"View Library",
my_library_added_to_private_library_button_2:"Stay Here",
my_library_remove_folder_message:"Are you sure you want to delete this folder? All lessons will remain in your library.",
my_library_remove_folder_title:"Delete folder",
my_library_remove_from_folder_title:"Remove lesson",
my_library_remove_from_folder_message:"Are you sure you want to remove this lesson from the folder?",
my_library_remove_from_folder_button:"Remove",
my_library_save_confirm_message:"A lesson must have at least 2 slides",
my_library_save_lesson_message:"Please save your changes to this lesson before adding to the",
my_library_school_library:"School Library",
my_library_district_library:"District Library",
my_library_added_to_private_library_message_part_3:"now?",
my_library_add_lesson_public_library_fail:"This lesson is already in your Public Library",
my_library_add_lesson_public_library_success:"Lesson successfully added to your Public Library",
my_library_add_lesson_private_library_success:"Lesson successfully added to your",
my_library_add_lesson_private_library_error:"This lesson is already in the",
my_library_delete_folder_success:"DELETED",
my_library_delete_folder_fail:"FAILED",
preview_right_panel_related_content:"Related Content",
preview_toolbar_save_lesson:"Save Lesson",
school_trial_welcome_title_part1:"Ready to explore  interactive learning experiences your students will love?",
school_trial_welcome_subtitle:"Is your school",
school_trial_welcome_confirm_school_yes:"Yes, this is my school",
school_trial_welcome_confirm_school_no:"No, that's not my school",
school_experiment_email_sent:"Thanks for letting us know. We will reach out shortly.",
school_experiment_school_not_found:"Let us know!",
school_experiment_school_updated:"Thanks! Your school has been added to your profile.",
admin_onboarding_express_gotit_thanks:"Got it, thanks",
my_library_no_lessons_result:"Hi! You have some awesome lessons but none with",
my_library_no_lessons_result_link:"Try searching our store.",
school_trial_onboarding_start_trial_title_before:"Awesome, ",
school_trial_onboarding_start_trial_title_after:"let's add some of your colleagues",
school_trial_onboarding_start_trial_text:"Nearpod ",
school_trial_onboarding_start_trial_text_part2:"is better together!",
school_trial_onboarding_start_trial_btn:"Invite Colleagues",
school_experiment_modal_title:"Nearpod works better together.",
school_experiment_modal_submit:"Submit",
admin_onboarding_confirm_school_success_title_part1:"Oh no!",
admin_onboarding_confirm_school_success_message_part1:"Nearpod",
admin_onboarding_confirm_school_success_textButton:"Invite Colleagues",
admin_onboarding_confirm_school_error_message_part1:"Don't worry.",
admin_onboarding_confirm_school_error_title_part1:"Oh no!",
admin_onboarding_confirm_school_error_subtitle:"We thought you were at another School",
admin_onboarding_confirm_school_error_textButton:"Go back to My Library",
admin_onboarding_express_congrats_title:"You Did It!",
admin_onboarding_express_congrats_subtitle:"Now you can download any of our 7000+ interactive lessons and customize them to your heart's content. ",
admin_onboarding_express_congrats_button_text:"Take me to my School",
admin_onboarding_express_congrats_text_part1:"Notifications",
school_trial_welcome_title_part2:"To get started, we just need to",
admin_onboarding_confirm_school_success_title_part2:"Look like something is not right...",
sort_options_date:"Recently Added",
sort_options_name:"Lesson Title",
sort_options_author:"Author",
sort_options_size:"Size",
admin_onboarding_confirm_school_success_message_part2:"is better together!",
admin_onboarding_confirm_school_error_message_part2:"Our support team is on it. Once fixed. You can pick up where you left off.",
admin_onboarding_confirm_school_error_title_part2:"Look's like something is not right...",
school_experiment_modal_subtitle:"Tell us about your school so we can spread the love.",
admin_onboarding_welcomeSchool_title_part1:"Now,",
admin_onboarding_welcomeSchool_title_part2:" let's learn all about what a Nearpod School Account offers...",
admin_onboarding_welcomeSchool_message:"Here is a quick video to highlight just a few.",
admin_onboarding_welcomeSchool_textButton:"Take a Look",
school_free_trial_modal_subtitle_part1:"You qualify for a",
school_free_trial_modal_title:"Congratulations!",
school_free_trial_modal_subtitle_part3:"School Account",
school_free_trial_modal_subtitle_part2:"FREE",
admin_onboarding_express_invite_title:"Share with your colleagues",
admin_onboarding_express_invite_subtitle:"Select colleagues with Nearpod accounts",
admin_onboarding_express_invite_button:"+ Invite",
admin_onboarding_express_select_colleagues:"Select your colleagues",
admin_onboarding_express_select_colleagues_singular:"colleague selected",
admin_onboarding_express_select_colleagues_plural:"colleagues selected",
admin_onboarding_express_add_colleague:"Add a colleague to your School",
admin_onboarding_express_colleague_invitation:"They will be invited to join Nearpod with access to all 7000+ lessons",
school_free_trial_modal_description_part1:"We are going to walk through all the steps to help get your School on",
school_free_trial_modal_description_part2:"Nearpod",
school_free_trial_modal_button:"Get Started",
school_free_trial_modal_link:"No, thanks.",
audio_not_supported:"Your browser does not support the audio element.",
video_not_supported:"Your browser does not support the video tag.",
admin_onboarding_express_congrats_text_part2:"will appear to guide you to important features throughtout your free trial.",
search_standard_placeholder:"Select a Standard",
btn_copy_text:"Copy",
verify_account_text_part4:"Please login to",
verify_account_text_part5:"and click the link we sent!",
verify_account_text_part6:"Once verified, your account will be all set to use and explore!",
verify_account_text_placeholder:"your email address",
admin_onboarding_invite_teachers_title_part1:"Great! Did you know that",
admin_onboarding_invite_teachers_title_part2:"colleagues at your school are also using Nearpod?",
admin_onboarding_invite_teachers_message_part1:"Nearpod",
admin_onboarding_invite_teachers_message_part2:"is better together!",
admin_onboarding_invite_teachers_textButton:"Share with colleagues",
admin_onboarding_invite_teachers_title2:"Share all 7,000+ lessons with your colleagues.",
admin_onboarding_skip_this_button:"Skip this",
admin_onboarding_user_invited_tag:"(Invited)",
webpage_youCanNow_ios:"You can now:",
webpage_share_ios:"Share this link",
webpage_openSafari_ios:"Open in Safari",
webpage_openBrowser_android:"Open in Browser",
admin_onboarding_express_text:"Some colleagues don't have Nearpod accounts? No problem.",
admin_onboarding_outcome_refer_button:"Refer a Contact",
admin_onboarding_outcome_title_part1:"Want to make this last longer than the 60 day trial period?",
admin_onboarding_outcome_title_part2:"Tell us who to contact to make this stick.",
admin_onboarding_refer_title:"Refer a Contact",
admin_onboarding_refer_subtitle:"We'll reach out to make this permanent",
admin_onboarding_refer_button:"Send to Nearpod",
admin_onboarding_express_congrats_button:"Explore Lessons",
global_form_rolIsRequired:"Role is required",
admin_onboarding_share_lessons_animation_title_part2:"Nearpod Lesson Library...",
school_trial_welcome_title_part3:"confirm your school.",
school_experiment_modal_no_thanks:"No, thanks",
admin_onboarding_invite_colleagues_share:"Share",
lms_confirm_button:"Yes, I understand",
lms_confirm_text_part1:"You are about to permanently link your",
global_poll:"Poll",
admin_onboarding_express_join_your_colleagues:"Join Your Colleagues",
admin_onboarding_express_join:"Join",
admin_onboarding_join_colleagues_animation_title:"Joining your colleagues!",
school_user_onboarding_invite_title:"Join your colleagues",
school_user_onboarding_invite_subtitle:"Join colleagues with Nearpod accounts",
lms_confirm_text_part2:"account to a Nearpod account. Please make sure you sign in to a School or District licensed Nearpod account in order to use this integration.",
poll_submit_confirm_title:"Wait!",
poll_submit_confirm_text:"Do you want to submit this answer?",
poll_submit_confirm_empty_actionone_text:"Review Answers",
poll_submit_confirm_actiontwo_text:"Yes, Submit",
poll_submit_confirmed_title:"Got it!",
poll_submit_confirmed_text:"Your answer has been submitted.",
poll_submit_confirmed_actionone_text:"Edit Answer",
poll_submit_confirmed_empty_actiontwo_text:"Submit Anyway",
poll_submit_confirm_empty_text:"You didn\u2019t answer the poll.",
student_slide_selector_multianswer_text:"Select one or more answers",
student_slide_selector_oneanswer_text:"Select an answer",
admin_onboarding_invite_teachers_title_part2_singular:"colleague at your school is also using Nearpod?",
admin_onboarding_refer_animation_title:"Sending contact to Nearpod...",
school_user_onboarding_invite_teachers_title2:"Join the entire collection of interactive learning experiences!",
school_user_onboarding_invite_teachers_textButton:"View your Colleagues",
cacophony_video_paused:"This video is paused on this device.",
cacophony_audio_paused:"This audio is paused on this device.",
student_slide_selector_selected_text:"answer(s) selected",
code_list_remaining:"remaining",
code_list_tooltip:"Click to adjust the expiration date of this CODE",
my_library_launch_student_paced_subtitle:"Or share any of these active sessions",
main_header_dropdown_nearpodLessonLibrary:"Nearpod Lesson Library",
binders_message_durationExceeded:"Sub Plans can only be sent within 365 days of absence",
global_quiz:"Quiz",
aox_form_user_in_another_school:"This teacher is already part of another school.",
quiz_questions:"questions",
quiz_question_number_text:"Question",
unlock_lessons_modal_title1:"Unlock Sample Lessons",
unlock_lessons_modal_title2:"Sample Lessons",
unlock_lessons_modal_message_part1:"This supplemental curriculum package is available to be purchased by schools and districts, but you can access sample lessons for",
unlock_lessons_modal_message_part2:" FREE!",
unlock_lessons_modal_button_text:"Unlock Sample Lessons",
unlock_lessons_modal_textLink:"Learn More",
quiz_submit_confirm_empty_question_text:"Some questions are unanswered.",
quiz_submit_confirm_empty_actionone_text:"Review answers",
quiz_submit_confirm_empty_actiontwo_text:"Submit anyway",
poll_timeFor_title:"a Poll",
quiz_intro_title:"Quiz",
quiz_intro_question:"Question",
global_next:"Next",
my_library_no_lessons_result_link_2:"Try searching the Nearpod Lesson Library.",
qa_submit_confirm_empty_actionone_text:"Review Answer",
qa_submit_confirm_empty_question_text:"The question is unanswered.",
oeq_intro_title:"Open-Ended Question",
oeq_answerPlaceholder:"Ready? Enter your answer here.",
btn_copy_text_copied:"Copied!",
pdf_title_ios:"Reference Media - PDF",
quiz_submit_confirmed_title:"Got it!",
quiz_submit_confirmed_text:"Your answer has been submitted.",
quiz_submit_confirmed_actionone_text:"Edit Answer",
login_sso_error_confirm_button:"Ok, Got it!",
login_sso_error_message_lti:"This account does not have the correct license. Please login in using a School or District licensed Nearpod account.",
sign_up_title:"Transforming Teaching. Together.",
sign_up_subtitle:"Ready-to-run K-12 lessons delivered through an award-winning interactive learning platform",
sign_up_find_or_create_title:"Find or create lessons",
sign_up_find_or_create_subtitle:"Our curated library has some of the best ready-to-teach lessons available",
sign_up_interact_students_title:"Interact with your students",
sign_up_interact_students_subtitle:"Select from our rich set of activities to interact with your students on any device",
sign_up_students_reports_title:"Get student insights",
sign_up_students_reports_subtitle:"See immediate responses in the classroom and assessment reports delivered to you",
sign_up_teachers_title:"Teachers",
sign_up_teachers_subtitle_1:"Sign Up for",
sign_up_students_title:"Students",
sign_up_teachers_subtitle_2:"FREE",
code_placeholder:"Enter CODE",
sign_up_sign_in:"Sign In",
lti_display_title:"Nearpod Selected! Next Steps:",
lti_display_subtitle:"The existing Nearpod < > Schoology integration does not support auto-inserting content. In order to access this lesson, please follow these 5 steps:",
lti_display_step_1:"Copy the link listed below",
lti_display_step_2:"Return to your Materials page",
lti_display_step_3:"Select the gear next to the selected lesson, and then select \"edit\" in the dropdown",
lti_display_step_4:"Paste the copied link into the \"URL\" field",
lti_display_step_5:"Select \"Save Changes\"",
binders_message_priorToToday:"Sub Plans can\u2019t be sent prior to today",
my_library_no_lessons_lti_confirm:"Hi! It looks like you don\u2019t have any lessons yet. Visit the Explore section of Nearpod on the full site or app to download some awesome lessons!",
video_error_ios:"Error trying to load the video. Please try again.",
signUp_signUpWithEmail_2:"Sign Up with Email",
signUp_signUpWithGoogle_2:"Sign Up with Google",
signUp_signUpWithOffice_2:"Sign Up with Office 365",
activity_timer_hangOn:"Hang on for the next activity.",
oeq_submit_empty_answer_confirm_text:"You didn't answer the question.",
oeq_submit_empty_answer_actionone_text:"Review Answer",
oeq_submit_empty_answer_actiontwo_text:"Submit Anyway",
oeq_timer_stand_by_activity_name:"a Question!",
matchingPairs_timer_timeIsUp:"Time's Up!",
matchingPairs_timeForMatchingPairs:"Time for",
matchingPairs_youWillHave:"You will have",
matchingPairs_toFinishThisActivity:"to finish this activity. Wait for your teacher to begin!",
matchingPairs_timer_min:"min",
matchingPairs_timer_sec:"sec",
matchingPairs_timeForMatchingPairs2:"Matching Pairs!",
my_library_name_folder_modal_placeholder_2:"Folder Name",
oeq_submit_wait_title:"Wait!",
oeq_submit_confirmed_title:"Got it!",
oeq_submit_confirmed_text:"Your answer has been submitted.",
oeq_submit_confirmed_actionOne_text:"Edit Answer",
studentJoin_dontHaveAPin_2:"Don't have a CODE? Use MAGIC",
my_account_form_change_password_placeholder:"Enter password",
my_account_confirm_password_title:"Verify your account",
my_account_confirm_password_subtitle:"Enter your password to continue",
my_account_confirm_password_input_title:"Current Password",
my_account_confirm_password_button:"Continue",
global_loading:"Loading",
binders_message_durationExceeded_1:"Sub Plans can only be sent within 365 days of the absence",
endImpersonate:"End Impersonation",
my_account_form_change_password_subtitle:"Change Password",
login_signup_error_message_lti:"This Nearpod account does not exist. Please sign in using a school or district licensed Nearpod account.",
true_false_intro_title:"True\/False",
admin_onboarding_nostoredownloads_text:"weeks left in your School Free Trial",
admin_onboarding_nostoredownloads_title:"Did you know that the School Free Trial gives you access to over",
admin_onboarding_nostoredownloads_strong_title:"7,000 premium ready-to-teach, customizable lessons?",
admin_onboarding_nostoredownloads_primary_text_button:"Explore Lessons",
admin_onboarding_nostoredownloads_secondary_text_button:"Go to My Library",
admin_private_library_npp_hoverLayer_move:"Drag to Move",
quiz_intro_questions:"Questions",
admin_private_library_entityMoved:"was moved to",
desmos_title_SlopeInterceptForm:"Slope Intercept Form",
desmos_title_PointSlopeForm:"Point Slope Form",
desmos_title_TwoPointFormOfALine:"Two Point Form of a Line",
desmos_title_InterceptForm:"Intercept Form",
desmos_title_GeneralForm:"General Form",
desmos_title_VisualizingSlope:"Visualizing Slope",
desmos_title_StandardForm:"Standard Form",
desmos_title_VertexForm:"Vertex Form",
desmos_title_FactoredForm:"Factored Form",
desmos_title_StandardFormWithTangent:"Standard Form with Tangent",
desmos_title_PeriodAndAmplitude:"Period & Amplitude",
desmos_title_Phase:"Phase",
desmos_title_AllTheTrigFunctions:"All the Trig Functions",
desmos_title_UnitCircle:"Unit Circle",
admin_onboarding_add_teachers_title:"We hope you're enjoying the School Free Trial!",
admin_onboarding_add_teachers_subtitle:"Did you know that 4 colleagues at your school are already on Nearpod?",
admin_onboarding_add_teachers_primary_button_text:"Share with colleagues",
admin_onboarding_add_teachers_secondary_button_text:"Go to My Library",
admin_onboarding_add_teachers_message_part1:"Nearpod",
admin_onboarding_add_teachers_message_part2:"is better together!",
onboarding_overlay_lesson_create_title:"Learn how to use Nearpod like a pro",
onboarding_overlay_lesson_create_body:"Learn how to create engaging, interactive lessons from scratch or from existing slides you already have.",
desmos_validation_completed_succesfully:"Saving graph...",
admin_onboarding_add_teachers_subtitle_part1:"Did you know that",
admin_onboarding_add_teachers_subtitle_part2:"colleagues at your school are also using Nearpod?",
school_library_onboarding_overlay_title:"Create a central hub of shared resources with School Library!",
school_library_onboarding_overlay_body:"School library allows educators to collaborate more effectively and share best practices and resources.",
district_library_onboarding_overlay_body:"District library allows educators to collaborate more effectively and share best practices and resources.",
district_library_onboarding_overlay_title:"Create a central hub of shared resources with District Library!",
timer_save_error:"There was a problem saving the Timer",
school_library_onboarding_overlay_video:"https:\/\/www.youtube.com\/embed\/ZAzDQTHdCY4?autoplay=1",
school_library_onboarding_overlay_admin_video:"https:\/\/www.youtube.com\/embed\/kiAf2fLnzLE?autoplay=1",
district_library_onboarding_overlay_admin_video:"https:\/\/www.youtube.com\/embed\/lmIP0Jbn4G8?autoplay=1",
district_library_onboarding_overlay_video:"https:\/\/www.youtube.com\/embed\/ojYAkzo8xXE?autoplay=1",
onboarding_overlay_lesson_create_action_button:"Create a Nearpod Lesson Now",
onboarding_overlay_lesson_create_action_dismiss:"Dismiss",
admin_onboarding_nodminformation_primary_text_button:"Refer a Contact",
admin_onboarding_nodminformation_secondary_text_button:"Go to My Library",
admin_onboarding_nodminformation_title:"We hope you\u2019re enjoying the School Free Trial!",
admin_onboarding_nodminformation_strong_title:"Tell us who to contact to make it stick.",
admin_onboarding_nodminformation_text:"weeks left in your School Free Trial",
onboarding_overlay_lesson_create_video:"https:\/\/www.youtube-nocookie.com\/embed\/y8xNQbggas0?rel=0&showinfo=0",
dm_storage_experiment_title:"Want access to all our premium content? We thought so!",
dm_storage_experiment_strong_title:"Tell us who to contact at your school to make this happen. In the meantime we\u2019ll double your storage. Nice, right?",
dm_storage_experiment_primary_text_button:"Double Storage",
dm_storage_experiment_secondary_text_button:"Go to My Library",
try_it_free:"Try it FREE for 30 days",
action_button_nothanks:"Not now, thanks",
spaced_overlay_title:"Student-paced mode gives you superpowers",
spaced_overlay_body:"Support differentiated group work, flip your classroom, or assign dynamic homework assignments with student-paced mode.",
free_trial_activated:"Enjoy your 30 days of FREE Student-paced mode!",
already_on_free_trial:"You are already part of the FREE trial.",
dm_storage_experiment_double_storage_button:"Double Storage",
Desmos_Category_Linear:"Linear",
Desmos_Category_Inequalities:"Inequalities",
Desmos_Category_Quadratics:"Quadratics",
Desmos_Category_Trigonometry:"Trigonometry",
Desmos_Category_Transformations:"Transformations",
Desmos_Category_ConicSections:"Conic Sections",
Desmos_Category_PolarAndParametric:"Polar and Parametric",
Desmos_Category_Calculus:"Calculus",
Desmos_Category_ProbabilityAndStatistics:"Probability and Statistics",
Desmos_Category_Modeling:"Modeling",
desmos_title_Circle:"Circle",
desmos_title_ParabolaAndFocus:"Parabola and Focus",
desmos_title_EllipseWithFoci:"Ellipse with Foci",
desmos_title_Hyperbola:"Hyperbola",
desmos_title_PolarRose:"Polar Rose",
desmos_title_LogarithmicSpiral:"Logarithmic Spiral",
desmos_title_Limacon:"Limacon",
desmos_title_PolarConicSections:"Polar Conic Sections",
desmos_title_TranslatingAnyFunction:"Translating any Function",
desmos_title_ScalingAnyFunction:"Scaling Any Function",
desmos_title_ReflectionsOfAFunction:"Reflections of a Function",
desmos_title_InverseOfAFunction:"Inverse of a Function",
desmos_title_Derivatives:"Derivatives",
desmos_title_SecantLine:"Secant Line",
desmos_title_TangentLine:"Tangent Line",
desmos_title_TaylorExpansionOfSinX:"Taylor Expansion of sin(x)",
desmos_title_DerivativeGame:"Derivative Game",
desmos_title_MatchAQuadraticFunction:"Match a Quadratic Function",
desmos_title_MatchALinearFunction:"Match a Linear Function",
desmos_title_MatchATrigonometricFunction:"Match a Trigonometric Function",
desmos_title_GraphingFunctionsUsingTables:"Graphing Functions Using Tables",
desmos_title_InequalitiesBasic:"Inequalities: Basic",
desmos_title_InequalitiesIntermediate:"Inequalities: Intermediate",
desmos_title_InequalitiesAdvanced:"Inequalities: Advanced",
desmos_title_ArcLengthByIntegration:"Arc Length by Integration",
desmos_title_CanyonJump:"Canyon Jump",
desmos_title_WillItHitTheHoop1:"Will It Hit the Hoop 1",
desmos_title_WaterBottleFlippingModel:"Water Bottle Flipping Model",
desmos_title_CircleOverlapFraction:"Circle Overlap Fraction",
desmos_title_MinMaxUnionIntersection:"Min Max Union Intersection",
desmos_title_TracingAPointOnAPolarCurve:"Tracing a Point on a Polar Curve",
desmos_title_FourCirclesThroughFourPoints:"Four Circles Through Four Points",
desmos_title_OrientedAreaIndependentOfBasePoint:"Oriented Area Independent of Base Point",
desmos_title_FundamentalTheoremOfCalculus:"Fundamental Theorem of Calculus",
desmos_title_IntegralWithAdjustableBounds:"Integral With Adjustable Bounds",
desmos_title_IntegralMeanValueTheorem:"Integral Mean Value Theorem",
desmos_title_MeanValueTheorem:"Mean Value Theorem",
desmos_title_CornuSpiral:"Cornu Spiral",
desmos_title_DifferentIntegrationBounds:"Different Integration Bounds",
desmos_title_IntegrationByParts:"Integration By Parts",
desmos_title_CosmicMicrowaveBackgroundDataset:"Cosmic Microwave Background Dataset",
desmos_title_MonteCarloPi:"Monte Carlo Pi",
desmos_title_ConicSectionWaves:"Conic Section Waves",
desmos_title_CircleWave:"Circle Wave",
desmos_title_FamilyOfRectanglesThroughTwoPoints:"Family of Rectangles Through Two Points",
desmos_title_BezierCurveAsEnvelope:"Bezier Curve As Envelope",
desmos_title_ImplicitVennDiagram:"Implicit Venn Diagram",
desmos_title_StationaryGradientCurves:"Stationary Gradient Curves",
desmos_title_CircleTangentToThreeCircles:"Circle Tangent to Three Circles",
desmos_title_DoublingTimeOfCompoundInterest:"Doubling Time of Compound Interest",
desmos_title_RegionsDefinedByFourHalfPlanes:"Regions Defined By Four Half Planes",
desmos_title_CardioidEnvelope:"Cardioid Envelope",
desmos_title_LambertWFunction:"Lambert W Function",
desmos_title_NormalFamily:"Normal Family",
desmos_title_HoopAttachedTo10Springs:"Hoop Attached To 10 Springs",
desmos_title_4ThOrderPolynomialThroughAny5Points:"4th Order Polynomial Through Any 5 Points",
desmos_title_Cycloid:"Cycloid",
desmos_title_ApollonianCircles:"Apollonian Circles",
desmos_title_PotentialOutsideALineCharge:"Potential Outside A Line Charge",
desmos_title_TrigUnitCircle:"Trig Unit Circle",
desmos_title_Beats:"Beats",
desmos_title_BisectingATangent:"Bisecting A Tangent",
desmos_title_GeneralLineIntersection:"General Line Intersection",
desmos_title_WrappedRadian:"Wrapped Radian",
desmos_title_ProjectileMotion:"Projectile Motion",
desmos_title_GeometricDistribution:"Geometric Distribution",
desmos_title_BinomialDistribution:"Binomial Distribution",
desmos_title_NormalDistribution:"Normal Distribution",
desmos_title_ParabolaMultiplication:"Parabola Multiplication",
desmos_title_ExtremaWithRegressions:"Extrema with Regressions",
desmos_title_RotatingCylinder:"Rotating Cylinder",
desmos_title_BouncingStereographicProjection:"Bouncing Stereographic Projection",
desmos_title_RotatingBezierControlPoints:"Rotating Bezier Control Points",
desmos_title_HypocycloidJuggling:"Hypocycloid Juggling",
desmos_title_NegativePedalCurve:"(Negative) Pedal Curve",
desmos_title_SphereShearing:"Sphere Shearing",
desmos_title_KernelDensityMetaballs:"Kernel Density Metaballs",
desmos_title_KernelDensityEstimation:"Kernel Density Estimation",
desmos_title_NielsensSpiral:"Nielsen's Spiral",
desmos_title_Regressions:"Regressions",
desmos_title_HistogramAndBoxAndWhiskerPlot:"Histogram and Box & Whisker Plot",
desmos_title_HistogramAndSummaryData:"Histogram & Summary Data",
desmos_title_BoxAndWhiskerPlotAndSummaryData:"Box & Whisker Plot and Summary Data",
desmos_title_MagnifyingGlassQuadratic:"Magnifying Glass: Quadratic",
desmos_title_MagnifyingGlassLinear:"Magnifying Glass: Linear",
desmos_title_MagifyingGlassCubic:"Magifying Glass: Cubic",
desmos_title_MagifyingGlassTrigonometric:"Magifying Glass: Trigonometric",
desmos_title_PythagorianTheoremProof:"Pythagorian Theorem Proof",
desmos_title_3DGraphUsingParametricLines:"3D Graph Using Parametric Lines",
desmos_title_StatisticsAnscombsQuartet:"Statistics: Anscomb's Quartet",
desmos_title_SincInterpolation:"Sinc Interpolation",
desmos_title_ReflectionOfAPointAcrossALine:"Reflection of a Point Across a Line",
desmos_title_DataWithErrorBars:"Data with Error Bars",
desmos_title_ParametricIntermediate:"Parametric: Intermediate",
desmos_title_ParametricBasic:"Parametric: Basic",
desmos_title_RestrictionsBasic:"Restrictions: Basic",
desmos_title_RestrictionsIntermediate:"Restrictions: Intermediate",
desmos_title_SlidingRestrictionsBoxSine:"Sliding Restrictions Box: Sine",
desmos_title_Harmonics:"Harmonics",
desmos_title_SierpinskiValentine:"Sierpinski Valentine",
desmos_title_Fireworks:"Fireworks!",
desmos_title_RegressionsBasics:"Regressions: Basics",
desmos_title_RegressionsIntermediate:"Regressions: Intermediate",
desmos_title_3DWorldGraph:"3d world graph",
desmos_title_FastestPathToAPoint:"Fastest Path to a Point",
desmos_title_PolygonTransformations:"Polygon Transformations",
desmos_title_PacMan:"Pac Man",
desmos_title_SummationIntermediate:"Summation: Intermediate",
desmos_title_SummationAdvanced:"Summation: Advanced",
desmos_title_TaylorAndBinomialSeries:"Taylor and Binomial Series",
desmos_title_RiemannSums:"Riemann Sums",
oeq_will_save_after_uploading:"Open Ended Question will save after files are done uploading...",
desmos_tooltip_edit_init:"Get access to over 100 Desmos charts with a Nearpod School or District Account. ",
desmos_tooltip_edit_link:"Contact us",
desmos_tooltip_edit_end:" for more information.",
school_library_overlay_title:"Share the magic! Add your lesson to your School Library",
school_library_overlay_body:"Add this lesson to your School Library so your colleagues can download or customize it for their classes!",
learn_more:"Learn More",
learn_more_url:"https:\/\/nearpod.com\/nearpod-school-library",
add_it_now:"Quickly Add!",
subs_overlay_title:"Flu season is here!",
subs_overlay_body:"Would you like to plan for absences that keep your students on their academic path?",
subs_GoToDashboard:"Go To Dashboard",
oeq_error_completeFields:"Please complete the required fields below.",
oeq_error_emptyQuestion:"Please include text for this question.",
oeq_question_placeholder:"Enter your question here",
add_lesson_sl:"Lesson successfully added to School Library",
login_notification_downgrade_platinum_to_gold_title:"You have been downgraded to the Gold Edition",
login_notification_downgrade_platinum_to_gold_message:"This means you'll have reduced storage space and will not longer have access to unlimited content from the Nearpod store and Student Notes.",
login_notification_downgrade_platinum_to_gold_buton:"Got it",
ayce_downgrade_title:"Changes in your account",
ayce_downgrade_message:"Your account has been downgraded to Silver Edition. As a result, some of your Nearpod lessons may have been disabled from your account and you will no longer have unlimited access to lessons previously available through the Nearpod Unlimited program.",
ayce_downgrade_button:"Got it",
feature_downgrade_title:"Changes to your account",
feature_downgrade_message:"You are now on the free Silver Edition. As a result, some of your lessons, reports and premium features may have been disabled from your account. Please contact us if you would like to restore your account at support@nearpod.com.",
feature_downgrade_button:"Got it!",
redeem_code_fail_title:"Unable to Redeem Gold Code",
redeem_user_used_once:"You have already participated with a code before.",
redeem_user_used_button:"Got it!",
school_trial_onboarding_modal_title:"Get an all-access pass to our library of 7,000+ ready-to-teach, customizable lessons",
school_trial_onboarding_admin_video:"https:\/\/www.youtube.com\/embed\/35A15FlEnUk?autoplay=1&mute=1",
school_trial_onboarding_modal_body:"Plus access to all our activities, unlimited student participation, and student-paced mode with your 60-day FREE School Account.",
paywalls_loginNotification1_title:"Try the Gold Edition for Free!",
paywalls_loginNotification1_text:"Try a FREE 30-day trial so your students can experience the full power of Nearpod. (Don't worry, no credit card required!)",
paywalls_loginNotification1_button:"Try Gold!",
school_user_onboarding_admin_video:"https:\/\/www.youtube.com\/embed\/35A15FlEnUk?autoplay=1&mute=1",
school_user_onboarding_modal_title:"You\u00b4ve been invited to an all-access pass to our library of 7,000+ ready-to-teach, customizable lessons",
school_user_onboarding_modal_body:"Plus access to all our activities, unlimited student participation, and student-paced mode with your 60-day FREE School Account.",
admin_onboarding_premium_activities_intro_title_part1:"We hope you\u2019re loving the School Free Trial!",
admin_onboarding_premium_activities_intro_title_part2:"Did you know that you have access to ",
admin_onboarding_premium_activities_intro_title_part3:"premium features ",
admin_onboarding_premium_activities_intro_title_part4:"like",
admin_onboarding_premium_activities_primary_text_button_loading:"Downloading",
admin_onboarding_premium_activities_primary_text_button_library:"Show in My Library",
admin_onboarding_premium_activities_primary_text_button:"Add to My Library",
admin_onboarding_premium_activities_secondary_text_button:"Go to My Library",
paywalls_loginNotification_successMessage:"Congrats! Your free Gold trial has been unlocked!",
admin_onboarding_premium_activities_add_lesson_title_part1:"Add this warm-up lesson to your library ",
admin_onboarding_premium_activities_add_lesson_title_part2:"to learn how to level up your",
admin_onboarding_premium_activities_add_lesson_title_part3:"classroom with Matching Pairs and Virtual Reality Tours.",
admin_onboarding_premium_activities_add_lesson_title_success_part1:"Great, we added the lesson to your library.",
admin_onboarding_premium_activities_add_lesson_title_success_part2:"Enjoy!",
dm_storage_experiment_space_doubled:"Congrats! Your storage has been DOUBLED!",
admin_onboarding_premium_activities_success_message:"You have successfully downloaded an Free Trial Sample Lesson!",
login_notification_extended_features_expired_title:"Oh no, your Free Gold Trial has ended!",
login_notification_extended_features_expired:"But the fun doesn\u2019t have to end here...",
action_button_upgrade_now:"Upgrade now!",
login_notification_extended_features_reminder_days_title:"Hey, there's {_daysLeft_} in your Trial!",
login_notification_extended_features_reminder_days:"Your trial is expiring soon! Upgrade to keep unlimited access to the most engaging Nearpod features.",
action_button_remindlater:"Remind me later",
oeq_cancelConfirm:"Are you sure you want to cancel? You will lose your changes.",
thanks:"Thanks!",
login_notification_school_join_message:"Congratulations! As a Nearpod School user, you can now enjoy access to premium and advanced features such as student-paced presentations, school private libraries, and student note taking.",
login_notification_school_join_title:"You've been added to {_SchoolName_}!",
Desmos_Category_StaffPicks:"Staff Picks",
test_localize_vars_one:"Test with {_number_} of vars",
test_localize_vars_multiple:"Test with {_number_} of vars, the first one is {_another_} and the other is the {_firstnumber_}",
importUser_popin_message_changeUserSchool:"Your Nearpod School administrator has upgraded you to the {_SchoolName_} {_ProductName_} Edition.\\n\\nBy joining the School Edition, you gain access to premium features such as school libraries and student note taking \u2013 all paid for by your school! \\n\\nWould you like to join the {_ProductName_} Edition?",
importUser_popin_message_changeUserSchool_gold:"Your Nearpod School administrator has upgraded you to the {_SchoolName_} {_ProductName_} Edition.\\n\\nBy joining the School Edition, you gain access to premium features such as school libraries and student note taking \u2013 all paid for by your school! \\n\\nWould you like to join the {_ProductName_} Edition?",
importUser_popin_message_changeUserSchool_goldPlus:"Your Nearpod School administrator has upgraded you to the {_SchoolName_} {_ProductName_} Edition.\\n\\nBy joining the School Edition, you gain access to premium features such as school libraries and student note taking \u2013 all paid for by your school! \\n\\nWould you like to join the {_ProductName_} Edition?",
importUser_popin_message_changeUserSchoolWithAyce:"You have been invited to join the {_SchoolName_} {_ProductName_} Edition by request of your Nearpod school administrator. \\n\\nYou are currently a member of another Nearpod school with {_ayceNames_} content {_subscriptionLabel_}. By accepting this invitation, you understand that you may be changing content subscriptions and therefore may lose access to some of your downloaded lessons. \\n\\nIf you wish to join this school, please click Join! \\n\\nIf you wish to remain in your current school, please close this box.",
action_button_gotit_cancel:"Got it!",
bulk_notAvailable_slots:"Your school administrator invited you to join Nearpod, but all spots have been filled. Please contact your admin for further information.",
Desmos:"Desmos",
subscription:"subscription",
subscriptions:"subscriptions",
test_localize_vars_multiple_equals:"Test with {_number_} of equal vars, the first one is {_number_} and the other is the {_number_}",
test_unescape_localize:"Im\\ntesting\\nthe\\nunescaping\\nof\\nlinebreak",
desmos_filter:"Filter :",
my_library_top_bar_search_placeholder:"Search lessons in your library",
sa_collaborate_coach_message:"Share text and images in real-time with your students. Anytime, lesson not required",
sa_collaborate_coach_footer:"Stay tuned, soon you'll be able to launch more activities.",
sa_collaborate_coach_button:"Ok, got it!",
share_invalid_email:"The email address is invalid",
sa_collaborate_coach_title:"LAUNCH",
sa_collaborate_coach_sub_title:"Collaborate!",
toolbar_upgrade:"Upgrade",
my_library_top_bar_collaborate_tooltip:"Launch Collaborate!",
signUp_clever_title:"Teacher Sign Up with Clever",
school_trial_admin_text_notification:"Get an all-access pass to our library of 7000+ ready-to-teach, customizable lessons",
school_trial_admin_button_text_notification:"Get Started",
school_trial_admin_link_text_notification:"Watch the video",
user_profile_save_success:"Profile information saved.",
lessons_list_header_action_add_folder:"Add Folder",
grades_subjects_modal_submit:"Submit",
grades_subjects_modal_no_thanks:"No, thanks",
grades_subjects_modal_subjects_placeholder:"Select Subjects",
grades_subjects_modal_subjects_label:"Subjects",
grades_subjects_modal_grades_placeholder:"Select Grades",
grades_subjects_modal_grades_label:"Grades",
grades_subjects_modal_subtitle:"We've got that, just give us your grade and subjects.",
grades_subjects_modal_title:"Want lessons you will love?",
edit_lesson_in_publiclibrary_confirm:"OK",
edit_lesson_in_publiclibrary_cancel:"Cancel",
edit_lesson_in_publiclibrary_title:"Edit Public Library Lesson",
edit_lesson_in_publiclibrary_description:"This lesson is currently on your PUBLIC LIBRARY.\\nBy editing, this lesson will be REMOVED.",
search_box_placeholder_text:"Search for lessons in our store",
search_box_placeholder_text_b2b:"Search for lessons in the Nearpod Lesson Library",
first_lesson_overlay_title:"Got lessons?",
first_lesson_overlay_subtitle:"Import one now.",
first_lesson_overlay_secondary_text_button:"No thanks, not now",
country_title:"Billing Information",
country_subtitle:"Please provide the following information:",
country_united_states:"United States",
country_other:"Other",
country_placeholder:"Country",
first_lesson_overlay_upload_success:"Alright, your first lesson is officially on Nearpod! Launch it now or explore our interactive activities.",
country_address:"Address",
country_apartment:"Apartment, suite, etc. (optional)",
country_state:"State (2 letter code)",
country_zipcode:"Zip Code",
country_city:"City",
themes_menu_title:"Themes",
user_permissions_modal_title:"User Permissions",
toggle_label_on:"ON",
toggle_label_off:"OFF",
global_form_invalidZipCode:"Please enter a valid zip code.",
onboarding_overlay_lesson_create_video_2:"https:\/\/www.youtube.com\/embed\/vvznAXPIXzY?rel=0&showinfo=0",
my_library_folder_updated_success:"The folder {_folderName_} has been saved",
first_lesson_overlay_loading_title1:"Ready to experience the magic of Nearpod?",
first_lesson_overlay_loading_subtitle1:"Hover and select Live Lesson.",
first_lesson_overlay_loading_title2:"To share the love,",
first_lesson_overlay_loading_subtitle2:"share the code.",
first_lesson_overlay_loading_title3:"You control the pace. They join from any device.",
first_lesson_overlay_loading_subtitle3:"Ready?",
time_to_climb_title_part1:"Bam! You now have access to",
time_to_climb_title_part2
:"Nearpod\u2019s",
time_to_climb_title_part3:"NEW",
time_to_climb_title_part4:"gamified activity, Time to Climb.",
time_to_climb_text_part1:"Check out our mini-series of ready-to-run",
time_to_climb_text_part2
:"Time to Climb activities!",
time_to_climb_primaryButton:"Explore",
time_to_climb_secondaryButton:"No, thanks",
mylibrary_dnd_npp_text:"Drag",
permission_view_license_details:"License Details",
permission_manage_users:"Manage Users",
permission_manage_schools:"Manage Schools",
permission_manage_school_library:"Manage School Library",
permission_manage_district_library:"Manage District Library",
permission_push_lessons:"Push Lessons",
permission_usage_graphs_school:"School Usage Graphs",
permission_usage_statistics_school:"School Usage Statistics",
permission_post_session_reports:"Post-Session Reports",
oeq_student_recording_audio_enable:"Enable Student Audio Recordings",
activityChallenge_header_title:"Nearpod Activity Challenge",
activityChallenge_header_subtitle:"Get student-paced lessons for the rest of 2018-2019 academic year!",
activityChallenge_header_text:"Just teach one lesson a week for the next four weeks. Are you in?",
activityChallenge_asset_text:"Student-Paced",
activityChallenge_button:"Accept Challenge",
activityChallenge_link
:"Not now, thanks",
student_recording_box_info_tooltip_text:"You can now enable audio recording for your students! Your students can record audio and play it back for them to listen and learn.",
streaks_challenge_title:"4 Week Activity Challenge - Week {_value_}",
streaks_challenge_description_week_1:"1 week down, 3 to go. Keep it up, launch your next lesson!",
user_permissions_modal_view:"View Only",
user_permissions_modal_edit:"Full",
streaks_challenge_description_week_2:"It\u2019s getting hot in here. 2 weeks down, 2 to go. Keep it up!",
streaks_challenge_description_week_3:"1 week to student-paced for the rest of the academic year!",
global_audio_recorder:"Audio Recorder",
streaks_challenge_description_empty:"Get student-paced for free. Launch a lesson with your class now!",
streaks_challenge_title_lose:"Aw, snap!",
streaks_challenge_title_win:"Challenge Completed",
streaks_challenge_description_lose:"Keep your eyes open for more fun challenges to level up your Nearpod.",
streaks_challenge_description_win:"You did it! Enjoy student-paced for the rest of the academic year.",
user_permissions_modal_description:"Enable users to perform certain actions typically reserved for admins",
oeq_student_recording_audio_recorder_incompatible:"Recording is not available in your device",
oeq_student_recording_audio_recorder_compatible
:"Record Audio",
oeq_student_recording_audio_recorder_no_permissions_1:"Audio responses had been enabled for this activity.",
oeq_student_recording_audio_recorder_no_permissions_2:"Grant audio recording permission for Nearpod",
oeq_student_recording_audio_recorder_no_permissions_3:" to use this feature.",
my_library_folder_updated_success_2:"The folder \"{_folderName_}\" has been saved",
my_library_delete_folder_success_2:"The folder \"{_folderName_}\" has been deleted",
my_library_folder_updated_failed:"",
drag_and_drop_title_part1:"Mic drop!",
drag_and_drop_title_part2:"We made organizing your lessons easy with drag and drop, and",
drag_and_drop_title_part3:"support for subfolders in My Library",
drag_and_drop_primaryButton:"Continue",
matching_pairs_homework_student_confirm:"Continue",
permission_usage_graphs_district:"District Usage Graphs",
permission_usage_statistics_district:"District Usage Statistics",
user_permissions_modal_none:"None",
streaks_challenge_completed_title:"4 Week Challenge Completed",
streaks_challenge_completed_subtitle
:"Great job teaching on Nearpod every week!",
streaks_challenge_completed_text1:"To express our utmost gratitude for accepting this Nearpod challenge, we are giving you a very shiny trophy and student-paced lessons for the rest of 2018-2019 academic year. Nice, right?",
streaks_challenge_completed_text2:"Stay tuned for more challenges, you never know what\u2019s coming!",
streaks_challenge_completed_share:"Share On",
streaks_challenge_completed_share_description:"Wow! I earned access to student paced nearpod lessons because of my #NearpodStreak",
streaks_challenge_completed_share_pinterest:"Wow! I earned access to student paced nearpod lessons because of my NearpodStreak",
school_experiment_modal_not_us:"Not in the United States",
oeq_delete_audio_confirm_title:"Wait!",
oeq_delete_audio_confirm_text:"Are you sure you want to delete the audio response?",
googleSlides_learnMore:"Learn how to use our add-on",
googleSlides_listHeader:"Select one to add a slide",
googleSlides_editBtn:"Edit This Slide",
googleSlides_saveBtn:"Save & Go To Nearpod",
googleSlides_userInfo:"Logged in as ",
global_slides_audio:"Audio",
global_slides_bbc:"BBC Video",
global_slides_collaborate:"Collaborate!",
global_slides_drawIt:"Draw It",
global_slides_fieldTrip:"Field Trip",
global_slides_fitb:"Fill in the Blanks",
global_slides_desmos:"Graphing Calculator",
global_slides_twitter:"Live Twitter Stream",
global_slides_memoryTest:"Memory Test",
global_slides_nearpod3d:"Nearpod 3D",
global_slides_pdfViewer:"PDF Viewer",
global_slides_phet:"Simulation",
global_slides_slide:"Slide",
global_slides_slideshow:"Slideshow",
global_slides_sway:"Sway",
global_slides_matchingPairs:"Matching Pairs",
global_slides_oeq:"Open Ended Question",
global_slides_poll:"Poll",
global_slides_quiz:"Quiz",
global_slides_timeToClimb:"Time to Climb",
global_slides_video:"Video",
global_slides_webContent:"Web Content",
my_library_no_content_p1:"You have no lessons in your Library. Please visit",
my_library_no_content_p2:"to find or create some lessons to teach",
my_library_no_content_link:"nearpod.com",
googleSlides_videoIconAlt:"Play Video Icon",
create_lesson:"Create Lesson",
lessons_list_npp_action_edit_google_slides:"Edit in Google Slides",
library_overlay_title:"Welcome to Your Lesson Library!",
library_overlay_body:"You'll find all the lessons you save from the Nearpod store or create on your own here!",
action_button_go_my_library:"View My Library",
googleSlides_filter_text_allFeatures:"All Features",
googleSlides_filter_label_allFeatures:"all features",
googleSlides_filter_text_content:"Content",
googleSlides_filter_label_content:"content",
googleSlides_filter_text_webContent:"Web Content",
googleSlides_filter_label_webContent:"web content",
googleSlides_filter_text_activities:"Activities",
googleSlides_filter_label_activities:"activities",
googleSlides_noResults_imageAlt:"No Results",
googleSlides_noResults_text:"Oh snap! The feature you are searching for is not available yet, but we\u2019re working on it.",
googleSlides_searchPlaceholder:"Search for",
sidebar_menu_explore_nearpod:"Explore Nearpod for your School or District >",
sidebar_menu_explore_offers:"News & Updates",
sidebar_menu_special_offers:"Get Special Offers! >",
sidebar_menu_special_offers_button:"Get Special Offers",
sidebar_join_lesson:"Join a lesson",
google_slides_refresh:"Please refresh this page",
browse_lessons_sidebar:"Browse our lessons",
show_breadcrumb_search_results:"Showing results for",
header_subs_link_2:"Sub Plans",
teacher_resources:"Teacher Resources",
sidebar_faq:"FAQ",
whats_new:"What's new",
sidebar_content_packages_title:"My Supplemental Curricula ",
sidebar_badge_title:"User",
tabs_filter:"Choose a tab:",
drawit_timer_stand_by_activity_name:"a Draw It!",
googleSlides_stayHere_btn:"Stay Here & Edit",
googleSlides_goToNearpod_btn:"Go To Nearpod",
googleSlides_edit_text_1:"This lesson is saved, are you sure you want to edit the Nearpod slides?",
googleSlides_edit_text_2:"If you do not wish to make any changes, we will take you back to Nearpod. You will be able to preview the lesson, and nothing will be lost.",
googleSlides_userAlert_text_1:"Wait! Your lesson might:",
googleSlides_userAlert_text_2:"If you do not wish to make any changes, we will take you back to Nearpod. You will be able to preview the lesson, and nothing will be lost.",
googleSlides_userAlert_listItem_1:"Have an active code",
googleSlides_userAlert_listItem_2:"Be in your school\/district library",
googleSlides_userAlert_listItem_3:"Be in your public library",
high_storage_overlay_title_text1:"Whoopsie daisy, your storage is almost full!",
high_storage_overlay_title_text2:"Upgrade to Gold to grow your library worry-free.",
high_storage_overlay_primary_button:"Get Gold",
high_storage_overlay_secondary_button:"No thanks",
share_microsoft:"Microsoft Teams",
student_drawit_clearTitle:"Erase All",
student_drawit_clearMessage:"Are you sure you want to erase this drawing?",
flocabulary_filter:"Filter:",
store_search_noresults_line1_default:"Hi! We have some awesome lessons but none with '%s'.",
store_search_noresults_line2_prelink_default:"Please",
store_search_noresults_line2_linkurl_default:"mailto:feedback@nearpod.com?subject=I got no results on my Nearpod Lesson Library search!",
store_search_noresults_line2_linktext_default:"tell us what you were searching for",
store_search_noresults_line2_postlink_default:"so we can do better!",
store_search_noresults_line3_default:"",
store_search_noresults_line1_flocabulary:"",
store_search_noresults_line2_prelink_flocabulary:"Hi! Please ",
store_search_noresults_line2_linkurl_flocabulary:"https:\/\/www.flocabulary.com",
store_search_noresults_line2_linktext_flocabulary:"head over to Flocabulary",
store_search_noresults_line2_postlink_flocabulary:"for more culturally-relevant,",
store_search_noresults_line3_flocabulary:"media-rich content to captivate student interest!",
Flocabulary_Category_language_arts:"Language Arts",
googleSlides_shareConfirm_title:"Shared copies of this lesson will only open in Nearpod",
googleSlides_shareConfirm_message:"For a more flexible editing experience, we recommend sharing this lesson directly from Google Slides.",
googleSlides_shareConfirm_agreeBtn:"Share in Nearpod",
standards_filter_title:"Standards",
standards_filter_placeholder:"Select a Standard or State",
Flocabulary_Category_math:"Math",
Flocabulary_Category_science:"Science",
Flocabulary_Category_social_studies:"Social Studies",
Flocabulary_Category_life_skills:"Life Skills",
Flocabulary_Category_vocabulary:"Vocabulary",
Flocabulary_Category_current_events:"Current Events",
standards_filters_subjects_title:"Select a Subject",
admin_onboarding_outcome_title_part1_with_param:"Want to make this last longer than the {_days_} day trial period?",
standards_filters_grades_title:"Select a Grade",
standards_filters_strands_title:"Strands",
quiz_placeholder:"Untitled Quiz",
school_trial_onboarding_modal_body_with_params:"Plus access to all our activities, unlimited student participation, and student-paced mode with your {_days_} day FREE School Account.",
school_user_onboarding_modal_body_with_params:"Plus access to all our activities, unlimited student participation, and student-paced mode with your {_days_} day FREE School Account.",
googleSlides_editLesson_btn:"Edit This Lesson",
googleSlides_duplicateConfirm_title:"This lesson was created using the Google Slides Add-On",
googleSlides_duplicateConfirm_message:"Duplicates of this lesson will only be editable in Nearpod.",
flocabulary_edit_tooltip_init:"Get access to our library of Flocabulary videos with a Flocabulary School or District subscription. ",
binders_welcome_overlay_title_step0_part1:"Every moment matters.",
binders_welcome_overlay_title_step0_part2:"Here is how to create and send a Nearpod Sub Plan.",
binders_welcome_overlay_title_step1_part1:"Now it's your turn.",
binders_welcome_overlay_title_step1_part2:"Email yourself a sample Sub Plan.",
binders_welcome_overlay_primary_text_button_step0:"Get Started",
binders_welcome_overlay_primary_text_button_step1:"Send Sub Plan",
lessons_list_npp_long_label_unsynced:"New Updates in Google Slides",
school_free_trial_overlay_admin_title_part1:"Watch and learn about your ALL-ACCESS pass.",
school_free_trial_overlay_admin_title_part2:"Then start your {_days_}-Day FREE School Trial!",
school_free_trial_overlay_admin_primary_button:"Get Started",
school_free_trial_overlay_admin_secondary_button:"No Thanks",
Flocabulary_SubCategory_reading_writing:"Reading & Writing",
Flocabulary_SubCategory_grammar:"Grammar",
Flocabulary_SubCategory_research_study:"Research & Study Skills",
Flocabulary_SubCategory_literature:"Literature",
Flocabulary_SubCategory_addition_subtraction:"Addition & Subtraction",
Flocabulary_SubCategory_multiplication_division:"Multiplication & Division",
Flocabulary_SubCategory_numbers_operations:"Numbers & Operations",
Flocabulary_SubCategory_expressions_equations:"Expressions & Equations",
Flocabulary_SubCategory_geometry_measurement:"Geometry & Measurement",
Flocabulary_SubCategory_statistics_probability:"Statistics & Probability",
Flocabulary_SubCategory_ratios_proportional_relationships:"Ratios & Proportional Relationships",
Flocabulary_SubCategory_life_science:"Life Science",
Flocabulary_SubCategory_earth_space_science:"Earth & Space Science",
Flocabulary_SubCategory_physical_science:"Physical Science",
Flocabulary_SubCategory_technology_and_engineering:"Technology & Engineering",
Flocabulary_SubCategory_scientific_practices:"Scientific Practices",
Flocabulary_SubCategory_world_history:"Ancient World History",
Flocabulary_SubCategory_modern_world_history:"Modern World History",
Flocabulary_SubCategory_us_history:"U.S. History",
Flocabulary_SubCategory_civics:"Civics",
Flocabulary_SubCategory_geography:"Geography",
Flocabulary_SubCategory_historical_figures:"Historical Figures",
Flocabulary_SubCategory_holidays:"Holidays",
Flocabulary_SubCategory_economics:"Economics",
Flocabulary_SubCategory_historical_practices:"Historical Practices",
Flocabulary_SubCategory_issues_in_the_news:"Issues in the News",
Flocabulary_SubCategory_social_and_emotional_learning:"Social & Emotional Learning",
Flocabulary_SubCategory_health_wellness:"Health & Wellness",
Flocabulary_SubCategory_financial_literacy:"Financial Literacy",
Flocabulary_SubCategory_vocabulary_peach:"Word Up Peach - K",
Flocabulary_SubCategory_vocabulary_grape:"Word Up Grape - Gr. 1",
Flocabulary_SubCategory_vocabulary_turquoise:"Word Up Turquoise - Gr. 2",
Flocabulary_SubCategory_vocabulary_red:"Word Up Red - Gr. 3",
Flocabulary_SubCategory_vocabulary_orange:"Word Up Orange - Gr. 4",
Flocabulary_SubCategory_vocabulary_indigo:"Word Up Indigo - Gr. 5",
Flocabulary_SubCategory_vocabulary_green:"Word Up Green - Gr. 6",
Flocabulary_SubCategory_vocabulary_yellow:"Word Up Yellow - Gr. 7",
Flocabulary_SubCategory_vocabulary_blue:"Word Up Blue - Gr. 8",
Flocabulary_SubCategory_vocabulary_sat:"SAT Vocabulary",
Flocabulary_SubCategory_week_in_rap:"The Week in Rap",
Flocabulary_SubCategory_week_in_rap_junior:"The Week in Rap Junior",
school_free_trial_overlay_user_title_part1:"You have been invited to a {_days_}-Day FREE School Trial!",
school_free_trial_overlay_user_title_part2:"Watch and learn about your ALL-ACCESS pass.",
school_free_trial_overlay_user_primary_button:"Get Started",
school_free_trial_overlay_user_secondary_button:"No Thanks",
store_clear_standards:"Clear Standards",
deviceNotSupported_title_entering:"Grab a device with a bigger screen to create your own...",
deviceNotSupported_title_exiting:"Or download our app to launch your presentation!",
create_lesson_thumbnail_title:"Create your own lesson:",
create_lesson_thumbnail_or:"or",
create_lesson_thumbnail_inGoogleSlides:"Lesson in Google Slides",
create_lesson_thumbnail_inNearpod:"Lesson in Nearpod",
global_continue:"Continue",
drawit_enterTextPlaceholder:"Enter your text here",
create_lesson_thumbnail_title_2:"Create your own:",
sidebar_badge_title_admin:"Admin",
action_flocab_got_it:"Got it, thanks!",
googleSlides_addTooltip_text:"Now you can create beautiful, engaging lessons with the flexiblity of Google and the magic of Nearpod\u2026 together!",
googleSlides_addTooltip_button:"Ok, got it!",
lessons_list_npp_long_label_newChanges:"New changes! Open in Google Slides",
create_lesson_inGoogleSlides:"Lesson in Google Slides",
deviceNotSupported_title_part1:"To download or create lessons",
deviceNotSupported_title_part2:"please use a tablet, desktop or laptop computer.",
deviceNotSupported_video_title:"Watch this video and learn how to create lessons",
drawit_imageUploadLocalFiles:"Browse my files",
lessons_list_npp_long_label_videoError:"Unsaved - Video File Error",
googleSlides_confirm_gotIt:"Got It",
googleSlides_confirm_addFeature_text:"Let\u2019s add some Nearpod features! Try getting started with a Poll as your bell ringer.",
DrawIt_BackgroundEdit_ResetChanges:"Reset Settings",
store_lockedContent_withDistrictLibrary:"Hello! Please visit the",
store_lockedContent_withoutDistrictLibrary:"Hello. Your institution does not have access to this area of the Nearpod platform. Please contact your administrator if you have any questions.",
store_lockedContent_withDistrictLibrary_part2:"for an exclusively curated and vetted collection of content designed specifically for you.",
googleSlides_savePresentationFailed:"Aw snap! We couldn\u2019t save your lesson. Please try again in a little.",
game_activitiesLimit:"Time to Climb activities can contain up to {_maxQuestions_} questions only. If you want to ask more questions, create a 2nd Time to Climb.",
signUp_classlink_title:"Teacher Sign Up with Classlink",
deviceNotSupported_activityOnboarding_entering:"Grab a device with a bigger screen to experience your activity\u2026",
deviceNotSupported_activityOnboarding_exiting:"Or download our app to launch your presentation!",
onboarding_collaborate_step1_title_part1:"Welcome to Nearpod! We\u2019re so happy you\u2019re here.",
onboarding_collaborate_step1_title_part2:"Let's jump right in with our favorite activity - Nearpod Collaborate!",
onboarding_collaborate_step2_title:"Create your first Nearpod Collaborate!",
onboarding_collaborate_step2_button:"Create Now",
deviceNotSupported_back_nearpod:"Back to Nearpod.com",
onboarding_collaborate_step2_placeholder:"Enter topic",
quiz_question_toggle_textType:"Text",
quiz_question_toggle_imageType:"Images",
quiz_question_toggle_label:"Choose your answer type",
onboarding_collaborate_step2_animation_title:"Great! Now launch that activity and elevate your superhero status!",
quiz_answer_image_placeholder:"Select an image",
googleSlides_duplicateConfirm_mainButton:"Agree & Continue",
googleSlides_duplicateConfirm_titleNew_1:"This duplicate lesson will only open",
googleSlides_duplicateConfirm_messageNew:"For a more flexible editing experience, we recommend duplicating this lesson directly from Google Slides.",
googleSlides_duplicateConfirm_mainButtonNew:"Duplicate in Nearpod",
googleSlides_duplicateConfirm_titleNew_2:"in Nearpod",
creationTool_activity_minimumQuestions:"There has to be at least {_minimumQuestions_} question for this activity",
creationTool_activity_maximumAnswers:"You can't add more than {_maximumAnswers_} answers",
creationTool_activity_minimumAnswers:"Please include at least {_minimumAnswers_} answer choices",
creationTool_activity_missingFields:"Please complete the required fields below.",
upload_image_error:"There has been an error uploading the image",
creationTool_question_answerTypeToggleConfirm:"Are you sure you want to change the answer type? You will lose the answers you have already entered.",
creationTool_activity_deleteConfirm:"Are you sure you want to delete this activity?",
creationTool_activity_cancelConfirm:"Are you sure you want to cancel?",
creationTool_question_missingQuestionText:"Please include text for this question",
creationTool_question_missingAnswerText:"Please include text for this answer",
creationTool_question_missingAnswerImage:"Please include an image for this answer",
creationTool_question_missingCorrectAnswer:"Please select a correct answer",
whats_new_2:"What's New",
googleSlides_confirm_addFeature_title:"This Slide Is Not Editable",
onboarding_collaborate_step2_placeholder_2:"ex: What did you do this summer?",
googleSlides_popUpBlocked:"Aw snap! It looks like our pop-up was blocked. Please click \u2018Try Again\u2019 to grant permission for us to access Google Slides.",
global_tryAgain:"Try Again",
lessons_list_npp_action_launch_video:"Play Video",
googleSlides_confirm_editAudio_text:"Whoops! At this time, audio files cannot be edited in Google Slides. You will need to delete this slide and add a new audio file.",
googleSlides_confirm_editAudio_title:"Audio Files Are Not Editable",
lessons_list_npp_long_label_audioError:"Unsaved - Audio File Error",
lessons_list_npp_long_label_audioAndVideoError:"Unsaved - Media File Errors",
onboarding_collaborate_step2_placeholder_3:"Start with a topic",
onboarding_collaborate_step1_button_text:"I'm curious, show me!",
googleSlides_transition_overlay_title:"Taking you to Google Slides\u2026",
store_loading_more_lessons:"Loading more lessons...",
onboarding_collaborate_step2_animation_title_2:"Saving your board and taking you to your library...",
onboarding_collaborate_demo_text:"Ready to make your own?",
onboarding_collaborate_demo_text_link:"Create a Collaborate board now \u203a",
onboarding_collaborate_step1_title_part1_2:"Welcome to Nearpod!",
onboarding_collaborate_step1_title_part2_2:"Let's jump right in with our favorite activity.",
googleSlides_saveMediaFailed_title:"Aw Snap! This Lesson Has an Error",
googleSlides_saveMediaFailed_message:"Please return to Google Slides to fix it.",
sidebar_menu_news_and_offers:"News & Offers >",
sidebar_menu_news_and_offers_button:"News & Offers",
sidebar_menu_explore_nearpod_2:"Bring Nearpod to your School or District >",
share_link_view_only:"Preview-only",
share_link_editable:"Editable",
lesson_link:"link:",
global_slides_flocabulary:"Flocabulary",
firstLessonTooltip_liveLesson_text:"Launch a quick tour to experience the magic of Nearpod in your classroom.",
firstLessonTooltip_liveLesson_button
:"Launch Now!",
onboarding_collaborate_step1_title_part1_3:"Want to reach all your students and give them a voice?",
onboarding_collaborate_step1_title_part2_3:"We have just the thing...",
onboarding_collaborate_demo_text_link_2:"Create a Collaborate!",
onboarding_collaborate_step2_title_2:"Create your own Collaborate activity!",
onboarding_collaborate_step2_button_2:"Save in a Lesson Now",
onboarding_collaborate_step2_animation_title_3:"Saving your lesson and taking you to My Library...",
school_free_trial_overlay_user_secondary_button_sf:"I'm not interested in Free School Trial",
googleSlides_lmsRefresh_title:"Are you in an LMS?",
googleSlides_lmsRefresh:"Please be sure to refresh this page when you are finished editing your Google Slides lesson.",
googleSlides_lmsOpenGoogle_title:"Taking you to Google Slides...",
googleSlides_lmsOpenGoogle:"To create lessons using the Nearpod add-on for Google Slides, we need to open a new tab.",
googleSlides_savePresentationPermissionFailed:"It looks like you're signed into more than one Google Account. Please sign out and sign back in to save.",
googleSlides_savePresentationPermissionFailed_title:"Aw Snap!",
admin_onboarding_invite_teachers_title2_sf:"Share your FREE School Trial with your colleagues so you can test out ALL school features, like the School Library!",
admin_onboarding_express_invite_subtitle_sf:"Select colleagues with Nearpod accounts and invite others to try it FREE",
admin_onboarding_outcome_title_part1_with_param_sf:"Want to keep your School License after your {_days_} day trial at NO COST to you?",
admin_onboarding_outcome_title_part2_sf:"Refer your administrator and leave the rest to us.",
admin_onboarding_outcome_refer_button_sf:"Refer Your Admin",
admin_onboarding_skip_this_button_sf:"I'm the administrator",
admin_onboarding_refer_title_sf:"Refer your Admin",
admin_onboarding_express_colleague_invitation_sf:"They will be invited to join your School Trial and get access to 7,000+ lessons.",
global_slides_timeToClimb_descriptive:"Quiz Game",
onboarding_collaborate_step1_button_text_2:"Awesome, Show Me!",
onboarding_collaborate_demo_button:"Create a Collaborate!",
onboarding_collaborate_demo_title:"Ready to make your own?",
flocabulary_limit_reached_overlay_email_body:"Hey - \\n\\nI wanted to highlight a tool I\u2019ve been using in class lately :) My students have been super engaged with Flocabulary\u2019s hip-hop videos in Nearpod. Flocabulary provides video-centered lessons for all subjects to engage students with different learning styles. \\n\\nIn order to get access to ALL videos, we need a Flocabulary site license. If you stop by my classroom I will show you what\u2019s it all about. You can also reach out to our Nearpod rep and they can set up a demo.\\n\\nThank you for your support!\\n",
flocabulary_limit_reached_overlay_email_subject:"I\u2019ve been engaging my students with Flocabulary! \\n",
flocabulary_limit_reached_overlay_nudgemyadmin:"Nudge My Admin",
immersive_reader_overlay_title:"Make learning more meaningful!",
immersive_reader_overlay_subtitle_1:"Turn on powerful teacher controls like our Immersive Reader Add-On to improve reading and writing for all learners. ",
immersive_reader_overlay_primary_button:"Take me there!",
immersive_reader_overlay_secondary_button:"No thanks, not now",
immersive_reader_overlay_subtitle_2:"Find them in your profile, in the Advanced tab.",
onboarding_collaborate_step1_title_part2_4:"We have just the thing. Start with our Collaborate activity!",
onboarding_collaborate_step1_button_text_3:"Awesome, Start Now!",
global_mic_permissions_title:"Check... 1... 2...",
global_mic_permissions_text_1:"You can now record audio on this slide!",
global_mic_permissions_text_2:"Grant access to your mic in your browser\u2019s settings.",
global_confirmation:"Ok, got it!",
Flocabulary_Category_all_videos:"All Videos",
googleSlides_convertToDrawIt:"Convert To Draw It",
search_videos:"Search videos",
store_search_noresults_line1_empty_search:"Hi! We have some awesome lessons but none that match your search criteria.",
googleSlides_loading_convertToDrawIt:"Converting to Draw It...",
activity_submissionFailed_title:"Aw snap!",
activity_submissionFailed_message:"We were unable to submit your answer. Please try again.",
global_search:"Search",
store_search_filter_lessons:"Lessons",
store_search_filter_videos:"Videos",
store_search_filter_videos_and_lessons:"All lessons and videos",
goals_collaborate_card_title:"Class discussion with Collaborate",
goals_collaborate_card_description:"Launch to spark discussion or facilitate brainstorming.",
goals_oeq_card_title:"Interactive Bell Ringer",
goals_oeq_card_description:"Start your class with an interactive open ended question.",
goals_ttc_card_title:"Fun Review Game",
goals_ttc_card_description:"Gamify your classroom with our new quiz game, Time to Climb!",
my_library_remove_folder_message_2:"Are you sure you want to delete this folder? All contents will also be deleted.",
topbar_home_tooltip:"Main Menu",
topbar_logo_tooltip:"Personalized Offers",
topbar_create_tooltip:"Create",
topbar_cart_tooltip:"Cart",
topbar_avatar_tooltip:"Nearpod Account",
delete_folder_message_2:"Are you sure you want to delete this folder? All contents will also be deleted.",
goals_congratulation_card_title:"Challenge Complete",
goals_congratulation_card_description:"Congratulations, you earned a badge!",
topbar_quicklaunch_tooltip:"Quick Launch",
flocabulary_limit_reached_overlay_email_body_2:"Hi - \\n\\nI wanted to highlight a tool I\u2019ve been using in my class lately. My students have been super engaged with Flocabulary\u2019s Hip-hop videos, which are now offered within Nearpod. Flocabulary offers lessons across content areas and provides teachers with new and engaging ways to teach academically rigorous content.\\n\\nIn order to get access to ALL videos, we need the Flocabulary video pack for Nearpod. I wanted to share this with you as I feel other teachers could benefit from this as well! You can request more information (https:\/\/www.flocabulary.com\/inquiry\/) to experience the magic for yourself or stop by my classroom and I can show you first-hand!",
goals_collaborateCard_title_50:"Spark class discussion with Collaborate!",
goals_collaborateCard_description_50:"Click here to launch and facilitate brainstorming",
goals_collaborateCard_title_0:"Spark class discussion with Collaborate!",
goals_collaborateCard_description_0:"Create now to facilitate brainstorming",
topbar_quickLaunch_tooltip_text:"Launch our activities without a lesson, slides not required!\\n\\nQuickly create activities like Open Ended Question or Draw It and immediately share with your students.",
topbar_quickLaunch_tooltip_button:"Ok, got it!",
global_slides_timer:"Timer",
topbar_quicklaunch_title:"Quick Launch",
global_myActivities:"My Activities",
icon_validate_invalid_type:"Invalid file type. Please upload a",
video_preview_credits:"Credits",
video_preview_grade:"Grade",
video_preview_grades_plural_part:"s",
goals_timeToClimbCard_description_0:"Create now to lead a gamified review",
goals_timeToClimbCard_title_0:"Gamified Review Quiz",
goals_collaborate_card_button:"Create Now",
goals_timeToClimbCard_title_50:"Gamified Review Quiz",
goals_timeToClimbCard_description_50:"Click here to experience your friendly gamified review",
goals_timeToClimbCard_title_100:"Challenge Complete",
goals_timeToClimbCard_description_100:"Congratulations, you earned a badge!",
goals_oeqCard_description_0:"Create now to start your class with a writing prompt",
goals_oeqCard_title_0:"Bell Ringer Writing Prompt",
goals_oeqCard_title_50:"Interactive Bell Ringer",
goals_oeqCard_description_50:"Click here to experience your interactive bell ringer",
googleSlides_copyPasteTooltip_text:"Note: Nearpod slides cannot be copied & pasted",
goals_oeq_referenceMedia_required:"Your bell ringer writing prompt requires an image.",
goals_oeqCard_description_100:"Congratulations, you earned a badge!",
goals_oeqCard_title_100:"Challenge Complete",
quicklaunch:"Quick Launch",
flocabulary_no_results_search:"Hi! We have some awesome videos but none with \u201c{_query_}\u201d. Please try searching other keywords.",
onboarding_collaborate_step1_title_part1_4:"Welcome to Nearpod!",
onboarding_collaborate_step1_button_text_4:"Awesome, let\u2019s go!",
onboarding_collaborate_step1_title_part2_5:"Let\u2019s get started with a Collaborate! board",
global_university:"University",
onboarding_collaborate_demo_text_2:"Ready to ask your students a question?",
onboarding_collaborate_step2_placeholder_4:"Write your question here",
time_to_climb_title_part1_v1:"Welcome to Nearpod!",
time_to_climb_title_part2_v1:"Get your game on with our new gamified quiz.",
time_to_climb_text_part1_v1:"Get started now with FREE pre-made lessons",
time_to_climb_text_part2_v1:"available for all grades and subjects!",
time_to_climb_primaryButton_v1:"Get FREE lessons",
quicklaunch_launch_error_confirm:"Something went wrong and your lesson is taking longer to save than expected. Please try again.",
topbar_home_tooltip_2:"My Library",
interactive_video_select_video_id:"Video ID",
interactive_video_select_duration:"Duration",
interactive_video_select_credits:"Credits",
homework_share_code_text2:"Join with this CODE at join.nearpod.com or in the app",
reference_media_addReferenceImage:"Add Reference Image",
quick_launch_timer_title:"Quick Launch Timer",
admin_dashboard_toolbar_hint_text:"Check out our new Admin Dashboard Data Center!",
admin_dashboard_toolbar_hint_button:"View Now!",
creationTool_question_missingQuestionTextOrImage:"Please include text or an image for this question",
SignUpEmailTermsError2:"",
logIn_title_2:"Teachers",
logIn_subtitle:"Log In",
signup_teacher_subtitle:"Sign up for FREE",
signup_teacher_separator:"Or",
signup_student_title:"Students",
signup_student_subtitle:"Join a Lesson",
signup_student_text_part1:"Don't have a CODE?",
signup_student_text_part2:"Test out Nearpod using ",
signup_student_text_part3:"MAGIC",
quick_launch_timer_start:"Start Timer",
quick_launch_timer_cancel:"Cancel Timer",
signUp_form_mustAcceptTerms2:"You must confirm your age and accept our T&C.",
signUp_logIn_label_2:"Already have an account? ",
signUp_terms_start_2:"I agree to Nearpod\u00b4s ",
signUp_terms_end_2:" and I am over 13 years old.",
logIn_signUp_label_2:"Don't have an account? ",
oeq_panel_title:"Open Ended Question",
quiz_panel_title:"Quiz",
poll_panel_title:"Poll",
quick_launch_timer_controls_pause:"Pause",
quick_launch_timer_controls_restart:"Restart",
quick_launch_timer_controls_add_time:"Add \\n30 seconds",
quick_launch_timer_controls_remove_time:"Remove \\n30 seconds",
mcq_panel_title:"Multiple Choice Question",
quick_launch_timer_controls_resume:"Resume",
quick_launch_timer_remove_time_toast:"30 seconds removed",
quick_launch_timer_add_time_toast:"30 seconds added",
quick_launch_timer_pause_time_toast:"Timer paused. Press Play to resume",
quick_launch_timer_resume_time_toast:"Timer resumed",
interactive_video_foc_multiple_choice_button:"Show Solution",
interactive_video_look_at_teacher_title:"Eyes up front!",
interactive_video_look_at_teacher_description:"The video will play on your teacher's device. Come back here when it's time for an activity.",
quicklaunch_cancel_timer_subtitle:"Are you sure you want to cancel?",
quicklaunch_cancel_timer_not_now_button:"Not Now",
quicklaunch_cancel_timer_confirm_button:"Yes, Cancel",
signup_with_office:"Office 365",
quicklaunch_restart_timer_title:"Restart Timer",
quicklaunch_restart_timer_subtitle:"Are you sure you want to restart?",
quicklaunch_restart_timer_confirm_button:"Yes, Restart",
signup_with:"Sign up with",
signup_with_google:"Google",
quick_launch_timer_confirm_cancel_modal_toast:"Timer canceled",
teachers_title:"Teachers",
signup_with_clever:"Clever",
signup_with_classlink:"Classlink",
quick_launch_timer_confirm_restart_modal_toast:"Timer restarted!",
interactive_video_ls_student_column_header:"Student",
interactive_video_ls_answer_column_header:"Answer",
interactive_video_ls_participation_column_header:"Participation",
interactive_video_ls_no_answers_yet:"No answers yet",
add_dropdown_interactiveVideo:"Interactive Video",
interactive_video_student_oeq_answer_placeholder:"Ready? Enter your answer here.",
interactive_video_student_oeq_submit:"Submit",
navigationMenu_upgrade_label:"Upgrade",
navigation_menu_account:"Nearpod Account",
interactive_video_upload_success:"Video Added",
interactive_video_creation_replaceVideo:"Replace Video",
interactive_video_topbar_settings:"Settings",
navigationMenu_notificationPreferences_label:"Notification Preferences",
navigationMenu_notificationPreferences_enableEmailNotification_text:"Email notifications",
navigationMenu_notificationPreferences_enableEmailNotification_description:"Receive email notifications for recommendations, offers, student activity, and your weekly activity.",
navigationMenu_notificationPreferences_note:"You will always receive email notifications for shared lessons.",
navigationMenu_account_label:"Manage Nearpod Account",
interactive_video_creation_premade:"Don't have a video to upload?",
interactive_video_creation_premade_link:"Try one of our pre-made interactive videos!",
onboarding_collaborate_step1_button_text_5:"Let's go!",
onboarding_collaborate_step1_title_part2_6:"Get ready to make every lesson interactive.",
onboarding_collaborate_step2_title_3:"Create your own Collaborate!",
onboarding_collaborate_step2_placeholder_5:"What do you want to ask your students?",
onboarding_collaborate_step2_button_3:"Save",
navigationMenu_notificationPreferences_updateEmailNotification_success:"You email notification settings have been saved.",
onboarding_collaborate_step2_animation_title_4:"Saving your activity and taking you to My Library...",
interactive_video_title:"Untitled Interactive Video",
add_to_districtLibrary:"Add to District Library",
add_to_schoolLibrary:"Add to School Library",
navigationMenu_help_label:"Help",
navigationMenu_helpCenter_label:"Help Center",
navigationMenu_teacherResources_label:"Teacher Resources",
navigationMenu_whatsNew_label:"What's New",
navigationMenu_communities_label:"Communities",
navigationMenu_pricing_label:"Pricing",
navigationMenu_contactUs_label:"Contact Us",
add_activity_at:"Add Activity at",
userSchoolProfile_overlay_title:"Tell us about you.",
userSchoolProfile_overlay_subtitle:"Based on this information, you'll get tips, offers, and free lessons just for you.",
userSchoolProfile_overlay_mainButton_text:"Update",
interactive_video_oeq_submission_no_answer:"No answer",
userSchoolProfile_overlay_school_title:"School",
userSchoolProfile_overlay_school_placeholder:"Type your school name",
userSchoolProfile_overlay_form_grades_label:"Grades",
userSchoolProfile_overlay_form_grades_placeholder:"Select one or more grades",
userSchoolProfile_overlay_school_notFound:"Let us know!",
interactive_video_collapse_tooltip:"Collapse",
interactive_video_expand_tooltip:"Expand",
userSchoolProfile_overlay_form_role_label:"Role",
userSchoolProfile_overlay_form_role_placeholder:"Select your primary role",
interactive_video_settingsModal_title:"Interactive Video Details",
interactive_video_settingsModal_inputPlaceholder:"Enter video title",
interactive_video_settingsModal_toggle:"Add Subject & Grade(s)",
interactive_video_settingsModal_submit:"Save & Exit",
userSchoolProfile_overlay_form_subjects_label:"Subjects",
userSchoolProfile_overlay_form_subjects_placeholder:"Select one or more subjects",
interactive_video_student_oeq_submit_confirmation_title:"Are you sure?",
interactive_video_student_oeq_submit_confirmation_text:"Once you submit your answer, you won't be able to change it.",
interactive_video_student_sp_submit_success_title:"Got it!",
interactive_video_student_oeq_submit_success_text:"Your answer has been submitted.\\nThe video will resume on your teacher\u2019s device.",
interactive_video_student_oeq_submit_confirmation_cancel:"Edit answer",
interactive_video_student_oeq_submit_confirmation_accept:"Submit",
preview_video_embedded_activities_Poll:"Poll",
preview_video_embedded_activities_MCQ:"Multiple Choice Question",
preview_video_embedded_activities_OEQ:"Open Ended Question",
preview_video_embedded_activities_title:"Embedded Activities:",
flipgrid_creationTool_student_label:"Insert the Join Link for the topic",
flipgrid_creationTool_student_helper_title:"Insert the Flipgrid Student URL",
flipgrid_creationTool_student_helper_description
:"From the grid, click \u2018Share\u2019 and then click to copy the link",
flipgrid_creationTool_teacher_label:"Insert the Topic URL from the browser",
flipgrid_creationTool_teacher_helper_title:"Insert the Flipgrid Teacher URL",
flipgrid_creationTool_teacher_helper_description:" Go to the teacher dashboard of your grid and copy the URL from the browser",
global_slides_flipgrid:"Flipgrid",
my_account_profile_image_save_success:"Profile image uploaded successfully.",
navigationMenu_endImpersonate:"End Impersonate",
interactive_video_activityPicker_title:"Add Activity",
student_lead_welcome_title:"Welcome to Your Lesson",
student_lead_login_title:"Student Log In",
student_lead_welcome_message:"Have an account? ",
student_lead_welcome_message_link:"Sign in Here",
student_lead_login_message:"Don\u2019t have an account? ",
student_lead_login_message_link:"Join as a Guest",
student_lead_welcome_nameInput:"Name",
student_lead_welcome_optionalInput:"Other optional name",
student_lead_welcome_submitButton:"Join Lesson",
student_lead_welcome_nameInput_error:"Please enter you name here",
onboarding_distance_learning_title_part2:"Create dynamic, interactive learning experiences for your students",
onboarding_distance_learning_button_text:"Let's go!",
onboarding_distance_learning_title_part1:"Keep students engaged in learning\u2026 wherever they are",
interactive_video_toggle_modal_subtitle_first:"Would you like to turn on Interactive Mode?",
interactive_video_toggle_modal_subtitle_second:"The video will pause at key moments to provide questions for discussion and exploration of the topic.",
interactive_video_toggle_modal_title:"This is an Interactive Video!",
firstLessonTooltip_liveLesson_text2:"Hover over your lesson to choose a Live or Student-Paced experience.",
myLibrary_silverstudentPaced_title:"Access Student-Paced mode to support your students during COVID-19",
myLibrary_silverstudentPaced_subtitle:"To help during this time of school closures, Nearpod is unlocking Student-Paced mode for Silver teachers through April 30th.",
myLibrary_silverstudentPaced_button:"Get Access!",
lessons_list_npp_action_live_lesson_with_zoom:"Live Lesson | Zoom",
school_trial_welcome_title_part1_2:"Ready to unlock the full power of Nearpod?",
admin_onboarding_invite_teachers_title2_2:"Click below to upgrade these teachers too!",
admin_onboarding_invite_teachers_textButton_2:"Upgrade colleagues",
admin_onboarding_express_text_2:"Want to invite more teachers?",
admin_onboarding_express_add_colleague_2:"Add a colleague",
admin_onboarding_express_colleague_invitation_2:"They will be invited to join your Nearpod school.",
admin_onboarding_invite_teachers_confirm_btn_one_2:"Continue",
admin_onboarding_outcome_title_part1_2:"Want to get even more teachers at your school on Nearpod?",
admin_onboarding_outcome_title_part2_2:"Refer your admin and leave the rest to us.",
admin_onboarding_outcome_refer_button_2:"Get started",
admin_onboarding_express_congrats_title_2:"You're all set! ",
admin_onboarding_express_congrats_subtitle_2:"Now you have access to all of Nearpod's school edition features, including the Lesson Library and Student-Paced mode.",
admin_onboarding_express_congrats_button_2:"Get started",
myLibrary_studentPaced_viewProgress:"View Progress",
lessons_list_more_actions_share_label:"Share With Teachers",
interactive_video_interactive_mode_toggle:"Interactive Mode",
interactive_video_exit_confirm_message:"Are you sure you want to exit?",
interactive_video_exit_tooltip:"Close (x)",
navigationMenu_manage_label:"Admin Tool",
collaborate_moderateStudentPaced_text:"You can now moderate Collaborate! boards in Student-Paced lessons. ",
preview_front_of_classroom_button:"Front Of Classroom",
preview_front_of_classroom_description:"Stream from your device to an interactive board",
preview_all_devices_button:"All Devices",
preview_all_devices_description:"Control the pace on your device, students respond to questions on their devices",
preview_assign_student_paced_button:"Assign Student-Paced",
preview_assign_student_paced_description:"Students complete the assignment on their own",
preview_teach_button:"Teach",
interactive_video_details:"Interactive video details",
reference_media_addReference:"Add media, video, or audio instructions",
navigationMenu_settings_label:"Teacher Settings",
myLibrary_silverstudentPaced_subtitle2:"During this time of school closures, Nearpod is providing access to Student-Paced mode to all teachers through June 30th.",
interactive_video_student_sp_submit_success_continue:"Continue Playing",
interactive_video_student_sp_submit_success_text:"Your answer has been submitted.",
myLibrary_lessonLaunchNotReady_title:"We are sorry! Your lesson is not ready yet.",
myLibrary_lessonLaunchNotReady_messageWithTime:"Please try again in {_seconds_} seconds.",
myLibrary_lessonLaunchNotReady_message:"Please try again.",
interactive_video_activity_updated:"Activity Updated",
lead_page_waiting_modal_title:"Welcome!",
lead_page_waiting_modal_text:"Please wait for your teacher to start the lesson.",
fillInTheBlanks_session_header_title:"Fill in the blanks",
fillInTheBlanks_session_header_button:"View Answers",
fillInTheBlanks_session_dashboard_student:"Student",
fillInTheBlanks_session_dashboard_matches:"Score",
fillInTheBlanks_session_dashboard_title:"Classroom results",
video_quality:"Video Quality",
interactive_video_activity_added:"Activity Added",
create_lesson_inNearpod:"Lesson in Nearpod",
poll_submit_required_text:"Oops! Looks like you haven't answered this poll. Please submit your choice before going to the next slide.",
oeq_submit_required_text:"Oops! Looks like you haven't answered this question. Please submit an answer before going to the next slide.",
quiz_submit_required_text:"Oops! Looks like you haven't answered all of the questions. Please submit your answers before going to the next slide.",
qa_submit_required_text:"Oops! Looks like you haven't answered this question. Please submit a response before proceeding to the next slide.",
drawit_submit_required_text:"Oops! This page looks blank. Please submit a drawing before going to the next slide.",
requiredActivities_toggle_label:"Require student submissions",
interactive_video_reports_title:"Video Report",
navigationMenu_upgrade_label2:"Upgrade Account",
navigationMenu_settings_label2:"Lesson Settings",
navigationMenu_help_label2:"Help & FAQs",
navigationMenu_helpCenter_label2:"FAQs",
interactive_video_toggle_modal_subtitle:"Would you like to turn on Interactive Mode?\\nThe video will pause at key moments to provide questions for discussion and exploration of the topic.",
interactive_video_activity_deleted:"Activity Deleted",
interactive_video_student_oeq_back_to_video:"Back to Video",
interactive_video_student_oeq_back_to_video_confirmation_accept:"Yes",
interactive_video_student_oeq_back_to_video_confirmation_cancel:"Cancel",
interactive_video_student_oeq_back_to_video_confirmation_text:"You will be taken back to the video.",
interactive_video_student_oeq_back_to_video_confirmation_title:"Are you sure?",
global_slides_mcq:"Multiple Choice Question",
interactive_video_previousActivity_tooltip:"Previous Activity",
interactive_video_nextActivity_tooltip:"Next Activity",
my_account_menu_navigation_payment:"Payment Details",
my_account_payment_title:"Payment Details",
my_account_payment_content_subtitle:"Payment Details",
my_account_payment_content_description:"Manage you subscription and payment methods.",
my_account_payment_content_button:"Manage Payment Details",
interactive_video_activity_delete_confirm:"Yes, Delete",
interactive_video_activity_delete_confirmation:"Are you sure you want to delete this activity?",
delete_activity_button_label:"Delete Activity",
desmos_title_BlankGraph:"Blank Graph",
do_not_show_again:"Do not show again",
create_toolbar_feedback_button:"Send Us Feedback",
mic_asking_permissions_title:"Grant Nearpod microphone access",
mic_asking_permissions_message:"To grant Nearpod microphone access, please go to your device settings.",
mic_asking_permissions_cancel:"Cancel",
mic_asking_permissions_goto_settings:"Go to Settings",
interactive_video_student_mcq_submit_confirmation_accept:"Submit",
interactive_video_student_mcq_submit_confirmation_text:"Once you submit your answer, you won't be able to change it.",
interactive_video_student_mcq_submit_confirmation_title:"Are you sure?",
interactive_video_student_mcq_submit_confirmation_cancel:"Edit answer",
interactive_video_guest_modal_title:"We're sorry!",
interactive_video_guest_modal_description:"Student View mode is not supported on this slide.",
mcq_answers_validation_minimum:"Please include at least two answer choices.",
mcq_answers_validation_maximum:"Questions can contain up to 15 answer choices only.",
video_playback_speed:"Playback Speed",
interactive_video_settings_playback_speed_normal:"Normal",
interactive_video_settings_playback_speed_slow:"Slow",
interactive_video_settings_playback_speed_slowest:"Slowest",
oeq_student_recording_audio_recorder_disabled:"Recording is not enabled",
googleSlides_clickableLinks_linksList_title:"Select the link you want to visit.",
interactive_video_student_mcq_submit:"Submit",
interactive_video_student_mcq_back_to_video:"Back to Video",
interactive_video_student_mcq_continue:"Continue Playing",
cookiesNotSupported_mainButton:"Enable cookies",
cookiesNotSupported_title:"Oops! It looks like your browser is blocking cookies for Nearpod",
cookiesNotSupported_subtitle:"After enabling cookies, hit Retry!",
cookiesNotSupported_secondaryButton:"Retry",
preview_all_devices_button_2:"Live Participation",
preview_all_devices_description_2:"Control the pace on your own device; students respond to questions on their devices.",
preview_assign_student_paced_button_2:"Student-Paced",
preview_assign_student_paced_description_2:"Students complete the assignment on their own.",
preview_front_of_classroom_button_2:"Front of Class",
preview_front_of_classroom_description_2:"Present from your device for the class to view.",
googleSlides_savePresentationFailed_alreadyPublished:"Your presentation is already saved. Reloading...",
global_complete_fields:"Please complete the required fields below.",
signup_emailAlreadyRegistered_error:"An account with this email already exists. Please login below",
interactive_video_settingsModal_support_title:"Support Settings",
interactive_video_settingsModal_support_update_poster:"Update poster image",
lessons_list_npp_action_launch_video_2:"Front Of Class",
lessons_list_npp_action_live_participation:"Live Participation",
preview_toolbar_share_button:"Share Preview",
preview_live_participation_button:"Live Participation",
create_toolbar_help_placeholder_2:"At Nearpod we are always looking for ways to improve the product, please tell us what you think.",
interactive_video_activity_cancel_confirm:"Are you sure you want to cancel? You will lose your changes.",
lessons_list_npp_status_almostThere:"Almost there",
interactive_video_notSupported_modal_title:"We're sorry!",
interactive_video_notSupported_modal_description:"This slide is not supported on this screen resolution.",
interactive_video_teacher_mcq_title_answers:"Answers",
interactive_video_teacher_mcq_title_selected:"Selected",
interactive_video_teacher_mcq_option_no_answer:"No Answer",
interactive_video_teacher_mcq_results_correct:"Correct",
interactive_video_teacher_mcq_results_incorrect:"Incorrect",
interactive_video_teacher_mcq_results_no_answer:"No Answer",
interactive_video_teacher_mcq_share:"Share Solution",
interactive_video_teacher_mcq_unshare:"Unshare",
student_lead_welcome_title_part1:"Welcome to ",
student_lead_welcome_title_part2:"Your Lesson",
student_lead_login_title_part1:"Student ",
student_lead_login_title_part2:"Log In",
help_box_send_feedback_title:"Send Us Your Feedback",
store_thumbnail_preview_text_folder:"View More",
store_thumbnail_preview_text_bundle:"Preview Bundle",
store_thumbnail_preview_text_lesson:"Preview Lesson",
nickelTour_button_complete_text:"Get Started!",
nickelTour_button_common_text:"Next",
nickelTour_lessonInteractive_title:"Make any lesson interactive",
nickelTour_lessonInteractive_description:"With Nearpod, you can add formative assessments directly into your lesson to drive student engagement.",
nickelTour_preMadeLessons_title:"No Need to Plan from Scratch",
nickelTour_preMadeLessons_description:"Start with a resource you already have, or check out our standards-aligned, pre-made lessons.",
nickelTour_reports_title:"Unlock Student Understanding",
nickelTour_reports_description:"Get real-time insights into what students know, and access reports after your lesson.",
interactive_video_settingsModal_support_transcript:"Handout: Transcript",
interactive_video_settingsModal_support_question:"Handout: Video Questions",
interactive_video_student_live_submit_success_title:"Got it!",
interactive_video_student_live_submit_success_text:"Your answer has been submitted.",
interactive_video_banner_title:"This is a Preview",
interactive_video_student_sp_oeq_submit_success_continue:"Continue Playing",
interactive_video_student_sp_oeq_submit_success_text:"Your answer has been submitted.",
interactive_video_student_oeq_submit_success_title:"Got it!",
nickelTour_tooltip_button:"Check it out!",
nickelTour_tooltip_description:"Spark class discussion with a Collaborate board.",
interactive_video_teacher_breakpointReached_title:"Ready to begin?",
interactive_video_teacher_breakpointReached_message:"Clicking \"Start Activity\" will pause the video wherever the students are at, and display the activity.",
interactive_video_teacher_breakpointReached_confirm:"Start Activity",
interactive_video_teacher_breakpointReached_dismiss:"Go Back",
confirm_storage_paywall_button_text:"Upgrade",
goals_collaborateCard_description_50_v2:"Now experience the magic by inviting your students to participate",
createToolbar_suggestionsButton:"Send Us Suggestions",
helpBox_sendSuggestionsTitle:"Send Us Your Suggestions",
interactive_video_teacher_breakpointReached_apply:"Apply to all activities in this video",
schoolProfile_overlay_title:"Tell us a little about yourself",
schoolProfile_overlay_subtitle:"Please complete your profile while we finish setting up your library.",
schoolProfile_overlay_school_label:"School",
schoolProfile_overlay_school_placeholder:"Type your school name",
schoolProfile_overlay_school_notFound:"Let us know!",
schoolProfile_overlay_role_label:"Role",
schoolProfile_overlay_role_placeholder:"Select your primary role",
schoolProfile_overlay_mainButton_text:"Lets Go!",
nickelTour_tooltip_description_2:"Collaborate! activity boards are great for gathering feedback and ideas from your class.",
max_presentation_size_reached__upgrade_button_text:"Upgrade",
max_presentation_size_reached__contact_button_text:"OK",
max_presentation_size_reached__upgrade_text:"This presentation exceeds the {_maxSizeOfPresentations_}MB size limit for presentations in your type of account.",
max_presentation_size_reached__contact_text:"This presentation exceeds the {_maxSizeOfPresentations_}MB per presentation limit of your account. Please email support@nearpod.com to find out how you can expand your account.",
video_picker_tab_youtube:"YouTube",
video_picker_tab_video_library:"Video Library",
video_picker_tab_video_upload_video:"Upload a Video",
interactive_video_teacher_breakpointReached_dismiss_2:"Back to Video",
schoolProfile_overlay_title_2:"Please tell us a little about yourself",
schoolProfile_overlay_subtitle_2:"Let us know your school and role so we can set up your library.",
schoolProfile_overlay_mainButton_text_2:"Done!",
myLibrary_silverstudentPaced_subtitle3:"During this time of school closures, Nearpod is providing access to Student-Paced mode to all teachers through October 31st.",
search_box_placeholder_text_videos:"Search for videos",
main_header_dropdown_videosLibrary:"Video Library",
video_settings_untitled_error:"Title your video",
nearpod_library:"Nearpod Library",
paywalls_not_enough_space:"You have reached the maximum storage capacity of {_maxStorage_}MB for your license. Upgrade now to increase your storage space.",
paywalls_not_enough_space_upgrade:"Upgrade",
paywalls_not_enough_space_contact:"Contact Us",
nearpod_library_search_box_placeholder_text:"Search for lessons in the Nearpod Library",
interactive_video_upload_error:"There has been an error processing this video. Please try again or try a different video.",
interactive_video_reports_info_message:"Click the blue dots to review student answers to each question. Then, navigate between questions with the arrows on the top right.",
interactive_video_reports_info_title:"Welcome to the video report",
store_search_noresults_line2_urllink_default:"mailto:feedback@nearpod.com?subject=I got no results on my Nearpod Library search!",
store_search_noresults_line2_urllinkurl_flocabulary:"https:\\\/\\\/www.flocabulary.com",
add_dropdown_interactiveVideo_new:"Video",
interactive_video_teacher_oeq_share_participant_submission:"Share with class",
interactive_video_teacher_oeq_unshare_participant_submission:"Unshare with class",
handouts_item_title_transcript:"Transcript",
handouts_item_title_video_questions:"Video Questions",
interactive_video_reports_info_continue
:"Continue",
interactive_video_cancel_confirm:"Are you sure you want to cancel? You will lose your changes.",
interactive_video_uploadingOverlay_processingMessage_1:"Sit back and relax, your video will be ready shortly!",
interactive_video_uploadingOverlay_processingMessage_2:"If you'd like to try again later, you can cancel at any time.",
interactive_video_uploadingOverlay_cancelButton:"Cancel video upload",
interactive_video_uploadingOverlay_uploading:"Uploading...",
interactiveVideo_handouts_transcript:"Transcript",
interactiveVideo_handouts_videoQuestions:"Video Questions",
store_picker_search_noresults:"Hi! We have some awesome lessons and videos but none with '%s'.",
interactive_video_topbar_button_back:"Back",
video_topbar_button_back	:"Back",
student_lead_welcome_message_2:"Already have an account? ",
student_lead_welcome_message_link_2:"Log In",
student_lead_welcome_submitButton_2:"Join Lesson",
main_topBar_addButton_label:"New",
main_topBar_quickLaunchButton_label:"Quick Launch",
navigationMenu_nearpodBlog_label:"Nearpod Blog",
interactive_video_empty_video_save:"Oops! You haven't uploaded a video. Add a video or click cancel to exit the video editor.",
first_lesson_overlay_loading_subtitle1_live_participation:"Hover and select Live Participation.",
lessons_list_npp_live_participation_session_tooltip:"Hover over this thumbnail to launch a Live Participation! Click \"Preview\" to see the lesson before launching.",
my_library_launch_live_participation_new:"Launch new live participation",
no_access_video_library_content_tab:"Aw Snap! You don't have access to Video Library content. Please switch over to the \"YouTube\" or \"Upload a Video\" tabs to continue.",
code_palceholder_2:"CODE...",
navigationSidebar_resources_title:"RESOURCES",
create_lesson_thumbnail_inVideo:"Video",
create_lesson_thumbnail_inVideo_description:"Start with one of our videos or create your own.",
create_lesson_thumbnail_inNearpod_description:"Create a new lesson or upload a PowerPoint.",
create_lesson_thumbnail_inGoogleSlides_description:"Add the power of Nearpod to your slides.",
cart_button_decorator_cartButtonText_adding:"Adding",
navigationSidebar_materials_title:"MY MATERIALS",
navigationSidebar_nearpod_content_title:"NEARPOD CONTENT",
interactive_video_settings_updated_banner:"Video details updated",
navigationSidebar_b2bLibraries_title:"SHARED LIBRARIES",
interactive_video_participation_lowercase:"participation",
student_accounts_sso_noAccountConfirm_title:"Error",
student_accounts_sso_noAccountConfirm_subTitle:"This Nearpod Student Account does not exist.",
student_accounts_sso_noAccountConfirm_button:"Ok, got it!",
navigationMenu_personalizedNews_label:"Personalized News",
navigationSidebar_b2bLibraries_managelink_text:"Manage >",
picker_search_noresults_empty_search:"Hi! We have some awesome videos but none that match your search criteria.",
student_autofillName_getName_title:"Grab my name from...",
student_autofillName_getName_info_subtitle:"The only information we will get from your account are your first and last names.",
interactive_video_activityPicker_title_new:"Activities",
navigationSidebar_materials_publicLibrary_text:"My Public Library",
interactive_video_blocked_title:"Time for a video!",
interactive_video_blocked_message:"To play it, click the button below and the video will open in a new tab.",
interactive_video_blocked_button:"Launch This Video",
uploader_max_video_size:"This file is too large. The maximum file size is %s MB.",
lessons_list_header_action_share_tooltip:"This folder cannot be shared because it contains an unsaved lesson or premium content.",
video_preview_extra_information_related_videos:"Related Videos",
student_autofillName_confirmName_title:"Is this you?",
student_autofillName_confirmName_link:"Go Back",
student_autofillName_confirmName_button:"Yes, Continue",
student_autofillName_getName_info_subtitle_2:"The only information we will get from your account is your first and last name.",
signUp_form_password_error:"Minimum 6 characters, no common words.",
lead_page_quickTourExtended_modal_title:"Welcome to the Student View",
lead_page_quickTourExtended_modal_text:"Switch back to the prior tab to see the Teacher view and compare.",
onboarding_collaborate_transition_animation_title_part1:"You just made your first Nearpod activity!",
onboarding_collaborate_transition_animation_title_part2:"Now, let's check out what your students will experience.",
my_library_add_lessons_to_pl_modal:"Add Here",
video_picker_max_upload_file_size:"Max file size: %smb",
mylibrary_dnd_npp_text_2:"Drag to folder",
navigationSidebar_b2bLibraries_manageDistrict_text:"Manage District",
navigationSidebar_b2bLibraries_manageSchool_text:"Manage School",
schoolProfile_overlay_subtitle_3:"Let us know your role so we can set up your library.",
video_picker_tab_my_videos:"My Videos",
lessons_list_npp_action_teach:"Teach",
lessons_list_npp_action_live_zoom:"Live + Zoom",
my_library_teach_modal_title:"Choose your teaching mode",
lesson_collaborate_disabled_confirm_alert_title:"This lesson has a Collaborate Board",
lesson_collaborate_disabled_confirm_alert_message:"Collaborate Boards are currently disabled for your Student-Paced lessons. Students will not be able to participate in this activity. Open your settings to enable Collaborate Boards for Student-Paced or continue with your lesson.",
lesson_collaborate_disabled_confirm_btn_continue
:"Continue",
lesson_collaborate_disabled_confirm_btn_settings:"Open Settings",
my_library_teach_modal_live_participation_tooltip:"Control the pace on your own device; students respond to questions on their devices.",
my_library_teach_modal_live_zoom_tooltip:"Lead the lesson while instructing with Zoom.",
my_library_teach_modal_student_paced_tooltip:"Students complete the assignment on their own.",
my_library_teach_modal_front_of_class_tooltip:"Present from your device for the class to view.",
global_slides_collaborateBoard:"Collaborate Board",
nickelTour_tooltip_description_collaborateBoard:"Collaborate Boards are great for gathering feedback and ideas from your class.",
onboarding_collaborateBoard_demo_button:"Create a Collaborate Board",
onboarding_collaborateBoard_step1_title_part2:"Let\u2019s get started with a Collaborate Board",
onboarding_collaborateBoard_step2_title:"Create your own Collaborate Board",
private_library_title_schoolLibrary_2:"Add Lesson to School Library",
private_library_title_districtLibrary_2:"Add Lesson to District Library",
interactive_video_settings_playback_speed_fast:"Fast",
interactive_video_settings_playback_speed_fastest:"Fastest",
interactive_video_blank_prompt_title:"Wait!",
interactive_video_blank_prompt_message
:"You didn't answer the question.",
interactive_video_limitReached_modal_description:"This activity has reached the maximum amount of students. Please wait for your teacher so you can move to the next slide.",
interactive_video_limitReached_modal_title:"We're sorry!",
my_library_teach_modal_settings:"Lesson Settings",
my_library_teach_modal_resume_active_session:"Resume Active Session",
goals_collaborateCard_title_0_2:"Spark class discussion with Collaborate",
my_library_teach_modal_view_active_sessions:"View Active Sessions",
goals_collaborateCard_title_50_2:"Spark class discussion with Collaborate",
interactive_video_trimming_trim:"Trim",
interactive_video_trimming_cancel:"Cancel",
poll_multiple_options_info:"Allow students to select multiple options",
poll_multiple_options_tooltip:"If not selected, the poll answer will be limited to only one option per student.",
student_accounts_sso_confirmLogin_title:"Confirm Login",
student_accounts_sso_confirmLogin_button:"Continue",
student_accounts_sso_confirmLogin_link:"Log Out",
student_accounts_sso_confirmLogin_subtitle:"You\u2019ve logged in with this account before. Do you want to continue?",
video_preview_extra_information_credits:"Credits",
alert_title_iv_welcome_modal:"Videos",
alert_message_iv_welcome_modal:"Create your own interactive video with Nearpod! Start with one of our videos, upload your own or search YouTube. Then, embed questions to check student understanding.",
doit_button_iv_welcome_modal:"Let's do it!",
login_notification_school_join_message_2:"Congratulations! As a Nearpod School user, you can now enjoy access to premium and advanced features such as school libraries and student note taking.",
interactive_video_editor_welcome_tour_modal:"Make videos interactive with Nearpod! You can now add activities to any video to check for understanding.",
interactive_video_editor_welcome_tour_step_1:"Add activities at any point in the video.",
interactive_video_editor_welcome_tour_step_2
:"Activities are dots that appear on the timeline. Once added, select them to edit, or click and hold to drag them.",
interactive_video_editor_welcome_tour_step_3:"Use the \u201cSettings\u201d link to add or update the video\u2019s name, grade, or subject.",
global_skip_tour:"Skip Tour",
interactive_video_limitReached_modal_descriptionHomework:"This activity has reached the maximum amount of students. Please click on the arrow to move to the next slide.",
interactive_video_blank_prompt_review:"Review Answer",
interactive_video_blank_prompt_submit
:"Submit Anyway",
interactive_video_upload_credits_success:"Credits added",
interactive_video_embed_in_slide_button:"Embed in slides",
interactive_video_prevent_skip_prompt_title:"Wait!",
interactive_video_prevent_skip_prompt_message:"Oops, Looks like you haven't answered this question. Please submit an answer before moving on.",
interactive_video_prevent_skip_prompt_continue:"Got it!",
global_error:"An error has occured",
video_preview_extra_information_standards:"Standards",
main_topBar_addButton_label_2:"Create",
requiredActivitiesAndSkipping_toggle_label:"Require student responses and prevent skipping",
interactive_video_student_live_submit_confirmation_edit:"Edit Answer",
create_menu_slides_title:"Slides",
create_menu_slides_description:"Combine content, video and activities",
create_menu_videos_title:"Videos",
create_menu_videos_description:"Add activities in any video",
create_menu_google_slides_title:"Google Slides",
create_menu_google_slides_description:"Create lessons in Google Slides",
my_account_payment_content_text:"Manage your subscription and payment methods.",
mylibrary_header_add_folder:"+ Folder",
interactive_video_submissions_required_title:"Wait!",
interactive_video_submissions_required_text:"Oops! Looks like you haven't finished the video and all the questions. Please finish watching the video and answer all questions before moving on.",
interactive_video_trim_video_notification_message:"Activities and video in the trimmed area will not be deleted. You can come back here at any time to recover them. ",
my_library_explore_library_thumbnail:"EXPLORE THE NEARPOD LIBRARY",
picker_search_youtube_noresults_title:"Whoops!",
picker_search_youtube_noresults_message:"Looks like YouTube doesn't have exactly what you're looking for. Please try again.",
interactive_video_trimming_video_trimed:"Video Trimmed",
create_menu_slides_title_2:"Lessons",
login_notification_district_join_message_2:"Congratulations! As a Nearpod District user, you can now enjoy access to premium and advanced features such as district libraries and student note taking.",
video_captions:"Captions",
reference_media_audio_recorder_attached:"Audio Recording Attached",
navigationSidebar_b2bLibraries_manageNearpod_text:"Manage Nearpod",
video_picker_tab_my_videos_message_without_videos:"You currently don't have any videos saved in My Library. When you save videos to My Library, they'll show up here.",
audio_recorder_delete_confirm_text:"Are you sure you want to delete this audio recording? You will lose all of your changes.",
audio_recorder_delete_confirm_cancel:"Cancel",
audio_recorder_delete_confirm_confirm:"Yes, Delete",
interactive_video_trimtool_save_modal_goBack:"Go Back",
interactive_video_trimtool_save_modal_trimAndSave:"Trim and Save",
interactive_video_trimtool_save_modal_title:"Wait! It looks like you have unsaved changes. Do you want to keep these changes and save your video?",
custom_audio_player_uploading:"Uploading",
custom_audio_player_delete_confirm_text:"Are you sure you want to delete? You will lose your audio recording.",
custom_audio_player_delete_confirm_cancel:"Cancel",
custom_audio_player_delete_confirm_confirm:"Yes, Delete",
timeToClimb_creation_deleteQuestion_confirm:"Are you sure you want to delete this question?",
google_slides_unauthorized_create_title:"Heads up!",
google_slides_unauthorized_create_message:"Building lessons with the Google Slides Add-On is available to teachers with Nearpod Gold and up. Not ready to upgrade? You can still upload your Google Slides and add activities in Nearpod.",
google_slides_unauthorized_create_createInNearpod:"Create in Nearpod",
google_slides_unauthorized_create_goGold:"Upgrade Options",
addon_not_supported_subtitle:"Building lessons with the Google Slides Add-On is available to teachers with Nearpod Gold and up. To access the add-on, you will need to upgrade your account. Not ready to upgrade? You can still upload your Google Slides and add activities in Nearpod.",
addon_not_supported_upgrade:"Learn About Upgrading",
addon_not_supported_go_to_nearpod:"Create in Nearpod",
onboardingGuide_title:"Get started with Nearpod",
my_library_no_lessons_result_link_3:"Try searching the Nearpod Library.",
onboardingGuide_lessonPreviewCard_title:"See how it works",
onboardingGuide_lessonPreviewCard_text:"Experience Nearpod in this interactive lesson preview.",
onboardingGuide_exploreLessonsCard_title:"Explore lessons",
onboardingGuide_exploreLessonsCard_text:"Preview thousands of standards- aligned pre-made lessons.",
onboardingGuide_lessonBuilderCard_title:"Lesson builder",
onboardingGuide_lessonBuilderCard_text:"Upload existing resources or start building from scratch.",
onboardingGuide_launchTourCard_title:"Launch tour",
onboardingGuide_launchTourCard_text:"Choose a teaching mode and share the lesson with your class.",
google_slides_unauthorized_edit_title:"This lesson was created using the Google Slides Add-On",
google_slides_unauthorized_edit_message:"By editing this lesson, you will be editing a Nearpod version of the lesson.",
google_slides_unauthorized_edit_learnMore:"Learn More",
google_slides_unauthorized_edit_editInNearpod:"Edit in Nearpod",
onboardingGuide_dismiss_confirm_title:"Dismiss Guide?",
onboardingGuide_dismiss_confirm_message:"To view the guide again simply select it from under Help & FAQs in your profile menu.",
onboardingGuide_dismiss_button_text:"Dismiss Tips",
onboardingGuide_dismiss_confirm_dismiss:"Dismiss",
onboardingGuide_navstack_button:"Getting Started Guide",
video_picker_tab_my_videos_message_without_results:"Hi! You have some awesome lessons but none with",
oeq_error_chars_exceed:"Oops! There was a problem saving your question.",
oeq_error_shorten_chars:"Your question exceeds the maximum length of 1,000 characters. Please shorten it and try saving again.",
lessonPreview_header_title:"Preview mode",
lessonPreview_teacher_device_title:"Teacher device",
lessonPreview_student_device_title:"Student device",
create_lesson_thumbnail_text:"Create a Lesson",
my_library_delete_lesson_confirm_message:"Deleting this lesson will delete all reports, expire all active CODES, remove it from all folders, and render share links invalid.",
my_library_active_session_message_1:"As a Silver user, you can only have one active Live Participation session at a time.",
my_library_active_session_resume:"Resume",
my_library_active_session_start:"Start New Session",
lessonPreview_header_exit:"Exit preview",
googleSlides_shareConfirm_titleNew:"This lesson was created using the Google Slides Add-On",
googleSlides_shareConfirm_messageNew
:"Shared copies of this lesson will only be editable in Nearpod.",
terms_and_conditions_suffix:" have changed. Please review and accept the changes to continue using Nearpod.",
terms_and_conditions_start:"I agree to Nearpod\u00b4s ",
terms_and_conditions_link:"terms & conditions",
terms_and_conditions_end:" and I am over 13 years old.",
terms_and_conditions_success:"Terms & Condition and Privacy Policy have been accepted",
terms_and_conditions_error:"There was an error",
help_feedback_suggestion_button:"Send suggestion",
addon_not_supported_title:"Heads up!",
oeq_error_reviewInformation:"Please review the entered information",
oeq_helper_message:"Please enter text up to 1000 characters",
interactive_video_embed_in_lesson_button:"Embed in a lesson",
terms_and_conditions_terms:"Terms & Conditions",
terms_and_conditions_policy:"Privacy Policy",
terms_and_conditions_connector:" and ",
terms_and_conditions_prefix:"Nearpod\u2019s ",
google_slides_unauthorized_create_messageNew:"Building lessons with the Google Slides Add-On is available to teachers with Nearpod Gold and up. Not ready to upgrade? You can still upload Google Slides presentations and add activities within Nearpod.",
addon_not_supported_message:"Building lessons with the Google Slides Add-On is available to teachers with Nearpod Gold and up. To access the add-on, you will need to upgrade your account. Not ready to upgrade? You can still upload Google Slides presentations and add activities within Nearpod.",
navigation_sidebar_my_lessons:"My Lessons",
onboardingGuide_exploreLessonsCard_text_2:"Preview thousands of pre-made standards-aligned lessons.",
onboardingGuide_lessonBuilderCard_title_2:"Lesson builder",
quiz_helper_message:"Please enter text up to 1000 characters",
rich_text_error_shorten_chars_helper:"Your question exceeds the maximum length of {_maxLength_} characters.",
my_library_lessons_title_2:"My Lessons",
onboardingGuide_lessonPreviewCard_title_2:"See how it works",
interactive_video_streamMode_title:"This is a video. How should it play?",
interactive_video_streamMode_option_teacherPlays_title:"Teacher plays",
interactive_video_streamMode_option_studentPlays_title
:"Students play",
activity_banks_search_placeholder_ttc:"Search Time to Climb Activities",
activity_banks_activity_grades:"Grade(s)",
activity_banks_title_ttc:"Explore Time to Climb Library",
activity_banks_loadingActivities:"Loading more activities",
activity_banks_noResults:"Hi! We have some awesome activities but none with",
activity_banks_filters_clear:"Clear",
activity_banks_filters_apply:"Apply",
activity_banks_filters_back:"Back",
activity_banks_replaceConfirm_title:"Are you sure?",
activity_banks_replaceConfirm_message:"If you replace this activity you will lose all of your changes.",
activity_banks_replaceConfirm_backButton:"No, go back",
activity_banks_replaceConfirm_replaceButton:"Yes, replace",
poll_helper_message:"Please enter text up to 1000 characters",
global_review_information_error:"Please review the entered information",
activity_banks_noResults_firstLine:"Hi!",
activity_banks_noResults_secondLine:"We have some awesome activities but none with",
interactive_video_check_progress_tooltip:"Students will move through the video at their own pace. Click the blue dots to view students' responses to the video questions.",
interactive_video_streamMode_option_studentPlays_desc:"Students watch the video and answer questions at their own pace.",
interactive_video_streamMode_option_teacherPlays_desc:"Video plays on the teacher's device. Questions appear on student devices.",
interactive_video_streamMode_continue:"Continue",
activity_banks_title_drawIt:"Explore Draw It Library",
activity_banks_search_placeholder_drawIt:"Search Draw It Activities",
postal_code:"Postal Code",
state_province:"State or Province",
activity_banks_title_matchingPairs:"Explore Matching Pairs Library",
activity_banks_search_placeholder_matchingPairs:"Search Matching Pairs Activities",
store_search_filter_activities:"Activities",
global_form_invalidPostalCode:"Please enter a valid postal code",
gs_paywallModal_title:"Two ways to create Nearpod Lessons with Google Slides",
gs_paywallModal_list_1
:"Upload Google Slides in Nearpod in Create > Lessons, then Upload (FREE)",
gs_paywallModal_list_2:"Use the Nearpod Add-On and create in Google Slides (Gold plans and up)",
gs_paywallModal_upgradeText:"Upgrade for 30 days with code:",
gs_paywallModal_button:"Try Gold FREE",
gs_paywallModal_disclaimer:"Gold code will not work if you\u2019ve redeemed a code before.",
activity_banks_activity_grade:"Grade",
gs_paywallModal_list_1_part1:"Upload Google Slides in Nearpod in Create > Lessons, then Upload (",
gs_paywallModal_list_1_part2:"Free",
gs_paywallModal_list_1_part3:")",
gs_paywallModal_list_2_part1:"Use the Nearpod Add-On and create in Google Slides (",
gs_paywallModal_list_2_part2:"Gold plans and up",
gs_paywallModal_list_2_part3:")",
no_access_video_library_content_tab_message:"Your school or district doesn't have access to the Video Library. You can still make your own interactive video lessons by selecting the \"YouTube\", \"My Videos\", or \"Upload a Video\" tabs to choose or upload videos into Nearpod.",
picker_search_youtube_video_placeholder:"Search with YouTube Safe Search or paste a YouTube link",
npp_activity_grades:"Grade(s)",
whiteboard_button_open:"Open Whiteboard",
whiteboard_button_close:"Close Whiteboard",
whiteboard_annotation_button_label:"Draw or write on this slide. Students will see your annotations in real-time."},
 es: {
quicklaunch_cancel_timer_title:"Cancelar Temporizador",
global_submit:"Enviar",
global_apply:"Aplicar",
global_logIn:"Ingresar",
global_signUp:"Registrarse",
global_joinALesson:"Unirse a una lecci\u00f3n",
global_areYouStudent_question:"\u00bfEres estudiante?",
global_imTeacher:"Soy Profesor",
global_imStudent:"Soy Estudiante",
global_OR:"o",
global_form_email:"Email",
global_form_password:"Contrase\u00f1a",
global_form_confirmPassword:"Confirmar contrase\u00f1a",
global_form_optionalField:"Este es un campo opcional",
global_form_requiredField:"Obligatorio",
global_form_invalidEmail:"Por favor ingrese un email v\u00e1lido.",
global_form_referralCode_question:"C\u00f3digo de referencia?",
global_form_emailIsRequired:"El email es obligatorio",
global_form_passwordIsRequired:"Contrase\u00f1a obligatoria",
studentJoin_explanation:"Tu profesor te dar\u00e1 un CODE para unirte a una lecci\u00f3n",
studentJoin_dontHaveAPin:"No tienes un CODE? Usa MAGIC",
logIn_title:"Ingreso Profesor",
logIn_forgotPassword_question:"Olvidaste tu contrase\u00f1a?",
logIn_rememberMe:"Recordarme",
logIn_logInWithOffice:"Ingresa con Office 365",
logIn_logInWithGoogle:"Ingresa con Google",
forgotPassword_title:"Recupera tu contrase\u00f1a",
forgotPassword_explanation_start:"Ingresa la",
forgotPassword_explanation_bold:"Direcci\u00f3n de email",
forgotPassword_explanation_end:"que has utilizado para crear una cuenta y te enviaremos instrucciones para cambiar la contrase\u00f1a.",
forgotPassword_forgotEmail:"Olvidaste tu email? Ponte en contacto con nosotros a",
signUp_signUpWithOffice:"Registrarse con Office 365",
signUp_signUpWithGoogle:"Registrarse con Google",
signUp_signUpWithEmail:"Registrarse con email",
signUp_form_mustAcceptTerms:"Debes confirmar tu edad y aceptar los t\u00e9rminos y condiciones.",
signUp_title:"Registrarse como Profesor",
signUp_terms_start:"Acepto los",
signUp_terms_link:"t\u00e9rminos y condiciones de Nearpod",
signUp_terms_end:"y tengo m\u00e1s de 13 a\u00f1os de edad",
signUp_form_firstName:"Nombre",
signUp_form_lastName:"Apellido",
signUp_form_schoolEmail:"Email Escuela",
signUp_studentAlertMessage:"No necesitas registrarte para unirte a una lecci\u00f3n.",
signUp_google_title:"Profesor - Registrarse con Google",
signUp_office_title:"Profesor - Registrarse con Office 365",
logInNewPassword_passwordDontMatch:"La contrase\u00f1a no coincide.",
logInNewPassword_title:"Por favor ingresa tu nueva contrase\u00f1a",
global_joinASession:"Unirse a una lecci\u00f3n",
global_join:"Unirse",
global_invalidReferral:"C\u00f3digo de referencia inv\u00e1lido",
global_form_firstNameIsRequired:"Nombre obligatorio",
global_form_lastNameIsRequired:"Apellido obligatorio",
header_myLibrary_link:"Mi Biblioteca",
header_create_link:"Crear",
header_explore_link:"Explorar",
header_subs_link:"Subs",
binders_sort_option_name:"Nombre de la tarea",
binders_sort_option_sub:"Sub asignado",
binders_sort_option_date:"Fecha(s)",
binders_sort_option_status:"Estado",
binders_sort_title:"Ordenar por:",
binders_newAssignmentBtn:"+ Nueva Tarea para Sub",
binders_listHeader_name:"Nombre de tarea",
binders_listHeader_sub:"Sub asignado",
binders_listHeader_date:"Fecha(s)",
binders_listHeader_status:"Estado",
binders_list_emptyMsg:"\u00a1Bienvenido!",
binders_status_draft:"Borrador",
binders_status_sent:"Enviado",
binders_status_reviewed:"Revisado",
binders_status_inProcess:"En proceso",
binders_status_completed:"Completo",
binders_list_emptyMsg_link:"Haz click aqu\u00ed para crear un Sub Plan",
binders_createModal_title:"Nombrar Tarea para suplente",
global_cancel:"Cancelar",
global_create:"Crear",
binders_sendAssignment:"Enviar tarea del Sub",
binders_addLessons:"Agregar lecciones",
binders_notesTooltip_text:"Agrega notas a cada lecci\u00f3n para aclarar cualquier duda que pueda tener el sub.",
binders_lessons_emptyMsg:"No has asignado ninguna lecci\u00f3n a\u00fan.",
binders_lessons_emptyMsg_link:"Empieza a agregar Lecciones.",
binders_lessons_titleDropdown_school:"Info de la Escuela",
binders_lessons_titleDropdown_classroom:"Info de la clase",
binders_lessons_titleDropdown_assignment:"Info de Tarea",
binders_lessons_titleDropdown_delete:"Borrar tarea",
binders_lessons_info_date:"Fecha(s)",
binders_lessons_info_sub:"Sub",
binders_lessons_info_link:"Seleccionar",
binders_lessons_title:"Lecciones para Sub",
global_tooltip_gotIt:"Entendido",
binders_npp_addNotes:"Agregar notas",
binders_npp_editNotes:"Editar notas",
binders_npp_preview:"Vista previa",
binders_notesModal_title:"Agregar notas de la lecci\u00f3n",
binders_notesModal_desc:"Agrega detalles acerca de cu\u00e1ndo y c\u00f3mo debe usarse esta Lecci\u00f3n.",
binders_notesModal_placeholder:"ej: Hicimos la mitad de esta lecci\u00f3n ayer, as\u00ed que debe empezarse en la diapositiva 13. Los estudiantes deben silenciar sus dispositivos cuando corran un video.",
binders_deleteBinder_title:"Borrar tarea",
binders_deleteBinder_msg:"\u00bfConfirma que desea borrar esta tarea? Ya no podr\u00e1 recuperar la tarea ni sus reportes.",
global_date_picker_placeholder:"Del MM\/DD\/YYYY al MM\/DD\/YYYY",
binders_form_school_information_title:"Informaci\u00f3n de la Escuela",
binders_form_school_information_tooltip:"Esta informaci\u00f3n se guarda en tu perfil y puede ser editada en cualquier momento.",
binders_form_school_name_label:"Nombre de la Escuela",
binders_form_school_name_placeholder:"Nombre de la Escuela",
binders_form_school_address_label:"Direcci\u00f3n de la Escuela",
binders_form_school_address_placeholder:"Direcci\u00f3n",
binders_form_city_label:"Ciudad",
binders_form_city_placeholder:"Ciudad",
binders_form_state_label:"Estado",
binders_form_state_placeholder:"Seleccionar",
binders_form_zip_code_label:"C\u00f3digo postal",
binders_form_zip_code_placeholder:"C\u00f3digo postal",
binders_form_school_contact_label:"Contacto de la Escuela",
binders_form_school_contact_detail:"\u00bfA qui\u00e9n puede llamar el\/la suplente si tiene preguntas?",
binders_form_school_contact_placeholder:"Nombre completo",
binders_form_school_contact_phone_placeholder:"Tel\u00e9fono",
binders_form_school_contact_role_placeholder:"Rol",
binders_form_classroom_information_title:"Informaci\u00f3n de la clase",
binders_form_classroom_information_tooltip:"Esta informaci\u00f3n se guarda en tu perfil y puede ser editada en cualquier momento.",
binders_form_class_notes_label:"Notas de clase",
binders_form_class_notes_detail:"D\u00f3nde encontrar dispositivos e informaci\u00f3n adicional",
binders_form_class_notes_placeholder:"\u00bfQu\u00e9 deber\u00eda saber el\/la suplente sobre la clase? \u00bfAlgo sobre alg\u00fan estudiante o sobre los procesos de trabajo?",
binders_form_emergency_procedures_label:"Procedimientos de emergencia",
binders_form_emergency_procedures_placeholder:"\u00bfHay algo que el\/la suplente deba saber si hay un simulacro de incendio? \u00bfAlgo m\u00e1s para tener en cuenta?",
binders_form_classroom_assistance_label:"Asistencia para la clase",
binders_form_classroom_assistance_detail:"\u00bfA qui\u00e9n puede acudir el\/la suplente si necesita ayuda?",
binders_form_classroom_assistance_name_placeholder:"Nombre completo",
binders_form_classroom_assistance_phone_placeholder:"Tel\u00e9fono o n\u00famero del aula",
binders_form_classroom_assistance_role_placeholder:"Rol",
binders_form_classroom_information_upload:"Cargar",
binders_form_classroom_information_replace:"Reemplazar",
binders_form_classroom_information_upload_tooltip:"Adjunta un JPG o PDF con cualquier informaci\u00f3n adicional que el\/la suplente pueda necesitar.",
binders_form_assignment_information_title:"Informaci\u00f3n de la Tarea",
binders_form_assignment_information_tooltip:"Puede ser completada en cualquier momento antes de enviar la tarea.",
binders_form_assignment_name_label:"Nombre de la Tarea",
binders_form_assignment_name_placeholder:"Nombre de la Tarea",
binders_form_assignment_dates_label:"Fecha(s)",
binders_form_assignment_sub_title:"\u00bfSabes qui\u00e9n ser\u00e1 tu suplente?",
binders_form_assignment_sub_tooltip:"Los\/as suplentes pueden recibir tareas tanto por email como por mensaje de texto.",
binders_form_sub_information_label:"Informaci\u00f3n de contacto del\/a suplente",
binders_form_sub_information_person_title_placeholder:"Seleccionar",
binders_form_sub_information_first_name_placeholder:"Nombre",
binders_form_sub_information_last_name_placeholder:"Apellido",
binders_form_sub_information_email_placeholder:"E-mail",
binders_form_sub_information_phone_placeholder:"Tel\u00e9fono celular",
binders_form_assignment_admin_title:"Si no se asigna suplencia, ingresa los datos del administrador de la escuela.",
binders_form_assignment_admin_tooltip:"Un contacto de la escuela puede compartir la tarea una vez que se asigne un\/a suplente.",
binders_form_assignment_admin_label:"Contacto administrativo de la Escuela",
binders_form_admin_first_name_placeholder:"Nombre",
binders_form_admin_last_name_placeholder:"Apellido",
binders_form_admin_email_placeholder:"E-mail",
binders_form_admin_role_placeholder:"Rol",
binders_form_cell_notifications_title:"Ingresa tu n\u00famero de celular para recibir notificaciones por mensaje de texto.",
binders_form_cell_notifications_placeholder:"555-888-1234",
binders_form_next_button:"Siguiente",
binders_form_send_button:"Enviar tarea al\/a suplente",
global_folder:"Carpeta",
global_lessons_sort_recent:"Reciente",
global_lessons_sort_name:"Nombre",
global_lessons_sort_author:"Autor",
global_lessons_sort_size:"Tama\u00f1o",
global_lessons_no_results:"No hay resultados para tu b\u00fasqueda. Intenta nuevamente.",
global_lessons_no_selected:"No hay lecciones seleccionadas a\u00fan.",
global_add:"Agregar",
binders_lessons_picker_title:"Agregar lecciones a",
binders_lessons_picker_search_placeholder:"Buscar en Mi Librer\u00eda",
global_save:"Guardar",
global_delete:"Borrar",
global_date_from:"Del ",
global_date_to:" al ",
binders_lessonsAdded_singular:"Lecci\u00f3n agregada exitosamente.",
binders_lessonsAdded_plural:"Lecciones agregadas exitosamente.",
teacher_private_library_search_toolbar_title_library:"Biblioteca de la Escuela",
teacher_private_library_search_toolbar_sort_by:"Ordenar por:",
search_input_filter:"Filtrar",
search_input_placeholder:"Buscar por nombre de profe o palabra clave",
search_input_filters_modal_clear:"Limpiar selecci\u00f3n",
search_input_filters_modal_search:"Buscar",
teacher_private_library_root_lessons_container_empty_cta:"\u00a1Agregar lecciones!",
teacher_private_library_root_lessons_container_empty:"No hay lecciones en esta biblioteca a\u00fan.",
teacher_private_library_npp_hover_layer_preview_btn_text:"Vista previa",
cart_button_decorator_cartButtonText_show_in_my_library:"Ver en mi Biblioteca",
cart_button_decorator_cartButtonText_add_to_my_library:"Agregar a Biblioteca",
cart_button_decorator_cartButtonText_adding_to_cart:"Agregando",
cart_button_decorator_cartButtonText_removing_from_cart:"Sacando del carrito de compras",
cart_button_decorator_cartButtonText_remove_from_cart:"Sacar del carrito de compras",
cart_button_decorator_cartButtonText_purchase_for:"Comprar por $",
private_library_sort_options_date:"Agregadas recientemente",
private_library_sort_options_name:"Nombre",
private_library_sort_options_author:"Autor\/a",
private_library_sort_options_size:"Tama\u00f1o",
admin_private_library_info_title:"Biblioteca de la Escuela",
admin_private_library_info_description:"\u00a1Crea una Biblioteca Nearpod exclusiva para tu escuela o distrito! Podr\u00e1s f\u00e1cilmente compartir las lecciones que creaste o descargaste en un \u00fanico lugar con todos\/as tus colegas.",
admin_search_add_toolbar_button_area:"+ Agregar a la Biblioteca",
admin_search_add_toolbar_button_dropdown_find_lessons:"Buscar lecciones",
admin_search_add_toolbar_button_dropdown_new_folder:"Nueva Carpeta",
admin_search_add_toolbar_search:"Buscar por Profesor o Palabra Clave",
admin_search_add_toolbar_sort_label:"Ordenar por:",
admin_npp_more_actions_menu_item_btn_label_add:"Agregar a la carpeta",
admin_npp_more_actions_menu_item_btn_label_remove:"Sacar de lacarpeta",
admin_npp_more_actions_menu_item_btn_label_delete:"Eliminar",
admin_private_library_npp_preview:"Vista Previa",
private_library_breadcrumb_list_item:"Biblioteca de la Escuela",
private_library_breadcrumb_dropdown_add:"Agregar lecciones",
private_library_breadcrumb_dropdown_rename:"Cambiar nombre la carpeta",
private_library_breadcrumb_dropdown_delete:"Eliminar carpeta",
private_library_breadcrumb_dropdown_color:"Color de la carpeta",
admin_private_library_folder_button:"Agregar lecciones",
private_library_find_lessons_modal_header_title:"Encuentra lecciones para la ",
results_box_header_sort_label:"Ordenar por:",
admin_private_library_find_lessons_results_npp_preview:"Vista Previa",
admin_private_library_find_lessons_results_npp_unselect:"Eliminar selecci\u00f3n",
private_library_npp_free:"Gratis",
private_library_npp_teacherlesson:"Lecciones de profesores",
private_library_npp_nearpodstore:"Tienda Nearpod",
private_library_settings_edit_title:"Configuraciones de la Biblioteca de la Escuela",
private_library_settings_edit_name:"Nombre de la Biblioteca",
private_library_settings_edit_toggle:"Permitir que los profesores agreguen a la Biblioteca de la Escuela",
private_library_settings_edit_toggle_tooltip:"Esta opci\u00f3n habilita a profes para que agreguen lecciones a la Biblioteca.",
private_library_settings_edit_submit:"Guardar",
active_filters_lessons_from:"resultados para:",
private_library_sort_options_relevance:"Relevancia",
admin_private_library_find_lessons_results_npp_select:"Seleccionar lecci\u00f3n",
add_lessons_toolbar_hint_button:"\u00a1Entendido!",
add_lessons_toolbar_hint_text:"\u00a1Haz click aqu\u00ed para agregar las lecciones seleccionadas a la Biblioteca de tu Escuela!",
add_lessons_toolbar_button:"Agregar",
add_lessons_toolbar_select_label:"Mostrar todas las lecciones seleccionadas",
private_library_name_folder_modal_rename:"Renombrar",
private_library_name_folder_modal_name:"Nombre",
delete_lesson_title:"Eliminar Lecci\u00f3n",
delete_lesson_message:"\u00bfConfirma que desea eliminar esta lecci\u00f3n?",
delete_folder_title:"Eliminar esta carpeta ",
delete_folder_message:"\u00bfConfirma que desea eliminar esta carpeta? Todas las lecciones permanecer\u00e1n en su Biblioteca.",
main_header_dropdown_item:"Tienda Nearpod",
preview_toolbar_info:"Informaci\u00f3n",
preview_toolbar_share:"Compartir",
preview_toolbar_wishlist:"Favoritos",
preview_toolbar_author:"Nombre autor\/a",
preview_toolbar_info_details:"estudiantes alcanzados\/as",
long_description_title:"Acerca de esta lecci\u00f3n",
global_no:"No",
global_yes:"S\u00ed",
cart_remove_alert:"\u00bfConfirma que desea sacar este \u00edtem de su carrito de compras?",
share_title:"Compartir",
global_to:"para",
share_email_share_title:"O enviar por e-mail:",
global_send:"Enviar",
share_link_disclosure1:"o",
share_link_disclosure2:"para copiar el link",
share_embed_label:"Insertar c\u00f3digo:",
bundle_lessons_title:"Lecciones en este Bundle",
bundle_lessons_hide:"esconder",
bundle_lessons_see:"ver todo el contenido de",
private_library_find_lessons_modal_empty:"No se han encontrado lecciones. Por favor intenta con una nueva b\u00fasqueda. ",
teacher_private_library_search_toolbar_title_district:"Biblioteca del Distrito",
binders_createModal_termsText:"Estoy de acuerdo con",
binders_createModal_termsLink:"los t\u00e9rminos y condiciones de Nearpod para Subs",
global_confirm:"Confirmar",
paidLessons_modal_title:"Te avisamos que est\u00e1s agregando lecciones con costo.",
paidLessons_modal_text:"Los profesores deber\u00e1n pagar estas lecciones de sus bolsillos. \u00bfDesea continuar?",
private_library_folder_created:"Carpeta creada",
private_library_folder_deleted:"Carpeta eliminada",
private_library_folder_lessonAdded:"Lecci\u00f3n agregada a la carpeta",
private_library_folder_lessonRemoved:"Lecci\u00f3n removida de la carpeta",
private_library_lessonDeleted:"Lecci\u00f3n eliminada",
private_library_cart_itemRemoved:"Este \u00edtem fue removido de tu carrito de compras.",
private_library_lessonsAdded:"Lecciones agregadas",
private_library_cart_itemAdded:"se agreg\u00f3 a tu carrito de compras",
private_library_search_placeholder:"Buscar",
private_library_admin_lessonsNumber_text:"Lecciones",
private_library_findLessons_selectAll:"Seleccionar todo",
private_library_findLessons_unselectAll:"Borrar selecci\u00f3n",
private_library_admin_addToLibrary_hintText:"\u00a1Encuentra lecciones para tu escuela o distrito aqu\u00ed!",
private_library_admin_addToLibrary_hintButton:"\u00a1Entendido!",
private_library_admin_emptyMsg_1:"No hay lecciones en esta biblioteca a\u00fan.",
private_library_admin_emptyMsg_2:"para que usen los profesores de tu escuela o distrito",
private_library_admin_emptyMsg_link:"Agregar lecciones",
private_library_explore_tooltip:"\u00a1Mira la Biblioteca de tu Escuela o Distrito para encontrar lecciones compartidas por tus colegas!",
admin_district_library_info_title:"Biblioteca del Distrito",
private_library_title_schoolLibrary:"Biblioteca de la Escuela",
private_library_title_districtLibrary:"Biblioteca del Distrito",
my_account_profile_title:"Perfil",
my_account_advanced_title:"Avanzado",
my_account_notifications_title:"Notificaciones",
my_account_notifications_content_subtitle_email:"Notificaciones por e-mail",
my_account_notifications_content_description_email:"Administra tus notificaciones de email seleccionando el bot\u00f3n aqu\u00ed debajo.",
my_account_notifications_content_button_text:"Administrar notificaciones",
my_account_profile_header_image_tooltip:"Puedes subir archivos JPG o PNG de hasta",
my_account_profile_header_image_tooltip_btn:"Subir imagen",
add_to_folder_title:"Agregar a la carpeta",
add_to_folder_result_list_no_matches:"A\u00fan no tienes carpetas",
add_to_folder_result_list_no_matches_link:"crear una",
add_to_folder_new_folder_link:"Crear una nueva carpeta",
add_to_folder_add_lessons:"Agregar lecciones",
global_back:"Atr\u00e1s",
global_logOut:"Cerrar sesi\u00f3n",
sidebar_menu_following:"Siguiendo",
sidebar_menu_wishList:"Lista de deseos",
sidebar_menu_accountPreferences:"Preferencias de la cuenta",
sidebar_menu_manage:"Administrar",
sidebar_menu_get_the_school_edition:"Obt\u00e9n la Edici\u00f3n School",
sidebar_menu_free_trial_expired:"Tu Per\u00edodo de Prueba Gratuito ha expirado",
lessons_picker_result_list_item_bundle:"Bundle",
suggestion_list_new_item:"No puedes encontrar tu escuela?",
suggestion_list_new_item_link:"\u00a1Agregala ahora!",
paid_lessons_add_title:"Lecciones pagas",
paid_lessons_add_message:"Est\u00e1s incluyendo lecciones pagas",
private_library_name_folder_modal_placeholder:"Carpeta sin t\u00edtulo",
private_library_settings_edit_placeholder:"Nombre de la Biblioteca",
private_library_settings_edit_message:"Es obligatorio nombrar la Biblioteca",
binders_deleteLesson_title:"Eliminar lecci\u00f3n",
binders_deleteLesson_msg:"\u00bfConfirmas que deseas realizar esta acci\u00f3n?",
global_edit:"Editar",
binders_form_assignment_admin_salutation_placeholder:"Seleccionar",
global_ok:"\u00a1Entendido!",
global_checkout:"Ir al carrito",
item_added_alert_message:"fue agregada\/o a tu carrito de compras.",
lesson_preview_modal_secondaty_title:"Vista Previa",
my_account_menu_navigation_profile:"Perfil",
my_account_menu_navigation_advanced:"Avanzado",
my_account_menu_navigation_notifications:"Notificaciones",
global_upgrade:"Upgrade",
my_account_menu_upgrade_container_get_the_school_edition:"Obt\u00e9n la Edici\u00f3n School",
my_account_profile_personal_form_subtitle:"Informaci\u00f3n personal",
my_account_profile_personal_form_first_name_label:"Nombre",
my_account_profile_personal_form_last_name_label:"Apellido",
my_account_profile_personal_form_email_label:"E-mail",
my_account_profile_personal_form_change_password_btn_text:"Cambiar contrase\u00f1a",
my_account_profile_personal_form_current_password_label:"Contrase\u00f1a actual",
my_account_profile_personal_form_new_password_label:"Nueva contrase\u00f1a",
my_account_profile_personal_form_confirm_new_password_label:"Confirmar Nueva Contrase\u00f1a",
global_saveChanges:"Guardar cambios",
my_account_profile_school_form_subtitle:"Informaci\u00f3n de la escuela",
my_account_profile_school_form_country_label:"Pa\u00eds",
my_account_profile_school_form_state_label:"Estado",
my_account_profile_school_form_state_placeholder:"Seleccionar Estado",
my_account_profile_school_form_city_label:"Ciudad",
my_account_profile_school_form_city_placeholder:"Ingresar ciudad",
my_account_profile_school_form_school_label:"Escuela",
my_account_profile_school_form_school_placeholder:"Ingrese nombre de la escuela",
my_account_profile_teacher_form_subtitle:"Informaci\u00f3n del Profesor",
my_account_profile_teacher_form_grades_label:"Niveles",
my_account_profile_teacher_form_grades_placeholder:"Seleccionar niveles",
my_account_profile_teacher_form_subjects_label:"Materias",
my_account_profile_teacher_form_subjects_placeholder:"Seleccionar materias",
vft_banner_content_text_title:"Presentando Nearpod Paseo Virtual",
vft_banner_content_text_subtitle:"Los paseos virtuales de Nearpod llevar\u00e1n a tu clase experiencias del mundo real que inspirar\u00e1n a tus estudiantes a aprender y reflexionar. ",
vft_banner_content_quote_img:"Mis estudiantes y yo estamos obsesionados con la funcionalidad Paseo Virtual ",
vft_banner_content_quote_text:"- Lisa B - Profesora de Ciencias Sociales, Pensilvania, EEUU",
vft_banner_content_video_error:"Tu explorador de internet no soporta este video.",
vft_header_logo_text:"Nearpod VR",
vft_pick_title:"\u00a1Arma una Excursi\u00f3n Virtual en 30 segundos!",
vft_pick_step1_title:"1. \u00bfA d\u00f3nde quieres ir?",
vft_pick_step2_title:"2. Agrega una pregunta de reflexi\u00f3n.",
global_create_your_lesson:"Crea tu lecci\u00f3n",
share_email:"Email",
share_social:"Redes",
share_link:"Link",
share_embed:"Insertar",
share_email_area_input_placeholder:"Email",
my_account_menu_upgrade_trial_link_free_gold:"Actualiza gratis a la Edici\u00f3n Gold",
my_account_menu_upgrade_trial_link:"\u00a1Obt\u00e9n otros 30 d\u00edas!",
admin_private_library_lessonAddedToFolder:"Tu lecci\u00f3n fue agregada a la carpeta",
admin_private_library_lessonsAddedToFolder:"Tus lecciones fueron agregadas a la carpeta",
private_library_search_noResults_1:"No hay lecciones que coincidan con tu b\u00fasqueda. Intenta con otra.",
private_library_folder_emptyMsg_1:"A\u00fan no hay lecciones en esta carpeta.",
private_library_folder_emptyMsg_2:"Agregar algunas.",
private_library_search_noResults_2:"otra b\u00fasqueda",
private_library_lessonsPicker_district_placeholder:"Buscar lecciones de la Biblioteca del Distrito...",
private_library_lessonsPicker_school_placeholder:"Buscar lecciones de la Biblioteca de la Escuela...",
private_library_find_lessons_tooltipText:"Usa los filtros y la barra de b\u00fasqueda para encontrar lecciones de tus profesores o en de la tienda Nearpod.",
private_library_find_lessons_tooltipButtonText:"\u00a1Entendido!",
private_library_folder_renamed:"La carpeta ha sido renombrada.",
my_account_profile_header_image_invalid_type:"Tipo de archivo inv\u00e1lido",
global_required:"Campo obligatorio.",
my_account_profile_personal_form_newPassword_confirm_not_match:"La contrase\u00f1a no coincide.",
global_form_email_too_long:"El email es muy largo (max. 80 caracteres)",
private_library_settings_district_edit_title:"Configuraciones de la Biblioteca del Distrito",
intercom_school_newMessage:"\u00a1Hola! Me interesa tener la Edici\u00f3n School.",
my_account_base_storage_you_have_used:"Has usado",
global_of:"de",
my_account_advanced_text_learn_more:"Aprende m\u00e1s",
my_account_advanced_confirm_message_notes:"Equipo de Nearpod: \\nEstoy interesado en saber m\u00e1s acerca de la nueva funcionalidad de Notas de estudiantes. Por favor contactarme con los pasos a seguir para obtener este beneficio para mi instituci\u00f3n. \u00a1Gracias!",
private_library_lessonAdded:"Lecci\u00f3n agregada",
mail_invalid_domain:"Por favor ingrese una direcci\u00f3n de email v\u00e1lida. ",
my_account_profile_header_image_uploading:"Subiendo...",
sidebar_menu_contact_us:"Cont\u00e1ctanos",
logIn_signUp_label:"\u00bfNo tienes un cuenta?",
signUp_logIn_label:"\u00bfYa tienes una cuenta?",
my_account_profile_header_image_mb:"MB",
themes_menu_tooltip:"\u00a1Agrega color y estilos a tus diapositivas usando temas!",
long_description_title_bundle:"Acerca de este Bundle",
logInNewPassword_title_2:"Por favor ingrese su nueva contrase\u00f1a.",
global_skip:"Saltar",
onboarding_welcome_line1:"Bienvenido a Nearpod,",
onboarding_welcome_line2:"Estamos muy contentos de que est\u00e9s aqu\u00ed. \u00danete a los cientos de miles de profesores que utilizan Nearpod para inspirar y motivar a sus estudiantes todo los d\u00edas.",
onboarding_welcome_line3:"Empecemos por buscar las lecciones perfectas para ti.",
onboarding_welcome_btn:"Buscar lecciones",
onboarding_step1_line1:"\u00bfQu\u00e9 a\u00f1o\/s ense\u00f1as?",
onboarding_step1_line2:"\u00a1Tenemos lecciones de Nearpod llenas de contenido como paseos virtuales y cuestionarios interactivos para todos los a\u00f1os!",
onboarding_step1_btn:"Siguiente",
onboarding_step2_line1:"\u00bfQu\u00e9 materia\/s ense\u00f1as?",
onboarding_step2_line2:"\u00a1Las lecciones de Nearpod est\u00e1n alineadas a los est\u00e1ndares curriculares de muchas materias y son creadas por editores y profesores expertos!",
onboarding_step2_btn:"\u00a1Adquirir lecciones!",
onboarding_step3_loading_text:"Espere un momentito... estamos buscando las mejores lecciones de Nearpod para ti.",
onboarding_lessons_line1:"\u00a1Listo! Mira estas lecciones que conseguimos para ti.",
onboarding_lessons_line2_part1:"Haz vista previa de estas lecciones y",
onboarding_lessons_line2_part2:"selecciona las tres que m\u00e1s te gusten",
onboarding_lessons_line2_part3:"para agregar GRATIS a tu Biblioteca!",
onboarding_preview_line1:"Est\u00e1s viendo c\u00f3mo los estudiantes ver\u00e1n la lecci\u00f3n en sus computadores o dispositivos m\u00f3viles.",
onboarding_preview_line2_part1:"\u00a1Nearpod es completamente",
onboarding_preview_line2_part2:"GRATIS",
onboarding_preview_line2_part3:"para los estudiantes!",
onboarding_toolbar_selectLessons_part1:"Selecciona",
onboarding_toolbar_selectLessons_part2_singular:"lecci\u00f3n m\u00e1s",
onboarding_toolbar_lessonsReady:"\u00a1Tus lecciones est\u00e1n listas para ser agregadas!",
onboarding_toolbar_btn:"Agrega a tu Biblioteca",
onboarding_toolbar_selectLessons_part2_plural:"lecciones m\u00e1s",
school_search_form_country_label:"Pa\u00eds",
school_search_form_state_label:"Estado",
school_search_form_state_placeholder:"Seleccionar estado",
school_search_form_city_label:"Ciudad",
school_search_form_city_placeholder:"Ingresar ciudad",
school_search_form_school_label:"Escuela",
school_search_form_school_placeholder:"Ingresar nombre de escuela",
admin_onboarding_welcome_start:"Empieza tu prueba de School!",
admin_onboarding_welcome_change:"No, esa no es mi escuela",
admin_onboarding_welcome_subtitle:"Selecciona tu escuela para empezar la prueba:",
admin_onboarding_start_trial_subtitle:"Explora los beneficios de la Edici\u00f3n School con tu agente de atenci\u00f3n personal.",
admin_onboarding_start_trial_btn:"Comienza!",
admin_onboarding_invite_teachers_title:"Invita profesores a unirse a tu prueba gratuita.",
admin_onboarding_invite_teachers_form_subtitle:"Recibir\u00e1n una invitaci\u00f3n para unirse a tu prueba gratuita.",
admin_onboarding_invite_teachers_form_first_name_placeholder:"Nombre Profesor",
admin_onboarding_invite_teachers_form_last_name_placeholder:"Apellido Profesor",
admin_onboarding_invite_teachers_form_email_placeholder:"Email Profesor",
admin_onboarding_invite_teachers_form_save:"Agregar colega",
admin_onboarding_invite_teachers_lonely_btn:"Est\u00e1 muy solitario aqu\u00ed.",
admin_onboarding_invite_teachers_add_btn:"+ Agrega m\u00e1s profesores",
admin_onboarding_invite_teachers_send_btn:"Enviar invitaciones",
admin_onboarding_invite_teachers_animation_title:"\u00a1Compartiendo con tus colegas!",
admin_onboarding_invite_teachers_animation_subtitle:"Tus profesores recibir\u00e1n claves para ingresar y podr\u00e1n disfrutar enseguida de los beneficios de la Edici\u00f3n School.",
admin_onboarding_invite_teachers_confirm_btn_one:"Enviar",
admin_onboarding_invite_teachers_confirm_btn_two:"Agregar m\u00e1s",
admin_onboarding_invite_teachers_confirm_title:"Est\u00e1s seguro de que no quieres invitar a m\u00e1s profesores?",
admin_onboarding_invite_teachers_confirm_message:"Te recomendamos tener al menos 3 profesores en tu escuela para obtener lo mejor de tu per\u00edodo de prueba.",
admin_onboarding_start_unlimited_title:"Empecemos a armar la Biblioteca de Escuela!",
admin_onboarding_start_unlimited_subtitle_part1:"La",
admin_onboarding_start_unlimited_btn:"Echemos un vistazo!",
admin_onboarding_share_lessons_select:"Selecciona al menos 3 lecciones",
admin_onboarding_share_lessons_ready:"Lecciones listas para agregarse a la Biblioteca de tu Escuela",
admin_onboarding_share_lessons_btn:"Compartir lecciones",
admin_onboarding_share_lessons_tooltip:"Tu Biblioteca de Escuela es una biblioteca central para que los profesores compartan lecciones entre ellos",
admin_onboarding_share_lessons_title:"Aqu\u00ed hay algunas de las mejores lecciones de Nearpod! Empieza a compartir!",
admin_onboarding_share_lessons_animation_title_part1:"Desbloqueando nuestra",
admin_onboarding_congratulations_title:"Felicitaciones! Tu Edici\u00f3n School est\u00e1 lista para un excelente comienzo!",
admin_onboarding_congratulations_subtitle:"Qu\u00e9 sigue?",
admin_onboarding_congratulations_contact_message:"Empecemos a charlar sobre buenas pr\u00e1cticas, capacitaciones personalizadas, y m\u00e1s.",
admin_onboarding_congratulations_contact_btn:"Chatea con un experto",
admin_onboarding_congratulations_lessons_btn:"Obt\u00e9n m\u00e1s lecciones gratuitas",
admin_onboarding_congratulations_lessons_message:"M\u00e1s de 7000 lecciones - todas disponibles gratis! Descarga todo lo que desees!",
admin_onboarding_congratulations_admin_btn:"Panel del Admin",
admin_onboarding_contact_form_text_is_required:"Texto requerido",
admin_onboarding_contact_form_phone_is_required:"Tel\u00e9fono requerido",
admin_onboarding_contact_form_last_name:"Apellido",
admin_onboarding_contact_form_phone_placeholder:"Tel\u00e9fono",
admin_onboarding_contact_form_email:"Email",
admin_onboarding_contact_form_text_label:"Con qu\u00e9 podemos ayudarte?",
admin_onboarding_contact_form_text_placeholder:"Texto",
admin_onboarding_contact_title_part1:"Hola",
admin_onboarding_contact_subtitle_part1:"Nos pondremos en contacto contigo en breve! Tambi\u00e9n puedes reservar una cita con tu agente de atenci\u00f3n al cliente.",
admin_onboarding_user_invite_hint_button:"Ok, entendido!",
admin_onboarding_toolbar_hint_text:"Haz clic aqu\u00ed cuando est\u00e9s listo para enviar tus invitaciones. Cuantas m\u00e1s, mejor!",
admin_onboarding_contact_form_first_name:"Primer Nombre",
admin_onboarding_user_invite_tooltip:"Ese eres t\u00fa! Ya est\u00e1s sumado a tu escuela de Nearpod como Admin.",
admin_onboarding_user_invite_hint_text:"Tus colegas ya est\u00e1n usando Nearpod - selecciona los profesores que quieres invitar a unirse a tu Edici\u00f3n School!",
admin_onboarding_welcome_title_before:"Obt\u00e9n",
admin_onboarding_welcome_title_after:"d\u00edas de prueba de la Edici\u00f3n School de Nearpod!",
admin_onboarding_start_trial_title_before:"Bienvenido a Edici\u00f3n School,",
admin_onboarding_start_trial_title_after:"!",
admin_onboarding_start_unlimited_text_part1:"Por cierto, tu escuela ahora tiene",
admin_onboarding_start_unlimited_text_part2:"acceso ilimitado y gratis",
admin_onboarding_start_unlimited_text_part3:"a m\u00e1s de 7000 lecciones de Nearpod!",
admin_onboarding_start_trial_text:"Hola! Comencemos con tu nueva prueba de Edici\u00f3n School.",
admin_onboarding_invite_teachers_form_title:"Agrega un colega a tu prueba de Edici\u00f3n School.",
admin_onboarding_invite_teachers_subtitle_part1:"Agregar hasta",
admin_onboarding_invite_teachers_subtitle_part2:"profesores",
admin_onboarding_invite_teachers_subtitle_part3:"a tu prueba de Edici\u00f3n School gratis.",
admin_onboarding_invite_teachers_toolbar_text:"invitaciones disponibles",
admin_onboarding_toolbar_tooltip_part1:"Preguntas? Ponte en contacto conmigo a:",
admin_onboarding_toolbar_tooltip_part2:"courtneym@nearpod.com",
admin_onboarding_toolbar_tooltip_part3:"o 855-632-7763",
admin_onboarding_toolbar_tooltip_part4:"ext. 2245",
admin_onboarding_share_lessons_subtitle_part1:"Agrega tantas lecciones como quieras a tu Biblioteca de Escuela - son todas gratis!",
admin_onboarding_share_lessons_subtitle_part2:"Biblioteca de Escuela de Nearpod",
binders_lessonCodes_title:"Esta lecci\u00f3n est\u00e1 asignada a m\u00e1s de una clase.",
binders_lessonCodes_subtitle:"Por favor ten en cuenta: Las lecciones pueden tomar hasta 10 min para lanzarse automaticamente",
binders_lessonCodes_sentColumn:"Tarea mandada el",
binders_lessonCodes_pincodeColumn:"C\u00f3digo de Clase",
binders_lessonCodes_availableColumn:"Disponible para",
binders_lessonNotes_missingLessons:"Por favor selecciona un n\u00famero de lecciones.",
binders_message_newBinder:"Felicitaciones! Ahora est\u00e1s listo para a\u00f1adir lecciones a tu Plan para Suplentes",
binders_message_notesSaved:"Tus Notas han sido guardadas!",
binders_message_subSent:"Felicidades! Tu Plan para Suplentes a sido enviado y las Lecciones lanzadas en el modo Estudiante.",
binders_lessons_info_admin:"Admin:",
binders_button_dashboard:"Panel de Tareas",
button_reports:"Reportes",
binders_sort_option_recent:"Reciente",
binders_button_sendSub:"Mandar Tarea",
binders_button_viewSub:"Ver Tarea",
binders_createModal_placeholder:"Ej: Ausencia por Enfermedad, Planes de Lectura de Emergencia...",
binders_lessons_picker_search_title:"Agrega lecciones de tu Biblioteca a",
binders_notesModal_lessons_1:"Una clase",
binders_notesModal_lessons_2:"Dos clases",
binders_notesModal_lessons_3:"Tres clases",
binders_notesModal_lessons_4:"Cuatro clases",
binders_notesModal_lessons_5:"Cinco clases",
binders_notes_lessons_title:"Cu\u00e1ntas clases deber\u00edan recibir esta lecci\u00f3n? Cada clase recibir\u00e1 un C\u00f3digo de Lecci\u00f3n diferente.",
binders_notes_lessons_placeholder:"Cu\u00e1ntas clases recibir\u00e1n la lecci\u00f3n asignada?",
binders_welcome_step1_title:"Ahora es tu turno! Enviar una muestra del Plan para Suplente a ti mismo ahora...",
binders_welcome_step2_title:"Ejemplos pueden incluir procedimientos de emergencia, notas de clase detalladas o mapas de asientos.",
global_close:"Cerrar",
binders_message_notesComplete:"Tus Notas han sido guardadas. Todas las lecciones han sido a\u00f1adidas con \u00e9xito a tu Plan para Substitutos!",
binders_npp_viewCodes:"Ver C\u00f3digos de Lecci\u00f3n.",
admin_onboarding_invite_animation_text:"Bienvenido a",
admin_onboarding_preview_line2:"Todas las lecciones son completamente gratuitas con tu Edici\u00f3n School.",
binders_message_subPlanSaved:"Tu Plan para Suplentes ha sido guardado.",
binders_message_requiredFields:"Por favor completa los siguientes campos obligatorios.",
binders_message_addLesson:"Debes agregar por lo menos una lecci\u00f3n a tu plan Sub.",
binders_message_subPlanSent:"Plan para Suplentes enviado!",
binders_message_firstSubPlan:"Felicitaciones! Ahora est\u00e1s listo para crear un Plan para Suplentes.",
binders_message_error:"Hubo un error",
binders_video_tooltip:"Click para saber m\u00e1s",
admin_onboarding_contact_top_title:"Aprovecha tu per\u00edodo de prueba al m\u00e1ximo consultando con tu agente de atenci\u00f3n personal de Nearpod.",
admin_onboarding_contact_form_role_title:"Rol",
admin_onboarding_contact_form_role_title_placeholder:"Selecciona un rol",
admin_onboarding_contact_form_phone_number:"N\u00famero de tel\u00e9fono (opcional)",
admin_onboarding_contact_form_days:"Mejores d\u00edas para ponernos en contacto?",
admin_onboarding_contact_form_days_placeholder:"Selecciona d\u00edas",
admin_onboarding_contact_form_times:"Mejor hora del d\u00eda para contactarnos (EST)",
admin_onboarding_contact_form_times_placeholder:"Selecciona horarios",
admin_onboarding_contact_form_discuss:"Qu\u00e9 querr\u00edas discutir?",
admin_onboarding_invite_teachers_form_first_name:"Nombre",
admin_onboarding_invite_teachers_form_last_name:"Apellido",
admin_onboarding_invite_teachers_form_email:"Email",
admin_onboarding_contact_form_day_monday:"Lunes",
admin_onboarding_contact_form_day_tuesday:"Martes",
admin_onboarding_contact_form_day_wednesday:"Mi\u00e9rcoles",
admin_onboarding_contact_form_day_thursday:"Jueves",
admin_onboarding_contact_form_day_friday:"Viernes",
admin_onboarding_toolbar_hint_button:"Ok, entendido!",
admin_onboarding_contact_form_validation_title:"Gracias!",
admin_onboarding_contact_form_validation_subtitle:"Nos pondremos en contacto contigo en breve.",
admin_onboarding_contact_form_validation_button:"Panel del Admin",
admin_onboarding_contact_title_part2:"encontremos un momento para hablar.",
admin_onboarding_contact_subtitle_part2:"Reserva aqu\u00ed:",
admin_onboarding_invite_teachers_toolbar_text_singular:"invitaci\u00f3n disponible",
admin_onboarding_contact_form_role_is_required:"Rol requerido",
admin_onboarding_contact_form_hours_are_required:"Horario requerido",
admin_onboarding_contact_form_days_are_required:"D\u00edas requerido",
admin_onboarding_invite_teachers_form_duplicated:"Email ya agregado",
admin_onboarding_contact_back_button:"Volver",
admin_onboarding_contact_subtitle_link:"https:\/\/app.grooveapp.com\/meetings\/valeriad\/30min",
admin_onboarding_toolbar_phone:"8556327763",
create_toolbar_help_placeholder:"Ay\u00fadanos a mejorar Nearpod enviando comentarios",
create_toolbar_help_button:"Comentarios",
help_box_error:"Por favor, escribe algo antes de enviar",
global_preview:"Vista previa",
drag_picker_text:"\u00a1Soltar archivos aqu\u00ed!",
global_show_more:"Mostrar m\u00e1s",
quiz_will_save_after_uploading:"El cuestionario se guardara luego de que los archivos se terminen de cargar...",
global_generic_error:"Algo fall\u00f3. Por favor intentar nuevamente.",
quiz_answers_limit:"Las preguntas pueden contener solo hasta 15 opciones de respuesta.",
quiz_questions_limit:"Los cuestionarios pueden tener hasta 50 preguntas. Si quieres agregar m\u00e1s preguntas, agrega un segundo cuestionario.",
quiz_answers_minimum:"Por favor incluye al menos dos opciones de respuesta.",
quiz_questions_minimum:"Tiene que haber por lo menos una pregunta para esta actividad.",
quiz_complete_fields:"Por favor completa los siguientes campos obligatorios.",
quiz_answer_drag_tooltip:"Arrastra para reordenar",
quiz_answer_delete_tooltip:"Borrar",
quiz_collapse:"Contraer todo",
quiz_expand:"Desplegar todos",
quiz_add_question:"+ Agregar pregunta",
quiz_question_drag_tooltip:"Arrastra para reordenar",
quiz_question_title_part1:"Pregunta",
quiz_question_title_part2:"de",
quiz_question_duplicate_tooltip:"Duplicar",
quiz_question_delete_tooltip:"Borrar",
quiz_question_textarea_placeholder:"Ingresa tu pregunta aqu\u00ed",
quiz_answer_textarea_placeholder:"Opci\u00f3n de respuesta",
quiz_add_answer:"+ Agregar respuesta",
global_image:"Imagen",
global_video:"Video",
global_audio:"Audio",
global_pdf_viewer:"Visualizador de PDF",
global_web_content:"Contenido Web",
quiz_question_add_reference:"Agregar referencia",
global_retry:"Reintentar",
share_email_checkbox_tooltip:"Esto agregar\u00e1 la lecci\u00f3n a la biblioteca de Nearpod del destinatario",
quiz_question_reference_media_upload_failed:"Falla en la carga",
admin_onboarding_welcome_confirm_subtitle:"Gracias por ingresar una nueva Escuela de Nearpod. Nuestro equipo est\u00e1 validando el ingreso en este momento y te enviar\u00e1 un email pronto para comenzar el per\u00edodo de prueba. Por favor ponte en contacto con support@nearpod.com si tienes alguna pregunta.",
signUp_form_recaptcha_error:"Por favor vuelve a introducir el captcha",
cart_button_decorator_cartButtonText_downloading:"Descargando",
storefront_success_update_notification:"Tu Librer\u00eda P\u00fablica ha sido actualizada",
binders_welcome_step0_title:"Este simple video te mostrar\u00e1 c\u00f3mo crear y enviar un Plan para Suplente con Nearpod.",
binders_welcome_step1_modal_title:"Enviar una muestra del Plan para Suplente a ti mismo",
binders_welcome_step1_modal_button:"Enviar Plan para Suplente",
storefront_remove_lesson_title:"Remover lecci\u00f3n",
storefront_remove_lesson_message:"Est\u00e1s seguro de querer remover esta lecci\u00f3n?",
storefront_remove_lesson_confirm:"Remover",
storefront_add_lessons_title:"Agregar Lecciones a Mi Librer\u00eda P\u00fablica",
storefront_add_lessons_subtitle:"Solo puedes agregar tus lecciones personalizadas a la librer\u00eda p\u00fablica",
quiz_service_error_message:"Lo sentimos, algo anduvo m\u00e1l. Por favor intenta de nuevo.",
admin_onboarding_start_unlimited_subtitle_part2:"Biblioteca de Escuela",
admin_onboarding_start_unlimited_subtitle_part3:"te permite compartir y organizar lecciones con toda tu escuela.",
storefront_add_lessons_placeholder:"Buscar en mis lecciones",
storefront_npp_hoverLayer_rearrange:"Arrastra para reordenar",
onboarding_back_to_lessons:"Volver",
private_library_name_folder_modal_name_1:"Nombrar Carpeta",
private_library_name_subfolder_modal_placeholder:"Subcarpeta Sin Nombre",
private_library_name_subfolder_modal_name:"Nombrar Subcarpeta",
admin_search_add_toolbar_button_dropdown_new_subfolder:"Nueva Subcarpeta",
private_library_breadcrumb_dropdown_rename_subfolder:"Renonmbrar Subcarpeta",
private_library_breadcrumb_dropdown_delete_subfolder:"Borrar Subcarpeta",
storefront_header_share_button:"Compartir",
storefront_header_date_prefix:"Desde",
storefront_header_introduction_placeholder:"Escribe una descripci\u00f3n sobre ti.",
storefront_header_introduction_expand_button:"Ver m\u00e1s",
storefront_header_introduction_collapse_button:"Ver menos",
storefront_header_lessons_title:"Lecciones",
storefront_header_grades_title:"Niveles",
storefront_header_subjects_title:"Materias",
storefront_header_grades_button:"Agregar niveles",
storefront_header_subjects_button:"Agregar Materias",
storefront_header_add_lessons_button:"Agregar Lecciones",
storefront_header_follow_button:"Seguir",
private_library_breadcrumb_dropdown_add_subfolder:"Agregar Subcarpeta",
header_library_publicLibrary:"Librer\u00eda P\u00fablica",
public_header_placeholder_join:"Ingresa el CODE",
public_header_signup:"Crear cuenta",
public_header_login:"Ingresa",
information_modal_title_join:"Informaci\u00f3n",
information_modal_message_join:"Por favor ingresa un CODE v\u00e1lido",
storefront_header_following_button:"Siguiendo",
private_library_settings_edit_toggle_district:"Permitir que los profesores agreguen a la Biblioteca del Distrito",
storefront_empty_view_text_owner:"Tu Librer\u00eda P\u00fablica est\u00e1 vac\u00eda.",
storefront_empty_view_text_visitor:"\u00a1El profesor no ha configurado su Librer\u00eda P\u00fablica todav\u00eda!",
user_loggedIn_confirm_title:"Primero debes registrarte",
user_loggedIn_confirm_message:"Para continuar, por favor ingresa o reg\u00edstrate.",
storefront_empty_view_button:"\u00a1Agregar Lecciones ahora!",
storefront_npp_hoverLayer_remove:"Remover",
storefront_npp_hoverLayer_preview:"Vista previa",
storefront_header_empty_stat:"Ninguna",
storefront_header_followers:"Seguidores",
storefront_header_downloads:"Descargas",
add_to_subfolder_title:"Agregar a la Subcarpeta",
add_to_subfolder_new_folder_link:"Crear una nueva Subcarpeta",
remove_from_subfolder_title:"Sacar de la Subcarpeta",
quiz_cancelConfirm:"\u00bfEst\u00e1s seguro de querer cancelar? Perder\u00e1s tus cambios.",
cart_button_hoverLayer_added:"\u00a1Lecci\u00f3n agregada!",
draw_it_will_save_after_uploading:"La actividad de dibujos ser\u00e1 guardada cuando los archivos se terminen de cargar.",
draw_it_instructions_placeholder:"Instrucciones (opcional)",
npp_label_new_lesson:"\u00a1Nueva Lecci\u00f3n!",
npp_label_new_bundle:"\u00a1Nuevo Bundle!",
npp_label_new_lesson_added:"\u00a1Nueva Lecci\u00f3n Agregada!",
npp_label_new_lessons_added:"\u00a1Nuevas Lecciones Agregadas!",
draw_it_drag_and_drop_message:"Los alumnos pueden dibujar sobre un canvas vac\u00edo si no hay una im\u00e1gen de fondo cargada.",
draw_it_drag_and_drop_button:"Cargar im\u00e1gen de fondo",
picker_connector_or:"o",
picker_audio_title:"Carga tus audios",
picker_options_title:"Escoge alguna de estas opciones",
picker_audio_recorder_title:"Graba tu audio.",
picker_gif_title:"Carga tus Gifs",
picker_gif_search_placeholder:"Buscar Gifs con Google SafeSearch",
picker_image_title:"Cargar tus im\u00e1genes",
picker_image_search_placeholder:"Buscar im\u00e1genes con Google SafeSearch",
picker_pdf_title:"Cargar tus PDFs",
picker_video_title:"Cargar tus videos",
picker_video_search_placeholder:"Buscar videos con YouTube Safe Search",
picker_webpage_title:"Carga tu contenido web",
picker_webpage_error_invalid_url:"Por favor incluir un URL v\u00e1lido.",
picker_webpage_error_invalid_website:"Por favor introducir un sitio web v\u00e1lido.",
picker_webpage_subtitle:"Introduce el URL del sitio web que los estudiantes ver\u00e1n.",
picker_webpage_test_link:"Prueba este link.",
picker_webpage_add_anyway:"Agregar a mi presentaci\u00f3n de todas maneras",
picker_webpage_note_part1:"Por favor tener en cuenta que los sitios web con Flash no funcionar\u00e1n en dispositivos iOS.",
picker_webpage_note_part2:"Recuerda: algunos sitios web pueden est\u00e1r bloqueados por tu escuela.",
draw_it_cancelConfirm:"\u00bfEst\u00e1s seguro de querer cancelar? Perder\u00e1s tus cambios.",
privateLibrary_admin_lessonAddedGoToLibrary:"Administrar",
privateLibrary_admin_lessonAddedStayExplore:"Ver Biblioteca",
privateLibrary_admin_lessonAddedToDistrict:"\u00a1Tu lecci\u00f3n fue agregada a la Biblioteca del Distrito! \u00bfQuieres administrar o ver la Biblioteca del Distrito ahora?",
privateLibrary_admin_lessonAddedToSchool:"\u00a1Tu lecci\u00f3n fue agregada a la Biblioteca de la Escuela! \u00bfQuieres administrar o ver la Biblioteca de la Escuela ahora?",
privateLibrary_cantAddLessonMessage:"Esta lecci\u00f3n ya est\u00e1 en la ",
preview_toolbar_districtLibrary:"Biblioteca del Distrito",
preview_toolbar_schoolLibrary:"Biblioteca de la Escuela",
binders_notesModal_lessons_6:"Seis clases",
binders_notesModal_lessons_7:"Siete clases",
binders_notesModal_lessons_8:"Ocho clases",
binders_notesModal_lessons_9:"Nueve clases",
binders_notesModal_lessons_10:"Diez clases",
cart_not_enough_space_intercom_message:"",
poll_cancelConfirm:"\u00bfEst\u00e1s seguro de querer cancelar? Perder\u00e1s tus cambios.",
poll_will_save_after_uploading:"La encuesta se guardar\u00e1 cuando los archivos terminen de subir.",
create_toolbar_settings:"Ajustes",
private_library_bundleAdded:"Bundle agregado",
private_library_bundleDeleted:"Bundle eliminado",
delete_bundle_title:"Eliminar Bundle",
delete_bundle_message:"\u00bfConfirma que desea eliminar este bundle?",
poll_save_settings_success:"\u00a1Ajustes actualizados correctamente!",
student_join_title:"",
multiple_school_libraries_dropdown_settings:"Configurar",
multiple_school_libraries_dropdown_switch:"Cambiar Biblioteca",
multiple_school_libraries_switch_modal_title:"Ver Biblioteca de Escuela",
poll_settings_message:"Permitir que los estudiantes seleccionen m\u00faltiples opciones",
poll_settings_button_save:"Guardar",
multiple_school_libraries_switch_modal_placeholder:"Nombre de la Escuela",
studentJoin_explanation_ios:"Obt\u00e9n un CODE de tu profesor para unirte a una presentaci\u00f3n.",
studentJoin_dontHaveAPin_ios:"O escribe \"MAGIC\" para probar Nearpod a tu propio ritmo.",
public_header_placeholder_join_ios:"Ingresa el CODE",
privateLibrary_admin_bundleAddedToSchool:"\u00a1Tu bundle fue agregado a la Biblioteca de la Escuela! \u00bfQuieres administrar o ver la Biblioteca de la Escuela ahora?",
privateLibrary_admin_bundleAddedToDistrict:"\u00a1Tu bundle fue agregado a la Biblioteca del Distrito! \u00bfQuieres administrar o ver la Biblioteca del Distrito ahora?",
school_onboarding_overlay:"\u00a1Bienvenido a tu Biblioteca de la Escuela!",
matching_pairs_back_to_results:"Volver a los resultados",
matching_pairs_dashboard_student:"Estudiante",
matching_pairs_dashboard_matches
:"Coincidencias",
matching_pairs_dashboard_tries:"Intentos",
matching_pairs_ct_add_pair:"Agregar par",
matching_pairs_ct_add_pair_error:"Por favor incluya 2 pares de items",
matching_pairs_dashboard_view_pairs:"Ver pares",
matching_pairs_zoom_tooltip
:"",
matching_pairs_zoom_tooltip_confirm:"",
matching_pairs_settings_title:"Configuraci\u00f3n de Buscando pares",
matching_pairs_settings_cancel
:"Cancelar",
matching_pairs_settings_confirm
:"Salvar",
matching_pairs_ct_instructions
:"Instrucciones (opcional)",
matching_pairs_ct_title
:"Buscando pares",
matching_pairs_ct_input_add_image:"Agregar una imagen",
matching_pairs_ct_input_add_text:"Ingrese texto",
matching_pairs_ct_input_add_or:"o",
matching_pairs_ct_delete_pair:"Borrar par",
matching_pairs_ct_add_another_pair
:"Agregar otro par",
matching_pairs_service_error
:"Lo siento, algo sali\u00f3 mal. Por favor, intenta nuevamente.",
matching_pairs_back:"Volver a los pares",
matching_pairs_well_done
:"\u00a1Bien hecho!",
matching_pairs_student_complete:"Puede revisar los pares correctos o continuar con la lecci\u00f3n.",
matching_pairs_student_wait:"Espere a que su profesor contin\u00fae con la lecci\u00f3n.",
matching_pairs_student_confirm:"Entendido",
matching_pairs_ct_delete_cancel:"Cancelar",
matching_pairs_ct_delete_title
:"Borrar par",
matching_pairs_ct_delete_confirmation_title:"\u00bfEst\u00e1 seguro?",
matching_pairs_ct_delete_confirmation_information:"Este par ser\u00e1 eliminado permanentemente",
matching_pairs_service_pair_added:"El par se ha a\u00f1adido con \u00e9xito.",
matching_pairs_service_pair_error:"Por favor, rellene los campos obligatorios a continuaci\u00f3n.",
matching_pairs_settings_random_prompt:"Colocaci\u00f3n aleatoria de fichas para cada estudiante. Esto evita que los estudiantes copien de los estudiantes que est\u00e1n sentados a su lado.",
matching_pairs_settings_random_title:"Aleatorizar fichas",
matching_pairs_pairs:"Pares",
matching_pairs_ct_done:"Hecho",
matching_pairs_ct_delete_confirm:"Borrar",
global_joinASession_ios:"\u00danete a una sesi\u00f3n",
header_reports_link:"Reportes",
header_learn_link:"Aprender",
privateLibrary_cantAddBundleMessage:"Este bundle ya est\u00e1 en la ",
cart_button_decorator_cartButtonText_preview:"Vista Previa",
private_library_lesson_added_to_single_library:"Lecci\u00f3n Agregada a la Biblioteca de la Escuela",
private_library_lesson_added_to_multiple_libraries:"Lecciones Agregadas a todas las Bibliotecas de las Escuelas",
private_library_lessons_added_to_single_library:"Lecciones Agregadas a la Biblioteca de la Escuela",
private_library_lessons_added_to_multiple_libraries:"Lecciones Agregadas a todas las Bibliotecas de las Escuelas",
addLessons_multipleSchools_modal_title:"\u00bfQuieres agregar estas Lecciones a todas las Bibliotecas de las Escuelas?",
addLesson_multipleSchools_modal_title:"\u00bfQuieres agregar esta Lecci\u00f3n a todas las Bibliotecas de las Escuelas?",
district_onboarding_overlay:"\u00a1Bienvenido a tu Biblioteca del Distrito!",
delete_bundle_multiple_school_message:"\u00bfQuieres Eliminar el Bundle de todas las Bibliotecas de Escuela?",
delete_lesson_multiple_school_message:"\u00bfQuieres Eliminar la Lecci\u00f3n de todas las Bibliotecas de Escuela?",
delete_single_library_option:"Solo \u00c9sta Biblioteca",
delete_multiple_libraries_option:"Borrar De Todas",
private_library_bundle_multipleLibraries_deleted:"Bundle eliminado de todas las Bibliotecas de Escuela",
private_library_lesson_multipleLibraries_deleted:"Lecci\u00f3n removida de todas las Bibliotecas de Escuela",
header_HowItWorks_link:"\u00bfComo funciona?",
header_ForStudents:"Estudiantes",
header_EnterCODEToJoinALesson_placeholder:"Ingresar CODE",
header_SignIn_link:"Ingresar",
header_SignUpForFree_link:"Crear cuenta gratis",
header_ExploreLessons_link:"Explorar",
poll_settings_description:"Si no se selecciona, la respuesta de la encuesta se limitar\u00e1 a una sola opci\u00f3n por alumno.",
poll_edit_settings_modal_title:"Ajustes de la encuesta",
verify_account_text_part1:"Acabamos de enviarte un correo electr\u00f3nico para verificar tu cuenta",
verify_account_text_part3
:":",
verify_account_text_part2:"Nearpod",
create_your_own_lesson_text:"Crea tu propia presentaci\u00f3n",
explore_our_lessons_and_one_free_text:"Explora nuestras presentaciones y obtiene una GRATIS",
explore_our_lessons_text:"Explora nuestras presentaciones",
matching_pairs_ct_pair_added:"Par agregado exitosamente",
matching_pairs_ct_complete:"Por favor completa los siguientes campos obligatorios.",
matching_pairs_ct_delete_removed:"El par fue removido exitosamente",
matching_pairs_ct_addTextImage:"Agregar texto o imagen",
matching_pairs_ct_pair:"Par",
matching_pairs_countdown_letsGo:"Vamos",
timer_modal_title:"Temporizador de actividad",
timer_modal_text:"Sus estudiantes tendr\u00e1n esta cantidad de tiempo para completar la actividad.",
timer_modal_minutes:"min",
timer_modal_seconds:"seg",
timer_modal_cancel:"Cancelar",
timer_modal_add:"Agregar",
matching_pairs_preview_back:"Volver a los pares",
matching_pairs_preview_title:"Pares",
timer_addBtn:"Temporizador",
activity_timer_timeIsUp:"\u00a1Tiempo agotado!",
matchingPairs_timer_answersSubmitted:"\u00a1Tu respuesta ha sido enviada!",
activity_timer_timeFor:"\u00a1Tiempo de",
activity_timer_youWillHave:"Tendr\u00e1s",
activity_timer_readySet:"Espera tu profesor. Preparado, listo...",
activity_timer_min:"min",
activity_timer_sec:"seg",
matchingPairs_timer_answersSubmitted2:"Por favor espera a tu profesor para continuar.",
activity_timer_timeForMatchingPairs2:"Buscando Pares!",
timer_startActivityBtn:"Iniciar actividad",
matchingPairs_wellDone_tries:"Intentos",
matching_pairs_dashboard_title:"Resultados de la clase",
private_library_npp_nearpodlibrary:"NP Lesson Library",
main_header_dropdown_nearpodLibrary:"Biblioteca de Nearpod",
private_library_find_lessons_tooltipText2:"Usa los filtros y la barra de b\u00fasqueda para encontrar lecciones de tus profesores o en de la librer\u00eda Nearpod.",
my_library_lessons_title:"Mis Presentaciones",
my_library_tips_and_tricks_title:"Consejos Y Trucos",
lessons_list_header_sort_title:"Ordenar por:",
my_library_name_folder_modal_placeholder:"Carpeta sin t\u00edtulo",
my_library_name_folder_modal_title:"Nombrar Carpeta",
my_library_name_folder_modal_creating:"Creando...",
my_library_name_folder_modal_renaming:"Renombrando....",
my_library_name_folder_modal_rename:"Renombrar",
share_google:"Google Classroom",
share_remind:"Remind",
lessons_list_npp_long_label_view_only:"Solo Vista",
lessons_list_npp_long_label_unsaved:"Sin Guardar",
lessons_list_npp_live_session_tooltip:"Desl\u00edzate sobre la imagen de la lecci\u00f3n para lanzarla. Selecciona \"Vista Previa\" para verla antes de lanzarla.",
lessons_list_npp_status_removing:"Quitando",
lessons_list_npp_status_deleting:"Eliminando",
lessons_list_npp_status_saving:"Guardando",
lessons_list_npp_preview:"Vista Previa",
lessons_list_npp_action_save_changes:"Guardar Cambios",
lessons_list_npp_action_start_training:"Comenzar Entrenamiento",
lessons_list_npp_action_student_paced:"Student-Paced",
lessons_list_npp_action_live_lesson:"Sesi\u00f3n Live",
lessons_list_npp_action_view:"Ver",
npp_grades:"Niveles",
npp_free:"Gratis",
lessons_list_npp_live_session_tooltip_button:"\u00a1Ok, entendido!",
lessons_list_header_action_share:"Compartir",
lessons_list_header_action_remove:"Eliminar",
lessons_list_header_action_add_lessons:"Agregar Lecciones",
lessons_list_header_action_rename:"Renombrar",
lessons_list_more_actions_school_library_label:"Biblioteca de la Escuela",
lessons_list_more_actions_district_library_label:"Biblioteca del Distrito",
lessons_list_more_actions_public_library_label:"Librer\u00eda P\u00fablica",
lessons_list_more_actions_folder_label:"Carpeta",
lessons_list_more_actions_duplicate_label:"Duplicar",
lessons_list_more_actions_add_label:"Agregar a",
lessons_list_more_actions_add_district_library_label:"Agregar a Biblioteca de Distrito",
lessons_list_more_actions_add_school_library_label:"Agregar a Biblioteca de Escuela",
lessons_list_more_actions_add_folder_label:"Agregar a Carpeta",
lessons_list_more_actions_remove_folder_label:"Eliminar de la Carpeta",
lessons_list_more_actions_export_pdf_label:"Exportar PDF",
lessons_list_more_actions_reports_label:"Reportes",
lessons_list_more_actions_delete_label:"Eliminar",
my_library_student_paced_launch_modal_valid_from:"V\u00e1lido desde",
my_library_student_paced_launch_modal_valid_to:"hasta",
homework_share_code_text:"\u00danete con este CODE en Nearpod.com o en la app",
my_library_launch_session_date_title:"Lanzado en",
my_library_launch_session_code_title:"CODE",
my_library_launch_session_expire_title:"Expira en",
my_library_launch_session_date_text:"a la\/s",
my_library_launch_live_session_new:"Lanza una nueva lecci\u00f3n live",
my_library_launch_live_session_resume:"Resumir",
my_library_launch_student_paced_new:"Lanza nueva lecci\u00f3n Student-paced",
my_library_launch_student_paced_share:"Compartir",
my_library_launch_session_title:"Esta lecci\u00f3n tiene m\u00e1s de una sesi\u00f3n activa. \u00bfQu\u00e9 deseas hacer?",
my_library_launch_session_subtitle:"\u00bfO retomar una de estas sesiones activas?",
my_library_delete_lesson_message_1:"\u00bfEst\u00e1s seguro de que deseas borrar esta Student-paced?",
my_library_delete_lesson_message_2:"Borrar esta lecci\u00f3n har\u00e1 que se borren todos los reportes, expiren todos los CODES activos y la quitar\u00e1 de todas las carpetas y Librer\u00eda P\u00fablica.",
my_library_delete_lesson_message_3:"Borrar esta lecci\u00f3n har\u00e1 que se borren todos los reportes, expiren todos los CODES activos y la quitar\u00e1 de todas las carpetas.",
my_library_edit_store_lesson_message:"Para conservar una copia del original, duplica la lecci\u00f3n antes de editarla.",
my_library_edit_store_lesson_title:"Est\u00e1s por editar una lecci\u00f3n descargada.",
my_library_edit_store_lesson_button_2:"Duplicar Lecci\u00f3n",
my_library_edit_store_lesson_button_1:"Editar Lecci\u00f3n",
my_library_export_pdf_message:"Guardar PDF en",
my_library_export_pdf_local_drive:"Mi Dispositivo",
my_library_export_pdf_google_drive:"Google Drive",
my_library_active_session_message:"Esta lecci\u00f3n ya tiene una sesi\u00f3n activa. \u00bfDeseas reanudarla?",
my_library_added_to_private_library_message_part_1:"\u00a1Tu lecci\u00f3n fue agregada a la",
my_library_added_to_private_library_message_part_2:"! \u00bfQuieres ver la lecci\u00f3n en la",
my_library_added_to_private_library_button_1:"Ver Biblioteca",
my_library_added_to_private_library_button_2:"Permanecer Aqu\u00ed",
my_library_remove_folder_message:"\u00bfEst\u00e1s seguro de que deseas borrar esta carpeta? Todas tus lecciones van a permanecer en tu biblioteca.",
my_library_remove_folder_title:"Borrar Carpeta",
my_library_remove_from_folder_title:"Eliminar lecci\u00f3n",
my_library_remove_from_folder_message:"\u00bfEst\u00e1s seguro de que deseas eliminar esta presentaci\u00f3n de la carpeta?",
my_library_remove_from_folder_button:"Eliminar",
my_library_save_confirm_message:"Una lecci\u00f3n debe tener al menos 2 diapositivas",
my_library_save_lesson_message:"Por favor guarda los cambios a esta lecci\u00f3n antes de agregarla a la",
my_library_school_library:"Biblioteca de la Escuela",
my_library_district_library:"Biblioteca del Distrito",
my_library_added_to_private_library_message_part_3:"ahora?",
my_library_add_lesson_public_library_fail:"Est\u00e1 lecci\u00f3n ya est\u00e1 en tu Librer\u00eda P\u00fablica",
my_library_add_lesson_public_library_success:"Lecci\u00f3n agregada a tu Librer\u00eda P\u00fablica",
my_library_add_lesson_private_library_success:"Lecci\u00f3n agregada a tu",
my_library_add_lesson_private_library_error:"Esta lecci\u00f3n ya est\u00e1 en la",
my_library_delete_folder_success:"ELIMINADA",
my_library_delete_folder_fail:"FALL\u00d3",
preview_right_panel_related_content:"Contenido Relacionado",
preview_toolbar_save_lesson:"Guardar Lecci\u00f3n",
school_trial_welcome_title_part1:"\u00bfListo para explorar las experiencias de aprendizaje interactivo que a sus alumnos les encantar\u00e1n?",
school_trial_welcome_subtitle:"\u00bfEs tu escuela",
school_trial_welcome_confirm_school_yes:"S\u00ed, esta es mi escuela",
school_trial_welcome_confirm_school_no:"No, esa no es mi escuela",
school_experiment_email_sent:"Gracias por hacernoslo saber. Nos comunicaremos pronto.",
school_experiment_school_not_found:"\u00a1Haznos saber!",
school_experiment_school_updated:"\u00a1Gracias! Tu Escuela ha sido agregada a tu perfil.",
admin_onboarding_express_gotit_thanks:"Entendido, gracias",
my_library_no_lessons_result:"Hola! Tienes lecciones maravillosas en tu librer\u00eda pero ninguna con",
my_library_no_lessons_result_link:"Intenta explorando nuestra tienda.",
school_trial_onboarding_start_trial_title_before:"Incre\u00edble,",
school_trial_onboarding_start_trial_title_after:"agreguemos algunos de tus colegas",
school_trial_onboarding_start_trial_text:"Nearpod",
school_trial_onboarding_start_trial_text_part2:"\u00a1es mejor juntos!",
school_trial_onboarding_start_trial_btn:"Invita Colegas",
school_experiment_modal_title:"Nearpod funciona mejor juntos.",
school_experiment_modal_submit:"Enviar",
admin_onboarding_confirm_school_success_title_part1:"\u00a1Oh no!",
admin_onboarding_confirm_school_success_message_part1:"\u00a1Nearpod",
admin_onboarding_confirm_school_success_textButton:"",
admin_onboarding_confirm_school_error_message_part1:"No te preocupes.",
admin_onboarding_confirm_school_error_title_part1:"\u00a1Oh no!",
admin_onboarding_confirm_school_error_subtitle:"Pensamos que estabas en otra Escuela",
admin_onboarding_confirm_school_error_textButton:"Regresar a Mi Biblioteca",
admin_onboarding_express_congrats_title:"Lo lograste!",
admin_onboarding_express_congrats_subtitle:"Ahora puedes descargar cualquiera de nuestras 7000+ presentaciones interactivas y personalizarlas con tu contenido.",
admin_onboarding_express_congrats_button_text:"Ll\u00e9vame a mi escuela",
admin_onboarding_express_congrats_text_part1:"Notificaciones",
school_trial_welcome_title_part2:"Para comenzar, solo necesitamos",
admin_onboarding_confirm_school_success_title_part2:"Parece que algo no est\u00e1 bien...",
sort_options_date:"Agregadas recientemente",
sort_options_name:"Nombre",
sort_options_author:"Autor\/a",
sort_options_size:"Tama\u00f1o",
admin_onboarding_confirm_school_success_message_part2:"es mejor juntos!",
admin_onboarding_confirm_school_error_message_part2:"Nuestro equipo de soporte est\u00e1 en ello. ",
admin_onboarding_confirm_school_error_title_part2:"Parece que algo no est\u00e1 bien...",
school_experiment_modal_subtitle:"Cu\u00e9ntanos sobre tu escuela para difundir el amor.",
admin_onboarding_welcomeSchool_title_part1:"",
admin_onboarding_welcomeSchool_title_part2:"",
admin_onboarding_welcomeSchool_message:"",
admin_onboarding_welcomeSchool_textButton:"",
school_free_trial_modal_subtitle_part1:"Calificas para una Cuenta Escolar",
school_free_trial_modal_title:"\u00a1Felicitaciones!",
school_free_trial_modal_subtitle_part3:" ",
school_free_trial_modal_subtitle_part2:"GRATUITA",
admin_onboarding_express_invite_title:"Comparte con tus colegas",
admin_onboarding_express_invite_subtitle:"Selecciona colegas con cuentas Nearpod",
admin_onboarding_express_invite_button:"+ Invitar",
admin_onboarding_express_select_colleagues:"Selecciona tus colegas",
admin_onboarding_express_select_colleagues_singular:"colega seleccionado",
admin_onboarding_express_select_colleagues_plural:"colegas seleccionados",
admin_onboarding_express_add_colleague:"Agrega a un colega a tu Escuela",
admin_onboarding_express_colleague_invitation:"Ser\u00e1n invitados a unirse a Nearpod con acceso a m\u00e1s de 7000 lecciones",
school_free_trial_modal_description_part1:"Vamos a seguir todos los pasos para ayudarte a obtener tu Escuela en",
school_free_trial_modal_description_part2:"Nearpod",
school_free_trial_modal_button:"Empezar",
school_free_trial_modal_link:"No, gracias.",
audio_not_supported:"",
video_not_supported:"Su navegador no soporta la etiqueta de video.",
admin_onboarding_express_congrats_text_part2:"aparecer\u00e1 para guiarlo hacia funciones importantes durante su prueba gratuita.",
search_standard_placeholder:"Selecciona un Standard",
btn_copy_text:"Copiar",
verify_account_text_part4:"Por favor, inicia sesi\u00f3n con",
verify_account_text_part5:"y haz click en el enlace que te enviamos!",
verify_account_text_part6:"Una vez verificada, \u00a1tu cuenta estar\u00e1 configurada para usar y explorar!",
verify_account_text_placeholder:"tu direcci\u00f3n de email",
admin_onboarding_invite_teachers_title_part1:"\u00a1Estupendo! \u00bfSab\u00edas que",
admin_onboarding_invite_teachers_title_part2:"colegas en tu escuela tambi\u00e9n est\u00e1n usando Nearpod?",
admin_onboarding_invite_teachers_message_part1:"Nearpod",
admin_onboarding_invite_teachers_message_part2:"es mejor juntos!",
admin_onboarding_invite_teachers_textButton:"Compartir con colegas",
admin_onboarding_invite_teachers_title2:"\u00a1Comparte las m\u00e1s de 7,000 lecciones con tus colegas!",
admin_onboarding_skip_this_button:"Saltar",
admin_onboarding_user_invited_tag:"(Invitado)",
webpage_youCanNow_ios:"",
webpage_share_ios:"",
webpage_openSafari_ios:"",
webpage_openBrowser_android:"",
admin_onboarding_express_text:"Algunos de tus colegas no tienen cuentas Nearpod? No hay problema.",
admin_onboarding_outcome_refer_button:"Referir un Contacto",
admin_onboarding_outcome_title_part1:"\u00bfDeseas que esto dure m\u00e1s que el per\u00edodo de prueba de 60 d\u00edas?",
admin_onboarding_outcome_title_part2:"Dinos a qui\u00e9n contactar para hacerlo.",
admin_onboarding_refer_title:"Referir un Contacto",
admin_onboarding_refer_subtitle:"Nos cont\u00e1ctaremos para hacer esto posible",
admin_onboarding_refer_button:"Enviar a Nearpod",
admin_onboarding_express_congrats_button:"Explora las Lecciones",
global_form_rolIsRequired:"El rol es obligatorio",
admin_onboarding_share_lessons_animation_title_part2:"Librar\u00eda de Presentaciones de Nearpod...",
school_trial_welcome_title_part3:"que confirmes tu escuela.",
school_experiment_modal_no_thanks:"No, gracias",
admin_onboarding_invite_colleagues_share:"Compartir",
lms_confirm_button:"Si, entiendo",
lms_confirm_text_part1:"Est\u00e1 a punto de vincular permanentemente su cuenta de",
global_poll:"Encuesta",
admin_onboarding_express_join_your_colleagues:"\u00danete a tus colegas",
admin_onboarding_express_join:"\u00danete",
admin_onboarding_join_colleagues_animation_title:"\u00a1Uni\u00e9ndote a tus colegas!",
school_user_onboarding_invite_title:"\u00danase a sus colegas",
school_user_onboarding_invite_subtitle:"\u00danete a tus colegas con cuentas de Nearpod",
lms_confirm_text_part2:"a una cuenta de Nearpod. Aseg\u00farese de iniciar sesi\u00f3n en una cuenta de Nearpod con licencia de Escuela o Distrito para utilizar esta integraci\u00f3n.",
poll_submit_confirm_title:"\u00a1Espera!",
poll_submit_confirm_text:"\u00bfQuieres enviar esta respuesta?",
poll_submit_confirm_empty_actionone_text:"Revisar Respuestas",
poll_submit_confirm_actiontwo_text:"Si, Enviar",
poll_submit_confirmed_title:"\u00a1Listo!",
poll_submit_confirmed_text:"Tu respuesta ha sido enviada.",
poll_submit_confirmed_actionone_text:"Editar Respuesta",
poll_submit_confirmed_empty_actiontwo_text:"Enviar",
poll_submit_confirm_empty_text:"No has respondido la pregunta.",
student_slide_selector_multianswer_text:"Selecciona una o m\u00e1s respuestas",
student_slide_selector_oneanswer_text:"Selecciona una respuesta",
admin_onboarding_invite_teachers_title_part2_singular:"colega en tu escuela tambi\u00e9n est\u00e1 usando Nearpod?",
admin_onboarding_refer_animation_title:"Enviando el contacto a Nearpod...",
school_user_onboarding_invite_teachers_title2:"\u00a1\u00danete a toda la colecci\u00f3n de experiencias de aprendizaje interactivas!",
school_user_onboarding_invite_teachers_textButton:"Ver tus Colegas",
cacophony_video_paused:"Este video esta pausado en este dispositivo.",
cacophony_audio_paused:"Este audio esta pausado en este dispositivo.",
student_slide_selector_selected_text:"respuesta(s) seleccionada",
code_list_remaining:"restante\/s",
code_list_tooltip:"Haz click aqu\u00ed para ajustar la fecha de expiraci\u00f3n de este CODE",
my_library_launch_student_paced_subtitle:"O comparte alguna de estas sesiones activas",
main_header_dropdown_nearpodLessonLibrary:"Nearpod Lesson Library",
binders_message_durationExceeded:"Los Planes para Suplentes solo pueden ser enviados dentro de 365 de ausencia",
global_quiz:"Cuestionario",
aox_form_user_in_another_school:"Este profesor ya es parte de otra escuela.",
quiz_questions:"preguntas",
quiz_question_number_text:"Pregunta",
unlock_lessons_modal_title1:"Desbloquear Lecciones de Ejemplo",
unlock_lessons_modal_title2:"Lecciones de Ejemplo",
unlock_lessons_modal_message_part1:"El paquete suplementario se encuentra disponible para licencias de Escuela o Distrito, pero podr\u00e1s acceder a las lecciones de ejemplo ",
unlock_lessons_modal_message_part2:" GRATIS!",
unlock_lessons_modal_button_text:"Desbloquear Lecciones",
unlock_lessons_modal_textLink:"Leer m\u00e1s",
quiz_submit_confirm_empty_question_text:"Algunas preguntas no fueron respondidas.",
quiz_submit_confirm_empty_actionone_text:"Revisar respuestas",
quiz_submit_confirm_empty_actiontwo_text:"Enviar",
poll_timeFor_title:"una Encuesta",
quiz_intro_title:"Cuestionario",
quiz_intro_question:"Pregunta",
global_next:"Siguiente",
my_library_no_lessons_result_link_2:"Intenta explorando la Librer\u00eda de Lecciones de Nearpod.",
qa_submit_confirm_empty_actionone_text:"Revisar Respuesta",
qa_submit_confirm_empty_question_text:"La pregunta no fue respondida.",
oeq_intro_title:"Pregunta abierta",
oeq_answerPlaceholder:"\u00bfListo? Ingresa tu respuesta aqu\u00ed.",
btn_copy_text_copied:"Copiado!",
pdf_title_ios:"",
quiz_submit_confirmed_title:"\u00a1Listo!",
quiz_submit_confirmed_text:"Tu respuesta ha sido enviada.",
quiz_submit_confirmed_actionone_text:"Editar Respuesta",
login_sso_error_confirm_button:"\u00a1Entendido!",
login_sso_error_message_lti:"Esta cuenta tiene una licencia incorrecta. Por favor ingresa con una cuenta de Nearpod con licencia de tipo Escuela o Distrito.",
sign_up_title:"Transformando la Ense\u00f1anza. Juntos.",
sign_up_subtitle:"Lecciones de K-12 listas para lanzar usando una plataforma interactiva ganadora de premios",
sign_up_find_or_create_title:"Encuentra o crea lecciones",
sign_up_find_or_create_subtitle:"Nuestra selecta librer\u00eda tiene algunas de las mejores lecciones listas para ense\u00f1ar",
sign_up_interact_students_title:"Interact\u00faa con tus estudiantes",
sign_up_interact_students_subtitle:"Elige actividades para interactuar con tus estudiantes en cualquier dispositivo",
sign_up_students_reports_title:"Conoce el razonamiento de tus estudiantes",
sign_up_students_reports_subtitle:"Mira las respuestas inmediatas en el aula y reportes de evaluaci\u00f3n enviados a ti",
sign_up_teachers_title:"Profesores",
sign_up_teachers_subtitle_1:"Reg\u00edstrate",
sign_up_students_title:"Estudiantes",
sign_up_teachers_subtitle_2:"GRATIS",
code_placeholder:"Ingresa el CODE",
sign_up_sign_in:"Ingresa",
lti_display_title:"Nearpod Seleccionado! Siguientes Pasos:",
lti_display_subtitle:"La integraci\u00f3n existente entre Nearpod < > Schoology no soporta la auto-inserci\u00f3n de contenido. Para poder acceder a esta lecci\u00f3n, por favor siga estos 5 pasos:",
lti_display_step_1:"Copia el link a continuaci\u00f3n",
lti_display_step_2:"Vuelve a tu p\u00e1gina de Materiales",
lti_display_step_3:"Selecciona la rueda al lado de la lecci\u00f3n seleccionada y luego selecciona \"editar\" en las opciones",
lti_display_step_4:"Pega el link copiado en el campo de \"URL\"",
lti_display_step_5:"Selecciona \"Guardar Cambios\"",
binders_message_priorToToday:"Los Planes para Suplentes no pueden ser enviados antes de hoy",
my_library_no_lessons_lti_confirm:"Hola! Parece que no tienes ninguna lecci\u00f3n a\u00fan. Visita la Secci\u00f3n Explorar de Nearpod en el sitio completo o en la aplicaci\u00f3n para descargar lecciones asombrosas! ",
video_error_ios:"",
signUp_signUpWithEmail_2:"Registrarse con email",
signUp_signUpWithGoogle_2:"Registrarse con Google",
signUp_signUpWithOffice_2:"Registrarse con Office 365",
activity_timer_hangOn:"Aguarda a la siguiente actividad.",
oeq_submit_empty_answer_confirm_text:"No has respondido la pregunta.",
oeq_submit_empty_answer_actionone_text:"Revisar Respuesta",
oeq_submit_empty_answer_actiontwo_text:"Enviar",
oeq_timer_stand_by_activity_name:"una Pregunta!",
matchingPairs_timer_timeIsUp:"\u00a1Tiempo agotado!",
matchingPairs_timeForMatchingPairs:"\u00a1Tiempo de",
matchingPairs_youWillHave:"Tendr\u00e1s",
matchingPairs_toFinishThisActivity:"para terminar esta actividad. \u00a1Espera a tu profesor para comenzar!",
matchingPairs_timer_min:"min",
matchingPairs_timer_sec:"seg",
matchingPairs_timeForMatchingPairs2:"Buscando Pares!",
my_library_name_folder_modal_placeholder_2:"Nombre de Carpeta",
oeq_submit_wait_title:"\u00a1Espera!",
oeq_submit_confirmed_title:"\u00a1Listo!",
oeq_submit_confirmed_text:"Tu respuesta ha sido enviada.",
oeq_submit_confirmed_actionOne_text:"Editar Respuesta",
studentJoin_dontHaveAPin_2:"\u00bfNo tienes un CODE? Usa MAGIC",
my_account_form_change_password_placeholder:"Ingresar contrase\u00f1a",
my_account_confirm_password_title:"Verifica tu cuenta",
my_account_confirm_password_subtitle:"Ingresa tu contrase\u00f1a para continuar",
my_account_confirm_password_input_title:"Contrase\u00f1a Actual",
my_account_confirm_password_button:"Continuar",
global_loading:"Cargando",
binders_message_durationExceeded_1:"Los Planes para Suplentes solo pueden ser enviados dentro de 365 dias de ausencia",
endImpersonate:"Finalizar impersonalizacion",
my_account_form_change_password_subtitle:"Cambiar Contrase\u00f1a",
login_signup_error_message_lti:"Esta cuenta de Nearpod no existe. Por favor ingresa con una cuenta de Nearpod con licencia de tipo Escuela o Distrito.",
true_false_intro_title:"Verdadero\/Falso",
admin_onboarding_nostoredownloads_text:"semanas restantes en la Prueba Gratuita de tu Escuela",
admin_onboarding_nostoredownloads_title:"\u00bfSab\u00edas que la Prueba de Escuela le da acceso a m\u00e1s de",
admin_onboarding_nostoredownloads_strong_title:"7,000 lecciones premium personalizables y listas para ense\u00f1ar?",
admin_onboarding_nostoredownloads_primary_text_button:"Explorar lecciones",
admin_onboarding_nostoredownloads_secondary_text_button:"Ir a mi biblioteca",
admin_private_library_npp_hoverLayer_move:"Arrastra para Mover",
quiz_intro_questions:"Preguntas",
admin_private_library_entityMoved:"fue movido a",
desmos_title_SlopeInterceptForm:"Forma pendiente-ordenada al origen",
desmos_title_PointSlopeForm:"Forma punto-pendiente",
desmos_title_TwoPointFormOfALine:"Forma dos puntos de una recta",
desmos_title_InterceptForm:"Forma sim\u00e9trica",
desmos_title_GeneralForm:"Forma general",
desmos_title_VisualizingSlope:"Visualizando la pendiente",
desmos_title_StandardForm:"Forma desarrollada",
desmos_title_VertexForm:"Forma can\u00f3nica",
desmos_title_FactoredForm:"Forma factorizada",
desmos_title_StandardFormWithTangent:"Forma desarrollada con tangente",
desmos_title_PeriodAndAmplitude:"Per\u00edodo y amplitud",
desmos_title_Phase:"Fase",
desmos_title_AllTheTrigFunctions:"Todas las funciones trigonom\u00e9tricas",
desmos_title_UnitCircle:"Circunferencia unitaria",
admin_onboarding_add_teachers_title:"\u00a1Esperamos que est\u00e9s disfrutando de la prueba gratuita de la Prueba de Escuela!",
admin_onboarding_add_teachers_subtitle:"\u00bfSab\u00edas que 4 colegas en tu escuela ya est\u00e1n en Nearpod?",
admin_onboarding_add_teachers_primary_button_text:"\u00a1Compartir con colegas!",
admin_onboarding_add_teachers_secondary_button_text:"Ir a Mi Biblioteca",
admin_onboarding_add_teachers_message_part1:"Nearpod",
admin_onboarding_add_teachers_message_part2:"es mejor en cojunto!",
onboarding_overlay_lesson_create_title:"Crea una presentaci\u00f3n Nearpod ahora",
onboarding_overlay_lesson_create_body:"Aprenda a crear lecciones interesantes e interactivas desde cero o desde las diapositivas existentes que ya tienes.",
desmos_validation_completed_succesfully:"Guardando gr\u00e1fico...",
admin_onboarding_add_teachers_subtitle_part1:"\u00bfSab\u00edas que",
admin_onboarding_add_teachers_subtitle_part2:"colegas en tu escuela tambi\u00e9n est\u00e1n usando Nearpod?",
school_library_onboarding_overlay_title:"\u00a1Cre\u00e1 un centro de recursos compartidos con tu Biblioteca de Escuela!",
school_library_onboarding_overlay_body:"La Biblioteca de Escuela permite a los educadores colaborar y compartir las mejores pr\u00e1cticas y recursos.",
district_library_onboarding_overlay_body:"La Biblioteca de Distrito permite a los educadores colaborar y compartir las mejores pr\u00e1cticas y recursos.",
district_library_onboarding_overlay_title:"\u00a1Cre\u00e1 un centro de recursos compartidos con tu Biblioteca de Distrito!",
timer_save_error:"Hubo un problema guardando su Temporizador",
school_library_onboarding_overlay_video:"https:\/\/www.youtube.com\/embed\/ZAzDQTHdCY4?autoplay=1",
school_library_onboarding_overlay_admin_video:"https:\/\/www.youtube.com\/embed\/kiAf2fLnzLE?autoplay=1",
district_library_onboarding_overlay_admin_video:"https:\/\/www.youtube.com\/embed\/lmIP0Jbn4G8?autoplay=1",
district_library_onboarding_overlay_video:"https:\/\/www.youtube.com\/embed\/ojYAkzo8xXE?autoplay=1",
onboarding_overlay_lesson_create_action_button:"Crear Presentaci\u00f3n ahora",
onboarding_overlay_lesson_create_action_dismiss:"Ignorar",
admin_onboarding_nodminformation_primary_text_button:"Referir un Contacto",
admin_onboarding_nodminformation_secondary_text_button:"Ir a mi biblioteca",
admin_onboarding_nodminformation_title:"\u00a1Esperamos que est\u00e9s disfrutando de la prueba gratuita de la Prueba de Escuela!",
admin_onboarding_nodminformation_strong_title:"Dinos a qui\u00e9n contactar para hacerlo.",
admin_onboarding_nodminformation_text:"semanas restantes en la Prueba Gratuita de tu Escuela",
onboarding_overlay_lesson_create_video:"https:\/\/www.youtube-nocookie.com\/embed\/y8xNQbggas0?rel=0&showinfo=0",
dm_storage_experiment_title:"\u00bfQuieres acceso a todo nuestro contenido Premium?",
dm_storage_experiment_strong_title:"Cu\u00e9ntanos qui\u00e9n es el contacto de tu escuela para hacerlo posible. Por ahora, vamos a duplicar tu espacio",
dm_storage_experiment_primary_text_button:"Duplicar espacio",
dm_storage_experiment_secondary_text_button:"Ir a mi biblioteca",
try_it_free:"Pru\u00e9balo GRATIS por 30 d\u00edas",
action_button_nothanks:"No ahora, gracias",
spaced_overlay_title:"El modo Homework te da super poderes",
spaced_overlay_body:"Soporte para grupos de trabajo diferenciados, o asigna tareas din\u00e1micamente con el modo Homework.",
free_trial_activated:"\u00a1Disfruta 30 d\u00edas GRATIS del modo Homework!",
already_on_free_trial:"Ya eres parte de esta prueba gratuita.",
dm_storage_experiment_double_storage_button:"Duplicar Espacio",
Desmos_Category_Linear:"Lineal",
Desmos_Category_Inequalities:"Desigualdades",
Desmos_Category_Quadratics:"Cuadr\u00e1tico",
Desmos_Category_Trigonometry:"Trigonometr\u00eda",
Desmos_Category_Transformations:"Transformaciones",
Desmos_Category_ConicSections:"Secciones c\u00f3nicas",
Desmos_Category_PolarAndParametric:"Polar y param\u00e9trica",
Desmos_Category_Calculus:"C\u00e1lculo",
Desmos_Category_ProbabilityAndStatistics:"Probabilidad y estad\u00edstica",
Desmos_Category_Modeling:"Modelado",
desmos_title_Circle:"Circunferencia",
desmos_title_ParabolaAndFocus:"Par\u00e1bola y foco",
desmos_title_EllipseWithFoci:"Elipse con focos",
desmos_title_Hyperbola:"Hip\u00e9rbola",
desmos_title_PolarRose:"Rosa polar",
desmos_title_LogarithmicSpiral:"Espiral logar\u00edtmica",
desmos_title_Limacon:"Caracol de Pascal",
desmos_title_PolarConicSections:"Secciones c\u00f3nicas polares",
desmos_title_TranslatingAnyFunction:"Trasladando cualquier funci\u00f3n",
desmos_title_ScalingAnyFunction:"Expandiendo y contrayendo cualquier funci\u00f3n",
desmos_title_ReflectionsOfAFunction:"Reflexiones de una funci\u00f3n",
desmos_title_InverseOfAFunction:"Inversa de una funci\u00f3n",
desmos_title_Derivatives:"Derivadas",
desmos_title_SecantLine:"Recta secante",
desmos_title_TangentLine:"Recta tangente",
desmos_title_TaylorExpansionOfSinX:"Expansi\u00f3n en serie de Taylor de sen(x)",
desmos_title_DerivativeGame:"Juego de la derivada",
desmos_title_MatchAQuadraticFunction:"Encuentra la funci\u00f3n cuadr\u00e1tica",
desmos_title_MatchALinearFunction:"Encuentra la funci\u00f3n lineal",
desmos_title_MatchATrigonometricFunction:"Encuentra la funci\u00f3n trigonom\u00e9trica",
desmos_title_GraphingFunctionsUsingTables:"Graficando funciones usando tablas",
desmos_title_InequalitiesBasic:"Inecuaciones: B\u00e1sico",
desmos_title_InequalitiesIntermediate:"Inecuaciones: Intermedio",
desmos_title_InequalitiesAdvanced:"Inecuaciones: Avanzado",
desmos_title_ArcLengthByIntegration:"Longitud de arco por integraci\u00f3n",
desmos_title_CanyonJump:"Salto en el ca\u00f1\u00f3n",
desmos_title_WillItHitTheHoop1:"Golpear\u00e1 el aro 1",
desmos_title_WaterBottleFlippingModel:"Modelo de botella de agua volteando",
desmos_title_CircleOverlapFraction:"Fracci\u00f3n de superposici\u00f3n de c\u00edrculos",
desmos_title_MinMaxUnionIntersection:"M\u00ednimo, m\u00e1ximo, uni\u00f3n, intersecci\u00f3n",
desmos_title_TracingAPointOnAPolarCurve:"Siguiendo un punto en una curva polar",
desmos_title_FourCirclesThroughFourPoints:"Cuatro circunferencias a trav\u00e9s de cuatro puntos",
desmos_title_OrientedAreaIndependentOfBasePoint:"\u00c1rea orientada independiente de punto base",
desmos_title_FundamentalTheoremOfCalculus:"Teorema fundamental del c\u00e1lculo",
desmos_title_IntegralWithAdjustableBounds:"Integral con l\u00edmites ajustables",
desmos_title_IntegralMeanValueTheorem:"Teorema del valor medio para integrales",
desmos_title_MeanValueTheorem:"Teorema del valor medio",
desmos_title_CornuSpiral:"Espiral de Corn\u00fa",
desmos_title_DifferentIntegrationBounds:"Diferentes l\u00edmites de integraci\u00f3n",
desmos_title_IntegrationByParts:"Integraci\u00f3n por partes",
desmos_title_CosmicMicrowaveBackgroundDataset:"Conjunto de datos de radiaci\u00f3n c\u00f3smica de microondas",
desmos_title_MonteCarloPi:"Pi de Monte Carlo",
desmos_title_ConicSectionWaves:"Ondas c\u00f3nicas",
desmos_title_CircleWave:"Onda circular",
desmos_title_FamilyOfRectanglesThroughTwoPoints:"Familia de rect\u00e1ngulos a trav\u00e9s de dos puntos",
desmos_title_BezierCurveAsEnvelope:"Curva de B\u00e9zier como envoltura",
desmos_title_ImplicitVennDiagram:"Diagrama de Venn impl\u00edcito",
desmos_title_StationaryGradientCurves:"Curvas de gradiente estacionarias",
desmos_title_CircleTangentToThreeCircles:"Circunferencia tangente a tres circunferencias",
desmos_title_DoublingTimeOfCompoundInterest:"Duplicando el tiempo de inter\u00e9s compuesto",
desmos_title_RegionsDefinedByFourHalfPlanes:"Regiones definidas por cuatro semiplanos",
desmos_title_CardioidEnvelope:"Envoltura de cardioide",
desmos_title_LambertWFunction:"Funci\u00f3n W de Lambert",
desmos_title_NormalFamily:"Familia normal",
desmos_title_HoopAttachedTo10Springs:"Aro atado a 10 cuerdas",
desmos_title_4ThOrderPolynomialThroughAny5Points:"Polinomio de 4to grado a trav\u00e9s de 5 puntos",
desmos_title_Cycloid:"Cicloide",
desmos_title_ApollonianCircles:"Circunferencias de Apolonio",
desmos_title_PotentialOutsideALineCharge:"Potencial fuera de una l\u00ednea de carga",
desmos_title_TrigUnitCircle:"Circunferencia trigonom\u00e9trica unitaria",
desmos_title_Beats:"Latidos",
desmos_title_BisectingATangent:"Bisecando una tangente",
desmos_title_GeneralLineIntersection:"Intersecci\u00f3n de dos rectas",
desmos_title_WrappedRadian:"Radi\u00e1n envuelto",
desmos_title_ProjectileMotion:"Movimiento de proyectiles",
desmos_title_GeometricDistribution:"Distribuci\u00f3n geom\u00e9trica",
desmos_title_BinomialDistribution:"Distribuci\u00f3n binomial",
desmos_title_NormalDistribution:"Distribuci\u00f3n normal",
desmos_title_ParabolaMultiplication:"Multiplicaci\u00f3n usando una par\u00e1bola",
desmos_title_ExtremaWithRegressions:"Extremos con regresiones",
desmos_title_RotatingCylinder:"Cilindro giratorio",
desmos_title_BouncingStereographicProjection:"Proyecci\u00f3n estereogr\u00e1fica rebotante",
desmos_title_RotatingBezierControlPoints:"Puntos de control giratorios de B\u00e9zier",
desmos_title_HypocycloidJuggling:"Malabarismo hipocicloide",
desmos_title_NegativePedalCurve:"Podaria negativa",
desmos_title_SphereShearing:"Esquileo de esfera",
desmos_title_KernelDensityMetaballs:"Metabolas de densidad kernel",
desmos_title_KernelDensityEstimation:"Estimaci\u00f3n de densidad kernel",
desmos_title_NielsensSpiral:"Espiral de Nielsen",
desmos_title_Regressions:"Regresiones",
desmos_title_HistogramAndBoxAndWhiskerPlot:"Histograma y diagrama de caja",
desmos_title_HistogramAndSummaryData:"Histograma y resumen de datos",
desmos_title_BoxAndWhiskerPlotAndSummaryData:"Diagrama de caja y resumen de datos",
desmos_title_MagnifyingGlassQuadratic:"Lupa: Cuadr\u00e1tica",
desmos_title_MagnifyingGlassLinear:"Lupa: Lineal",
desmos_title_MagifyingGlassCubic:"Lupa: C\u00fabica",
desmos_title_MagifyingGlassTrigonometric:"Lupa: Trigonom\u00e9trica",
desmos_title_PythagorianTheoremProof:"Demostraci\u00f3n del teorema de Pit\u00e1goras",
desmos_title_3DGraphUsingParametricLines:"Gr\u00e1fico 3D utilizando curvas param\u00e9tricas",
desmos_title_StatisticsAnscombsQuartet:"Estad\u00edstica: Cuarteto de Anscombe",
desmos_title_SincInterpolation:"Interpolaci\u00f3n sinc",
desmos_title_ReflectionOfAPointAcrossALine:"Reflexi\u00f3n de un punto respecto de una recta",
desmos_title_DataWithErrorBars:"Datos con barras de error",
desmos_title_ParametricIntermediate:"Param\u00e9trico: Intermedio",
desmos_title_ParametricBasic:"Param\u00e9trico: B\u00e1sico",
desmos_title_RestrictionsBasic:"Restricciones: B\u00e1sico",
desmos_title_RestrictionsIntermediate:"Restricciones: Intermedio",
desmos_title_SlidingRestrictionsBoxSine:"Caja de restricciones deslizante: senoidal",
desmos_title_Harmonics:"Arm\u00f3nicos",
desmos_title_SierpinskiValentine:"Valent\u00edn de Sierpinski",
desmos_title_Fireworks:"\u00a1Fuegos artificiales!",
desmos_title_RegressionsBasics:"Regresiones: B\u00e1sico",
desmos_title_RegressionsIntermediate:"Regresiones: Intermedio",
desmos_title_3DWorldGraph:"Gr\u00e1fico de mundo 3D",
desmos_title_FastestPathToAPoint:"Camino m\u00e1s r\u00e1pido a un punto",
desmos_title_PolygonTransformations:"Transformaciones de pol\u00edgonos",
desmos_title_PacMan:"Pac-Man",
desmos_title_SummationIntermediate:"Sumatoria: Intermedio",
desmos_title_SummationAdvanced:"Sumatoria: Avanzado",
desmos_title_TaylorAndBinomialSeries:"Serie de Taylor y Binomial",
desmos_title_RiemannSums:"Sumas de Riemann",
oeq_will_save_after_uploading:"La encuesta abierta se guardar\u00e1 cuando los archivos terminen de cargar.",
desmos_tooltip_edit_init:"Obt\u00e9n acceso a m\u00e1s de 100 gr\u00e1ficos de Desmos con una cuenta escuela o distrito de Nearpod. ",
desmos_tooltip_edit_link:"Cont\u00e1ctenos",
desmos_tooltip_edit_end:" para mas informaci\u00f3n.",
school_library_overlay_title:"\u00a1Compart\u00ed la magia! Agrega tu lecci\u00f3n a la Biblioteca de tu Escuela",
school_library_overlay_body:"A\u00f1ade esta lecci\u00f3n a la Librer\u00eda de tu Escuela para que tus colegas descargarla o personalizarla para sus clases!",
learn_more:"M\u00e1s Informaci\u00f3n",
learn_more_url:"https:\/\/nearpod.com\/nearpod-school-library",
add_it_now:"\u00a1Agregar r\u00e1pidamente!",
subs_overlay_title:"\u00a1Temporada de gripe!",
subs_overlay_body:"\u00bfTe gustar\u00eda planificar las ausencias para que los estudiantes sigan aprendiendo?",
subs_GoToDashboard:"Ir al Panel",
oeq_error_completeFields:"Por favor completa los siguientes campos obligatorios.",
oeq_error_emptyQuestion:"Por favor incluye texto para esta pregunta.",
oeq_question_placeholder:"Ingresa tu pregunta aqu\u00ed",
add_lesson_sl:"Lecci\u00f3n agregada exitosamente a la Libreria de la Escuela",
login_notification_downgrade_platinum_to_gold_title:"You have been downgraded to the Gold Edition",
login_notification_downgrade_platinum_to_gold_message:"Esto significa que tendr\u00e1s espacio reducido y no tendr\u00e1s m\u00e1s acceso a contenido ilimitado de la Tienda de Nearpod y a Notas de Estudiantes.",
login_notification_downgrade_platinum_to_gold_buton:"\u00a1Entendido!",
ayce_downgrade_title:"Cambios en tu cuenta",
ayce_downgrade_message:"Tu cuenta se ha cambiado a Edici\u00f3n Silver. Como resultado, algunas de tus lecciones de Nearpod pueden haber sido inhabilitadas de tu cuenta y ya no tendr\u00e1s acceso ilimitado a lecciones que ten\u00edas disponibles a trav\u00e9s del programa Nearpod Ilimitado.",
ayce_downgrade_button:"Entendido!",
feature_downgrade_title:"Cambios en tu cuenta",
feature_downgrade_message:"Ahora est\u00e1s en una cuenta gratuita Edici\u00f3n Silver. Por lo tanto, algunas de tus lecciones, reportes y funcionalidades premium pueden haber sido deshabilitadas de tu cuenta. Por favor ponte en contacto con nosotros a support@nearpod.com si quieres restaurar tu cuenta.",
feature_downgrade_button:"Entendido!",
redeem_code_fail_title:"No hemos podido redimir este c\u00f3digo",
redeem_user_used_once:"Ya has participado con un c\u00f3digo.",
redeem_user_used_button:"Entendido!",
school_trial_onboarding_modal_title:"Obt\u00e9n completo acceso a nuestra librer\u00eda de 7,000 lessons personalizables",
school_trial_onboarding_admin_video:"https:\/\/www.youtube.com\/embed\/35A15FlEnUk?autoplay=1&mute=1",
school_trial_onboarding_modal_body:"y mucho m\u00e1s, como acceso a todas nuestras actividades, participaci\u00f3n de estudiantes ilimitada, y el modo de tareas con tu cuenta de escuela gratuita de 60 d\u00edas.",
paywalls_loginNotification1_title:"Prueba la Edici\u00f3n Gold gratis!",
paywalls_loginNotification1_text:"Obt\u00e9n una Prueba GRATIS por 30 d\u00edas para probar todo el poder de Nearpod. (No te preocupes, no se necesita tarjeta de cr\u00e9dito)",
paywalls_loginNotification1_button:"Prueba Gold!",
school_user_onboarding_admin_video:"https:\/\/www.youtube.com\/embed\/35A15FlEnUk?autoplay=1&mute=1",
school_user_onboarding_modal_title:"Has sido invitado a acceso completo a nuestra librer\u00eda de 7.000+ lecciones personalizables listas para ense\u00f1ar",
school_user_onboarding_modal_body:"Adem\u00e1s acceso a todas nuestras actividades, participaci\u00f3n ilimitada para los estudiantes, y modo estudiante con 60 d\u00edas de Cuenta Escuela GRATIS",
admin_onboarding_premium_activities_intro_title_part1:"\u00a1Esperamos que te guste la prueba gratuita de la escuela!",
admin_onboarding_premium_activities_intro_title_part2:"\u00bfSab\u00edas que tienes acceso a ",
admin_onboarding_premium_activities_intro_title_part3:"funciones premium ",
admin_onboarding_premium_activities_intro_title_part4:"como",
admin_onboarding_premium_activities_primary_text_button_loading:"Descargando",
admin_onboarding_premium_activities_primary_text_button_library:"Mostrar en mi biblioteca",
admin_onboarding_premium_activities_primary_text_button:"A\u00f1adir a mi biblioteca",
admin_onboarding_premium_activities_secondary_text_button:"Ir a mi biblioteca",
paywalls_loginNotification_successMessage:"Felicitaciones! Se ha desbloqueado tu prueba gratuita de Gold!",
admin_onboarding_premium_activities_add_lesson_title_part1:"Agregue esta lecci\u00f3n de preparaci\u00f3n a su biblioteca ",
admin_onboarding_premium_activities_add_lesson_title_part2:"para aprender como aumentar el nivel en su",
admin_onboarding_premium_activities_add_lesson_title_part3:"aula con Buscando Pares y Paseos de Realidad Virtual.",
admin_onboarding_premium_activities_add_lesson_title_success_part1:"Genial, agregamos la lecci\u00f3n a tu biblioteca.",
admin_onboarding_premium_activities_add_lesson_title_success_part2:"\u00a1Disfr\u00fatala!",
dm_storage_experiment_space_doubled:"Felicidades \u00a1Tu espacio de almacenamiento ha sido DUPLICADO!",
admin_onboarding_premium_activities_success_message:"\u00a1Has descargado exitosamente una lecci\u00f3n de prueba gratuita!",
login_notification_extended_features_expired_title:"\u00a1Oh no! Tu Gold gratuita de prueba ha terminado.",
login_notification_extended_features_expired:"Pero la diversi\u00f3n no debe terminar aqu\u00ed...",
action_button_upgrade_now:"\u00a1Actualiza ahora!",
login_notification_extended_features_reminder_days_title:"\u00a1Oye! Solo te quedan {_daysLeft_} de tu prueba gratuita.",
login_notification_extended_features_reminder_days:"\u00a1Tu per\u00edodo de prueba est\u00e1 por expirar! Actualiza para mantener el acceso ilimitado a las mejores funcionalidades.",
action_button_remindlater:"Recu\u00e9rdamelo m\u00e1s tarde",
oeq_cancelConfirm:"\u00bfEst\u00e1s seguro de querer cancelar? Perder\u00e1s tus cambios.",
thanks:"Gracias!",
login_notification_school_join_message:"Felicitaciones! Como usuario Nearpod School, tienes acceso a funcionalidades avanzadas y premium como presentaciones para ver a tu propio ritmo, Bibliotecas Privadas para escuela, y Notas para Estudiantes.",
login_notification_school_join_title:"Has sido agregado a {_SchoolName_}!",
Desmos_Category_StaffPicks:"Recomendados",
test_localize_vars_one:"",
test_localize_vars_multiple:"",
importUser_popin_message_changeUserSchool:"El Administrador de Nearpod de tu escuela te ha actualizado la cuenta a {_SchoolName_} {_ProductName_}. \\n\\nAl unirte a la Edici\u00f3n School, obtendr\u00e1s acceso a funcionalidades premium como bibliotecas de escuela y notas para estudiantes \u2013 todo esta pago por la escuela! \\n\\nTe gustar\u00eda unirte a la Edici\u00f3n {_ProductName_}?",
importUser_popin_message_changeUserSchool_gold:"El Administrador de Nearpod de tu escuela te ha actualizado la cuenta a {_SchoolName_} {_ProductName_}.\\n\\nAl unirte a la Edici\u00f3n School, obtendr\u00e1s acceso a funcionalidades premium como bibliotecas de escuela y notas para estudiantes -todo esta pago por la escuela! \\n\\nTe gustar\u00eda unirte a la Edici\u00f3n {_ProductName_}?",
importUser_popin_message_changeUserSchool_goldPlus:"El Administrador de Nearpod de tu escuela te ha actualizado la cuenta a {_SchoolName_} {_ProductName_}. \\n\\nAl unirte a la Edici\u00f3n School, obtendr\u00e1s acceso a funcionalidades premium como bibliotecas de escuela y notas para estudiantes \u2013 todo esta pago por la escuela! \\n\\nTe gustar\u00eda unirte a la Edici\u00f3n {_ProductName_}?",
importUser_popin_message_changeUserSchoolWithAyce:"Has sido invitado a unirte a {_School.name_} Edici\u00f3n {_Product.name_} por pedido del administrador de Nearpod de tu escuela. \\n\\nActualmente eres miembro de otra escuela de Nearpod con contenido {_ayceNames_} {_subscriptionLabel_}. Al aceptar esta invitaci\u00f3n, est\u00e1s aceptando que puedes estar cambiando de suscripci\u00f3n y, por lo tanto, perder acceso a algunas de las lecciones descargadas. \\n\\nSi deseas unirte a esta escuela, por favor has clic en Unirme! \\n\\nSi deseas permanecer en tu actual escuela, por favor cierra esta ventana.",
action_button_gotit_cancel:"Entendido!",
bulk_notAvailable_slots:"El administrador de tu escuela te ha invitado a unirte a Nearpod pero todos los lugares han sido ocupados. Por favor ponte en contacto con tu administrador para obtener m\u00e1s informaci\u00f3n.",
Desmos:"Desmos",
subscription:"suscripci\u00f3n",
subscriptions:"suscripciones",
test_localize_vars_multiple_equals:"",
test_unescape_localize:"",
desmos_filter:"Filtro :",
my_library_top_bar_search_placeholder:"Buscar lecciones",
sa_collaborate_coach_message:"Comparte texto e im\u00e1genes con tus estudiantes en tiempo real. En cualquier momento, lesson no requerida.",
sa_collaborate_coach_footer:"Mantente sintonizado, pronto podr\u00e1s lanzar m\u00e1s actividades.",
sa_collaborate_coach_button:"Ok, entendido!",
share_invalid_email:"La direcci\u00f3n de email no es v\u00e1lida",
sa_collaborate_coach_title:"LANZAR",
sa_collaborate_coach_sub_title:"Collaborate!",
toolbar_upgrade:"Actualiza",
my_library_top_bar_collaborate_tooltip:"Lanzar Colaborativo!",
signUp_clever_title:"Profesor - Registrarse con Clever",
school_trial_admin_text_notification:"Obt\u00e9n completo acceso a nuestra librer\u00eda de 7000+ lecciones personalizables",
school_trial_admin_button_text_notification:"Empezar",
school_trial_admin_link_text_notification:"Ver el video",
user_profile_save_success:"Informaci\u00f3n de perfil guardada.",
lessons_list_header_action_add_folder:"Agregar Carpeta",
grades_subjects_modal_submit:"Enviar",
grades_subjects_modal_no_thanks:"No, gracias",
grades_subjects_modal_subjects_placeholder:"Seleccionar materias",
grades_subjects_modal_subjects_label:"Materias",
grades_subjects_modal_grades_placeholder:"Seleccionar niveles",
grades_subjects_modal_grades_label:"Niveles",
grades_subjects_modal_subtitle:"Las tenemos, s\u00f3lo danos tus niveles y materias.",
grades_subjects_modal_title:"\u00bfQuieres lecciones que te encantar\u00e1n?",
edit_lesson_in_publiclibrary_confirm:"OK",
edit_lesson_in_publiclibrary_cancel:"Cancelar",
edit_lesson_in_publiclibrary_title:"Editar Presentaci\u00f3n de Biblioteca P\u00f9blica",
edit_lesson_in_publiclibrary_description:"Esta presentaci\u00f3n se encuentra actualmente en tu BIBLIOTECA P\u00daBLICA.\\nAl editarla, esta ser\u00e1 REMOVIDA.",
search_box_placeholder_text:"Buscar lecciones en nuestra tienda",
search_box_placeholder_text_b2b:"Buscar lecciones en la Biblioteca de Lecciones de Nearpod",
first_lesson_overlay_title:"\u00bfTienes lecciones?",
first_lesson_overlay_subtitle:"Importa una ahora.",
first_lesson_overlay_secondary_text_button:"No gracias, ahora no",
country_title:"Datos de facturaci\u00f3n",
country_subtitle:"Por favor complete la siguiente informaci\u00f3n:",
country_united_states:"Estados Unidos",
country_other:"Otro",
country_placeholder:"Pa\u00eds",
first_lesson_overlay_upload_success:"Muy bien, \u00a1tu primera lecci\u00f3n esta oficialmente en Nearpod! L\u00e1nzala ahora o explora nuestras actividades interactivas.",
country_address:"Direcci\u00f3n",
country_apartment:"Piso, departamento, oficina, etc. (opcional)",
country_state:"Estado (dos letras)",
country_zipcode:"C\u00f3digo Postal",
country_city:"Ciudad",
themes_menu_title:"Temas",
user_permissions_modal_title:"Permisos de Usuario",
toggle_label_on:"ON",
toggle_label_off:"OFF",
global_form_invalidZipCode:"Por favor ingrese un c\u00f3digo postal v\u00e1lido.",
onboarding_overlay_lesson_create_video_2:"https:\/\/www.youtube.com\/embed\/vvznAXPIXzY?rel=0&showinfo=0",
my_library_folder_updated_success:"La carpeta {_folderName_} ha sido guardada",
first_lesson_overlay_loading_title1:"\u00bfListo para experimentar la magia de Nearpod?",
first_lesson_overlay_loading_subtitle1:"Mueve el mouse y selecciona Sesi\u00f3n Live.\\n",
first_lesson_overlay_loading_title2:"Para compartir el amor,",
first_lesson_overlay_loading_subtitle2:"compart\u00ed el c\u00f3digo.",
first_lesson_overlay_loading_title3:"Tu controlas el ritmo. Ellos se suman desde cualquier dispositivo.",
first_lesson_overlay_loading_subtitle3:"\u00bfListo?",
time_to_climb_title_part1:"Bam! Ahora tienes acceso a la",
time_to_climb_title_part2
:" ",
time_to_climb_title_part3:"NUEVA",
time_to_climb_title_part4:"actividad gamificada de Nearpod, Tiempo de Escalar.",
time_to_climb_text_part1:"Echa un vistazo a nuestra mini serie de productos listos para usar",
time_to_climb_text_part2
:"actividades de Tiempo de Escalar!",
time_to_climb_primaryButton:"Explorar",
time_to_climb_secondaryButton:"No, gracias",
mylibrary_dnd_npp_text:"Arrastrar",
permission_view_license_details:"Detalles de Licencia",
permission_manage_users:"Administrar Usuarios",
permission_manage_schools:"Administrar Escuelas",
permission_manage_school_library:"Administrar Librer\u00eda de Escuela",
permission_manage_district_library:"Administrar Librer\u00eda de Distrito",
permission_push_lessons:"Compartir Lecciones",
permission_usage_graphs_school:"Gr\u00e1ficos de Uso de Escuela",
permission_usage_statistics_school:"Estad\u00edsticas de Uso de Escuela",
permission_post_session_reports:"Reportes Post-Sesi\u00f3n",
oeq_student_recording_audio_enable:"Habilitar grabaciones de estudiantes",
activityChallenge_header_title:"Desaf\u00edo de Actividad Nearpod",
activityChallenge_header_subtitle:"Obt\u00e9n lecciones student-paced por el resto del a\u00f1o lectivo 2018-2019!",
activityChallenge_header_text:"Solo dicta una lecci\u00f3n por semana por las pr\u00f3ximas cuatro semanas. \u00bfTe sumas?",
activityChallenge_asset_text:"Student-Paced",
activityChallenge_button:"Aceptar desaf\u00edo",
activityChallenge_link
:"Ahora no, gracias",
student_recording_box_info_tooltip_text:"\u00a1Ahora puedes habilitar la grabaci\u00f3n de audio para tus estudiantes! Tus estudiantes pueden grabar audio y reproducirlo para que lo escuchen y aprendan.",
streaks_challenge_title:"Desaf\u00edo de actividad de 4 semanas - Semana {_value_}",
streaks_challenge_description_week_1:"1 semana completa, 3 pendientes. Manten el ritmo, lanza tu pr\u00f3xima sesi\u00f3n!",
user_permissions_modal_view:"Solo Vista",
user_permissions_modal_edit:"Completo",
streaks_challenge_description_week_2:"Esto se est\u00e1 calentando. 2 semanas completas, 2 pendientes. Mant\u00e9n el ritmo!",
streaks_challenge_description_week_3:"1 semana para obtener student-paced por el resto del a\u00f1o acad\u00e9mico!",
global_audio_recorder:"Grabador de audio",
streaks_challenge_description_empty:"Obt\u00e9n student-paced de forma gratuita. Lanza una sesi\u00f3n con tu clase ahora!",
streaks_challenge_title_lose:"Oh, que l\u00e1stima!",
streaks_challenge_title_win:"Desaf\u00edo completado",
streaks_challenge_description_lose:"Mant\u00e9n los ojos abiertos para m\u00e1s desaf\u00edos divertidos para subir tu nivel en Nearpod.",
streaks_challenge_description_win:"\u00a1Lo hiciste! Disfruta student-paced por el resto del a\u00f1o acad\u00e9mico.",
user_permissions_modal_description:"Permitir a los usuarios realizar ciertas acciones que t\u00edpicamente est\u00e1n reservadas para administradores",
oeq_student_recording_audio_recorder_incompatible:"No es posible grabar en su dispositivo",
oeq_student_recording_audio_recorder_compatible
:"Grabar Audio",
oeq_student_recording_audio_recorder_no_permissions_1:"Las respuestas de audio fueron activadas para esta actividad.",
oeq_student_recording_audio_recorder_no_permissions_2:"Otorga permisos de grabaci\u00f3n de audio para que Nearpod",
oeq_student_recording_audio_recorder_no_permissions_3:" pueda usar esta caracter\u00edstica.",
my_library_folder_updated_success_2:"La carpeta \"{_folderName_}\" ha sido guardada",
my_library_delete_folder_success_2:"La carpeta \"{_folderName_}\" ha sido eliminada",
my_library_folder_updated_failed:"",
drag_and_drop_title_part1:"\u00a1Atenci\u00f3n!",
drag_and_drop_title_part2:"Hicimos que organizar tus presentaciones sea f\u00e1cil con drag and drop, y",
drag_and_drop_title_part3:"soporte para sub carpetas en Mi Biblioteca",
drag_and_drop_primaryButton:"Continuar",
matching_pairs_homework_student_confirm:"Continuar",
permission_usage_graphs_district:"Gr\u00e1ficos de Uso de Distrito",
permission_usage_statistics_district:"Estad\u00edsticas de Uso de Distrito",
user_permissions_modal_none:"Ninguno",
streaks_challenge_completed_title:"Desaf\u00edo de 4 semanas completado",
streaks_challenge_completed_subtitle
:"\u00a1Buen trabajo ense\u00f1ando en Nearpod cada semana!",
streaks_challenge_completed_text1:"Para expresar nuestro mayor agradecimiento por aceptar este desaf\u00edo de Nearpod, le brindamos un trofeo muy brillante y student-paced durante el resto del a\u00f1o acad\u00e9mico 2018-2019.",
streaks_challenge_completed_text2:"Mant\u00e9ngase atento a m\u00e1s desaf\u00edos, \u00a1nunca se sabe lo que viene!",
streaks_challenge_completed_share:"Compartir en",
streaks_challenge_completed_share_description:"\u00a1Wow! He ganado acceso a student-paced por mis resultados en #NearpodStreak",
streaks_challenge_completed_share_pinterest:"\u00a1Wow! He ganado acceso a student-paced por mis resultados en NearpodStreak",
school_experiment_modal_not_us:"No estoy en Estados Unidos",
oeq_delete_audio_confirm_title:"\u00a1Espera!",
oeq_delete_audio_confirm_text:"\u00bfEst\u00e1s seguro de que deseas eliminar la respuesta de audio?",
googleSlides_learnMore:"Aprende a usar nuestro complemento",
googleSlides_listHeader:"Selecciona uno para agregar una diapositiva",
googleSlides_editBtn:"Editar esta diapositiva",
googleSlides_saveBtn:"Guardar e ir a Nearpod",
googleSlides_userInfo:"Sesi\u00f3n iniciada como ",
global_slides_audio:"Audio",
global_slides_bbc:"Video de la BBC",
global_slides_collaborate:"Colaborativo",
global_slides_drawIt:"Dibuja",
global_slides_fieldTrip:"Paseo Virtual",
global_slides_fitb:"Completar los espacios",
global_slides_desmos:"Calculadora Gr\u00e1fica",
global_slides_twitter:"Twitter Stream",
global_slides_memoryTest:"Memotest",
global_slides_nearpod3d:"Nearpod 3D",
global_slides_pdfViewer:"Visualizador de PDF",
global_slides_phet:"Simulaci\u00f3n",
global_slides_slide:"Diapositiva",
global_slides_slideshow:"Galer\u00eda de im\u00e1genes",
global_slides_sway:"Sway",
global_slides_matchingPairs:"Buscando pares",
global_slides_oeq:"Pregunta abierta",
global_slides_poll:"Encuesta",
global_slides_quiz:"Cuestionario",
global_slides_timeToClimb:"Time to Climb",
global_slides_video:"Video",
global_slides_webContent:"Contenido Web",
my_library_no_content_p1:"No tienes lecciones en tu Biblioteca. Por favor visita",
my_library_no_content_p2:"para encontrar o crear algunas lecciones para ense\u00f1ar",
my_library_no_content_link:"nearpod.com",
googleSlides_videoIconAlt:"\u00cdcono de video",
create_lesson:"Crear Presentacion",
lessons_list_npp_action_edit_google_slides:"Editar en Google Slides",
library_overlay_title:"\u00a1Bienvenido a tu biblioteca de lecciones!",
library_overlay_body:"\u00a1Encontrar\u00e1s todas las lecciones que guardes de la tienda Nearpod o crees por tu cuenta aqu\u00ed!",
action_button_go_my_library:"Ver mi biblioteca",
googleSlides_filter_text_allFeatures:"Todas las caracter\u00edsticas",
googleSlides_filter_label_allFeatures:"todas las caracter\u00edsticas",
googleSlides_filter_text_content:"Contenido",
googleSlides_filter_label_content:"contenido",
googleSlides_filter_text_webContent:"Contenido web",
googleSlides_filter_label_webContent:"contenido web",
googleSlides_filter_text_activities:"Actividades",
googleSlides_filter_label_activities:"actividades",
googleSlides_noResults_imageAlt:"No hay resultados",
googleSlides_noResults_text:"Ups! La caracter\u00edstica que buscas no est\u00e1 disponible a\u00fan, pero estamos trabajando en eso.",
googleSlides_searchPlaceholder:"Buscar",
sidebar_menu_explore_nearpod:"Explora Nearpod para tu Escuela o Distrito >",
sidebar_menu_explore_offers:"Novedades",
sidebar_menu_special_offers:"Recibe ofertas especiales! >",
sidebar_menu_special_offers_button:"Ofertas especiales",
sidebar_join_lesson:"Unirse a una lecci\u00f3n",
google_slides_refresh:"Por favor recarga esta p\u00e1gina",
browse_lessons_sidebar:"Explorar presentaciones",
show_breadcrumb_search_results:"Se muestran resultados para",
header_subs_link_2:"Planes de Subtituto",
teacher_resources:"Recursos de Profesor",
sidebar_faq:"FAQ",
whats_new:"Nuevo",
sidebar_content_packages_title:"Mi Curricula Suplemental",
sidebar_badge_title:"User",
tabs_filter:"",
drawit_timer_stand_by_activity_name:"Dibujar!",
googleSlides_stayHere_btn:"Permanecer aqu\u00ed y editar",
googleSlides_goToNearpod_btn:"Ir a Nearpod",
googleSlides_edit_text_1:"Esta lecci\u00f3n est\u00e1 guardada. \u00bfEst\u00e1s seguro\/a de que quieres editar las diapositivas de Nearpod?",
googleSlides_edit_text_2:"Si no deseas hacer cambios, te llevaremos de nuevo a Nearpod. Podr\u00e1s previsualizar la lecci\u00f3n y no se perder\u00e1 nada.",
googleSlides_userAlert_text_1:"\u00a1Espera! Tu lecci\u00f3n puede:",
googleSlides_userAlert_text_2:"Si no deseas hacer cambios, te llevaremos de nuevo a Nearpod. Podr\u00e1s previsualizar la lecci\u00f3n y no se perder\u00e1 nada.",
googleSlides_userAlert_listItem_1:"Tener un c\u00f3digo activo",
googleSlides_userAlert_listItem_2:"Estar en tu biblioteca de escuela\/distrito",
googleSlides_userAlert_listItem_3:"Estar en tu biblioteca p\u00fablica",
high_storage_overlay_title_text1:"Ups, tu almacenamiento est\u00e1 casi lleno!",
high_storage_overlay_title_text2:"Sub\u00ed a Gold para hacer crecer tu biblioteca sin preocupaciones.",
high_storage_overlay_primary_button:"Consigue Gold",
high_storage_overlay_secondary_button:"No, gracias",
share_microsoft:"Microsoft Teams",
student_drawit_clearTitle:"Eliminar todo",
student_drawit_clearMessage:"\u00bfEst\u00e1s seguro de que deseas borrar este dibujo?",
flocabulary_filter:"Filtro:",
store_search_noresults_line1_default:"\u00a1Hola! Tenemos incre\u00edbles lecciones pero ninguna con '%s'",
store_search_noresults_line2_prelink_default:"\u00a1Por favor",
store_search_noresults_line2_linkurl_default:"mailto:feedback@nearpod.com?subject=I got no results on my Nearpod Lesson Library search!",
store_search_noresults_line2_linktext_default:"cu\u00e9ntanos qu\u00e9 estabas buscando",
store_search_noresults_line2_postlink_default:"as\u00ed podemos mejorar!",
store_search_noresults_line3_default:"",
store_search_noresults_line1_flocabulary:"",
store_search_noresults_line2_prelink_flocabulary:"\u00a1Hola! \u00a1Por favor",
store_search_noresults_line2_linkurl_flocabulary:"https:\/\/www.flocabulary.com",
store_search_noresults_line2_linktext_flocabulary:"dir\u00edgete a Flocabulary",
store_search_noresults_line2_postlink_flocabulary:"para m\u00e1s contenido",
store_search_noresults_line3_flocabulary:"culturalmente relevante para capturar el inter\u00e9s de los estudiantes!",
Flocabulary_Category_language_arts:"ELA",
googleSlides_shareConfirm_title:"Las copias compartidas de esta lecci\u00f3n solo podr\u00e1n ser abiertas en Nearpod",
googleSlides_shareConfirm_message:"Para una experiencia de edici\u00f3n m\u00e1s flexible, recomendamos compartir esta lecci\u00f3n directamente desde Google Slides.",
googleSlides_shareConfirm_agreeBtn:"Aceptar y compartir",
standards_filter_title:"Standards",
standards_filter_placeholder:"Selecciona un Standard o Estado",
Flocabulary_Category_math:"Matem\u00e1ticas",
Flocabulary_Category_science:"Ciencias",
Flocabulary_Category_social_studies:"Sociales",
Flocabulary_Category_life_skills:"Habilidades para la vida",
Flocabulary_Category_vocabulary:"Vocabulario",
Flocabulary_Category_current_events:"Eventos Actuales",
standards_filters_subjects_title:"Selecciona una Materia",
admin_onboarding_outcome_title_part1_with_param:"\u00bfDeseas que esto dure m\u00e1s que el per\u00edodo de prueba de {_days_} d\u00edas?",
standards_filters_grades_title:"Selecciona un Grado",
standards_filters_strands_title:"Strands",
quiz_placeholder:"Cuestionario sin t\u00edtulo ",
school_trial_onboarding_modal_body_with_params:"y mucho m\u00e1s, como acceso a todas nuestras actividades, participaci\u00f3n de estudiantes ilimitada, y el modo de tareas con tu cuenta de escuela gratuita de {_days_} d\u00edas.",
school_user_onboarding_modal_body_with_params:"Adem\u00e1s acceso a todas nuestras actividades, participaci\u00f3n ilimitada para los estudiantes, y modo estudiante con {_days_} d\u00edas de Cuenta Escuela GRATIS",
googleSlides_editLesson_btn:"Editar esta lecci\u00f3n",
googleSlides_duplicateConfirm_title:"Esta lecci\u00f3n fue creada usando el complemento de Google Slides",
googleSlides_duplicateConfirm_message:"Las copias de esta lecci\u00f3n solo ser\u00e1n editables en Nearpod.",
flocabulary_edit_tooltip_init:"Obt\u00e9n acceso a nuestra biblioteca de videos de Flocabulary con una suscripci\u00f3n School o District de Flocabulary. ",
binders_welcome_overlay_title_step0_part1:"Cada momento importa.",
binders_welcome_overlay_title_step0_part2:"Aqu\u00ed es donde creas y env\u00edas un Nearpod Sub Plan.",
binders_welcome_overlay_title_step1_part1:"Ahora es tu turno.",
binders_welcome_overlay_title_step1_part2:"Env\u00edate un ejemplo de Sub Plan por correo electr\u00f3nico.",
binders_welcome_overlay_primary_text_button_step0:"Comenzar",
binders_welcome_overlay_primary_text_button_step1:"Enviar Sub Plan",
lessons_list_npp_long_label_unsynced:"Actualizado en Google Slides",
school_free_trial_overlay_admin_title_part1:"Mira y aprende sobre tu pase de COMPLETO-ACCESO.",
school_free_trial_overlay_admin_title_part2:"\u00a1Comience su prueba escolar gratuita de {_days_} d\u00edas!",
school_free_trial_overlay_admin_primary_button:"Comenzar",
school_free_trial_overlay_admin_secondary_button:"No Gracias",
Flocabulary_SubCategory_reading_writing:"Lectura y escritura",
Flocabulary_SubCategory_grammar:"Gram\u00e1tica",
Flocabulary_SubCategory_research_study:"Investigaci\u00f3n y capacidad de estudio",
Flocabulary_SubCategory_literature:"Literatura",
Flocabulary_SubCategory_addition_subtraction:"Suma y resta",
Flocabulary_SubCategory_multiplication_division:"Multiplicaci\u00f3n y divisi\u00f3n",
Flocabulary_SubCategory_numbers_operations:"N\u00fameros y operadores",
Flocabulary_SubCategory_expressions_equations:"Expresiones y ecuaciones",
Flocabulary_SubCategory_geometry_measurement:"Geometr\u00eda y medici\u00f3n",
Flocabulary_SubCategory_statistics_probability:"Probabilidad y estad\u00edstica",
Flocabulary_SubCategory_ratios_proportional_relationships:"Aspecto y proporciones relacionales",
Flocabulary_SubCategory_life_science:"Ciencia de la vida",
Flocabulary_SubCategory_earth_space_science:"Ciencia espacial y terrestre",
Flocabulary_SubCategory_physical_science:"Ciencia f\u00edsica",
Flocabulary_SubCategory_technology_and_engineering:"Tecnolog\u00eda e ingenier\u00eda",
Flocabulary_SubCategory_scientific_practices:"Pr\u00e1cticas cient\u00edficas",
Flocabulary_SubCategory_world_history:"Historia mundial antigua",
Flocabulary_SubCategory_modern_world_history:"Historia mundial moderna ",
Flocabulary_SubCategory_us_history:"Historia Estadounidense",
Flocabulary_SubCategory_civics:"C\u00edvica",
Flocabulary_SubCategory_geography:"Geograf\u00eda",
Flocabulary_SubCategory_historical_figures:"Figuras hist\u00f3ricas",
Flocabulary_SubCategory_holidays:"Vacaciones",
Flocabulary_SubCategory_economics:"Econom\u00eda",
Flocabulary_SubCategory_historical_practices:"Pr\u00e1cticas hist\u00f3ricas",
Flocabulary_SubCategory_issues_in_the_news:"Temas de las noticias",
Flocabulary_SubCategory_social_and_emotional_learning:"Aprendizaje social y emocional",
Flocabulary_SubCategory_health_wellness:"Salud y bienestar",
Flocabulary_SubCategory_financial_literacy:"Literatura financiera",
Flocabulary_SubCategory_vocabulary_peach:"Durazno - K",
Flocabulary_SubCategory_vocabulary_grape:"Uva - 1er grado",
Flocabulary_SubCategory_vocabulary_turquoise:"Turquesa - 2do grado",
Flocabulary_SubCategory_vocabulary_red:"Rojo - 3er grado",
Flocabulary_SubCategory_vocabulary_orange:"Naranja - 4to grado",
Flocabulary_SubCategory_vocabulary_indigo:"\u00cdndigo - 5to grado",
Flocabulary_SubCategory_vocabulary_green:"Verde - 6to grado",
Flocabulary_SubCategory_vocabulary_yellow:"Amarillo - 7mo grado",
Flocabulary_SubCategory_vocabulary_blue:"Azul - 8vo grado",
Flocabulary_SubCategory_vocabulary_sat:"Vocabulario SAT",
Flocabulary_SubCategory_week_in_rap:"La semana en Rap",
Flocabulary_SubCategory_week_in_rap_junior:"La semana en Rap Junior",
school_free_trial_overlay_user_title_part1:"\u00a1Usted ha sido invitado a una prueba de escuela gratuita por {_days_} d\u00edas!",
school_free_trial_overlay_user_title_part2:"Mira y aprende sobre tu pase de COMPLETO-ACCESO.",
school_free_trial_overlay_user_primary_button:"Comenzar",
school_free_trial_overlay_user_secondary_button:"No Gracias",
store_clear_standards:"Limpiar Standards",
deviceNotSupported_title_entering:"Toma un dispositivo con una pantalla m\u00e1s grande para crear tu lecci\u00f3n\u2026",
deviceNotSupported_title_exiting:"\u00a1O descarga nuestra aplicaci\u00f3n para lanzar tu presentaci\u00f3n!",
create_lesson_thumbnail_title:"Crea tu propia lecci\u00f3n:",
create_lesson_thumbnail_or:"o",
create_lesson_thumbnail_inGoogleSlides:"Lecci\u00f3n en Google Slides",
create_lesson_thumbnail_inNearpod:"Lecci\u00f3n en Nearpod",
global_continue:"Continuar",
drawit_enterTextPlaceholder:"Ingresa tu texto aqu\u00ed",
create_lesson_thumbnail_title_2:"Crea tu propia:",
sidebar_badge_title_admin:"Admin",
action_flocab_got_it:"Entendido, gracias!",
googleSlides_addTooltip_text:"\u00a1Ahora puedes crear lecciones atractivas e interesantes con la flexibilidad de Google y la magia de Nearpod... juntas!",
googleSlides_addTooltip_button:"\u00a1Ok, entendido!",
lessons_list_npp_long_label_newChanges:"\u00a1Nuevos cambios! Abrir en Google Slides",
create_lesson_inGoogleSlides:"Lecci\u00f3n en Google Slides",
deviceNotSupported_title_part1:"Para descargar o crear lecciones",
deviceNotSupported_title_part2:"por favor utilice una tableta, computadora de escritorio o port\u00e1til.",
deviceNotSupported_video_title:"Mira el video y aprende a c\u00f3mo crear lecciones",
drawit_imageUploadLocalFiles:"Explorar mis archivos",
lessons_list_npp_long_label_videoError:"Sin Guardar - Error en video",
googleSlides_confirm_gotIt:"Entendido",
googleSlides_confirm_addFeature_text:"\u00a1Agreguemos algunas caracter\u00edsticas de Nearpod! Prueba agregando una Encuesta para empezar.",
DrawIt_BackgroundEdit_ResetChanges:"Restablecer Ajustes",
store_lockedContent_withDistrictLibrary:"Hola! Por favor visita",
store_lockedContent_withoutDistrictLibrary:"Hola. Su instituci\u00f3n no tiene accesso a este area de Nearpod. Por favor contacte a su administrador por cualquier pregunta. ",
store_lockedContent_withDistrictLibrary_part2:"para contenido exclusivo.",
googleSlides_savePresentationFailed:"Qu\u00e9 pena! No pudimos guardar su presentaci\u00f3n, por favor int\u00e9ntelo nuevamente en unos minutos.",
game_activitiesLimit:"El l\u00edmite de preguntas es {_maxQuestions_}",
signUp_classlink_title:"Profesor - Registrarse con Classlink",
deviceNotSupported_activityOnboarding_entering:"Toma un dispositivo con una pantalla m\u00e1s grande para usar tu actividad\u2026",
deviceNotSupported_activityOnboarding_exiting:"\u00a1O descarga nuestra aplicaci\u00f3n para lanzar tu presentaci\u00f3n!",
onboarding_collaborate_step1_title_part1:"\u00a1Bienvenido a Nearpod! Estamos muy felices de que est\u00e9s aqu\u00ed.",
onboarding_collaborate_step1_title_part2:"Comencemos con nuestra actividad favorita - Nearpod Collaborate!",
onboarding_collaborate_step2_title:"\u00a1Crea tu primer Nearpod Collaborate!",
onboarding_collaborate_step2_button:"Crear",
deviceNotSupported_back_nearpod:"Volver a Nearpod.com",
onboarding_collaborate_step2_placeholder:"Ingrese un tema",
quiz_question_toggle_textType:"Texto",
quiz_question_toggle_imageType:"Im\u00e1genes",
quiz_question_toggle_label:"Elija su tipo de respuesta",
onboarding_collaborate_step2_animation_title:"\u00a1Excelente! \u00a1Ahora inicie la actividad y eleve su estado de superh\u00e9roe!",
quiz_answer_image_placeholder:"Elija una imagen",
googleSlides_duplicateConfirm_mainButton:"Aceptar y continuar",
googleSlides_duplicateConfirm_titleNew_1:"Esta lecci\u00f3n duplicada solo se abrir\u00e1",
googleSlides_duplicateConfirm_messageNew:"Para una experiencia de edici\u00f3n m\u00e1s flexible, recomendamos duplicar esta lecci\u00f3n directamente desde Google Slides.",
googleSlides_duplicateConfirm_mainButtonNew:"Duplicar en Nearpod",
googleSlides_duplicateConfirm_titleNew_2:"en Nearpod",
creationTool_activity_minimumQuestions:"Debe haber al menos {_minimumQuestions_} pregunta para esta actividad",
creationTool_activity_maximumAnswers:"No puedes incluir m\u00e1s de {_maximumAnswers_} respuestas",
creationTool_activity_minimumAnswers:"Por favor incluya al menos {_minimumAnswers_} respuestas",
creationTool_activity_missingFields:"Por favor completa los campos faltantes.",
upload_image_error:"Ha habido un error al subir la imagen",
creationTool_question_answerTypeToggleConfirm:"Est\u00e1s seguro que quieres cambiar el tipo de pregunta? Perder\u00e1s las respuestas que ya has completado.",
creationTool_activity_deleteConfirm:"Est\u00e1s seguro que deseas eliminar esta actividad?",
creationTool_activity_cancelConfirm:"Est\u00e1s seguro que deseas cancelar?",
creationTool_question_missingQuestionText:"Por favor incluye un texto para esta pregunta",
creationTool_question_missingAnswerText:"Por favor incluye un texto para esta respuesta",
creationTool_question_missingAnswerImage:"Por favor incluye una imagen para esta respuesta",
creationTool_question_missingCorrectAnswer:"Por favor selecciona una respuesta correcta",
whats_new_2:"Nuevo",
googleSlides_confirm_addFeature_title:"Esta diapositiva no es editable",
onboarding_collaborate_step2_placeholder_2:"Ej: \u00bfQu\u00e9 hiciste este verano?",
googleSlides_popUpBlocked:"Qu\u00e9 pena! Parece que nuestro pop up fue bloqueado. Por favor hace click en 'Intentar Nuevamente' para otorgarnos permisos para acceder a Google Slides",
global_tryAgain:"Intentar Nuevamente",
lessons_list_npp_action_launch_video:"Reproducir Video",
googleSlides_confirm_editAudio_text:"Ups! Por el momento, archivos de audio no pueden ser editados desde Google Slides. Elimina esta diapositiva y agrega una nueva de audio.",
googleSlides_confirm_editAudio_title:"Los Archivos de Audio no son Editables",
lessons_list_npp_long_label_audioError:"Sin Guardar - Error en audio",
lessons_list_npp_long_label_audioAndVideoError:"Sin Guardar - Error en archivos multimedia",
onboarding_collaborate_step2_placeholder_3:"Empieza con un tema",
onboarding_collaborate_step1_button_text:"\u00a1Tengo curiosidad, mu\u00e9strame!",
googleSlides_transition_overlay_title:"Llev\u00e1ndote a Google Slides...",
store_loading_more_lessons:"Cargando mas lecciones...",
onboarding_collaborate_step2_animation_title_2:"Guardando el pizarr\u00f3n y llevandote a tu biblioteca...",
onboarding_collaborate_demo_text:"\u00bfListo para crear el tuyo?",
onboarding_collaborate_demo_text_link:"Crear un tablero Colaborativo ahora \u203a",
onboarding_collaborate_step1_title_part1_2:"\u00a1Bienvenido a Nearpod!",
onboarding_collaborate_step1_title_part2_2:"Comencemos con nuestra actividad favorita.",
googleSlides_saveMediaFailed_title:"Oh! Esta lecci\u00f3n tiene un error",
googleSlides_saveMediaFailed_message:"Por favor regresa a Google Slides para arreglarlo.",
sidebar_menu_news_and_offers:"Noticias & Ofertas >",
sidebar_menu_news_and_offers_button:"Noticias & Ofertas",
sidebar_menu_explore_nearpod_2:"Lleva Nearpod a tu Escuela o Distrito >",
share_link_view_only:"Solo Previsualizaci\u00f3n",
share_link_editable:"Editable",
lesson_link:"link:",
global_slides_flocabulary:"Flocabulary",
firstLessonTooltip_liveLesson_text:"Inicie un recorrido r\u00e1pido para experimentar la magia de Nearpod en su sal\u00f3n de clases.",
firstLessonTooltip_liveLesson_button
:"Lanzar ahora!",
onboarding_collaborate_step1_title_part1_3:"\u00bfQuieres llegar a todos tus alumnos y darles voz?",
onboarding_collaborate_step1_title_part2_3:"Tenemos justo lo necesario...",
onboarding_collaborate_demo_text_link_2:"\u00a1Crea un Colaborativo!",
onboarding_collaborate_step2_title_2:"\u00a1Crea tu propia actividad Colaborativa!",
onboarding_collaborate_step2_button_2:"Guardar en una lecci\u00f3n ahora",
onboarding_collaborate_step2_animation_title_3:"Guardando tu lecci\u00f3n y llev\u00e1ndote a tu biblioteca...",
school_free_trial_overlay_user_secondary_button_sf:"No estoy interesado en una Prueba Gratuita de Escuela",
googleSlides_lmsRefresh_title:"Est\u00e1s en un LMS?",
googleSlides_lmsRefresh:"Por favor refresca esta p\u00e1gina cuando termines de editar tu lecci\u00f3n en Google Slides.",
googleSlides_lmsOpenGoogle_title:"Llev\u00e1ndote a Google Slides... ",
googleSlides_lmsOpenGoogle:"Para crear lecciones usando el add-on de Nearpod para Google Slides, necesitamos abrir una nueva pesta\u00f1a.",
googleSlides_savePresentationPermissionFailed:"Parece que has ingresado con m\u00e1s de una cuenta de Google. Por favor cierra sesi\u00f3n y vuelve a ingresar para guardar.",
googleSlides_savePresentationPermissionFailed_title:"Qu\u00e9 Pena!",
admin_onboarding_invite_teachers_title2_sf:" Comparte tu prueba de escuela GRATIS con tus colegas, para poder probar todas nuestras funcionalidades de escuela, como la biblioteca de escuela!",
admin_onboarding_express_invite_subtitle_sf:"Selecciona colegas con cuentas Nearpod e invita a otros para probarlo GRATIS!",
admin_onboarding_outcome_title_part1_with_param_sf:"Quieres mantener tu Licencia de Escuela luego de tu trial de {__days__}} d\u00edas SIN COSTO para ti?",
admin_onboarding_outcome_title_part2_sf:"Refiere a tu administrador y deja el resto a nosotros.",
admin_onboarding_outcome_refer_button_sf:"Refiere a tu Admin",
admin_onboarding_skip_this_button_sf:"Soy el admistrador",
admin_onboarding_refer_title_sf:"Refiere a tu Admin",
admin_onboarding_express_colleague_invitation_sf:"Ellos ser\u00e1n invitados a unirse a tu Prueba de Escuela y obtener acceso a + de 7.000 lecciones.",
global_slides_timeToClimb_descriptive:"Quiz Game",
onboarding_collaborate_step1_button_text_2:"\u00a1Incre\u00edble, mu\u00e9strame!",
onboarding_collaborate_demo_button:"\u00a1Crea un Colaborativo!",
onboarding_collaborate_demo_title:"",
flocabulary_limit_reached_overlay_email_body:"",
flocabulary_limit_reached_overlay_email_subject:"",
flocabulary_limit_reached_overlay_nudgemyadmin:"Dile a tu Admin",
immersive_reader_overlay_title:"\u00a1Haz que el aprendizaje sea m\u00e1s significativo!",
immersive_reader_overlay_subtitle_1:"Activa los potentes controles para los docentes como el Complemento de Immersive Reader para mejorar la lectura y la escritura de todos los alumnos.",
immersive_reader_overlay_primary_button:"\u00a1Ll\u00e9vame all\u00ed!",
immersive_reader_overlay_secondary_button:"No ahora, gracias",
immersive_reader_overlay_subtitle_2:"Encu\u00e9ntralos en tu perfil, en la pesta\u00f1a Avanzado.",
onboarding_collaborate_step1_title_part2_4:"Tenemos justo lo necesario. \u00a1Comienza con nuestra actividad de colaboraci\u00f3n!",
onboarding_collaborate_step1_button_text_3:"Impresionante, \u00a1comenzar ahora!",
global_mic_permissions_title:"Verificar... 1... 2...",
global_mic_permissions_text_1:"\u00a1Ahora puede grabar audio en esta diapositiva!",
global_mic_permissions_text_2:"Otorgue acceso a su micr\u00f3fono en la configuraci\u00f3n de su navegador.",
global_confirmation:"\u00a1Entendido!",
Flocabulary_Category_all_videos:"Todos los videos",
googleSlides_convertToDrawIt:"Convertir a Dibujo",
search_videos:"Buscar videos",
store_search_noresults_line1_empty_search:"\u00a1Hola! Tenemos incre\u00edbles lecciones pero ninguna que se corresponda con tu b\u00fasqueda.",
googleSlides_loading_convertToDrawIt:"Convirtiendo a Dibujo...",
activity_submissionFailed_title:"Qu\u00e9 pena!",
activity_submissionFailed_message:"No hemos podido enviar tu respuesta. Por favor int\u00e9ntalo nuevamente.",
global_search:"Buscar",
store_search_filter_lessons:"Lecciones",
store_search_filter_videos:"Videos",
store_search_filter_videos_and_lessons:"Todas las lecciones y videos",
goals_collaborate_card_title:"Discute con Colaborativo",
goals_collaborate_card_description:"Lanza un colaborativo para discutir o facilitar una lluvia de ideas.",
goals_oeq_card_title:"",
goals_oeq_card_description:"",
goals_ttc_card_title:"",
goals_ttc_card_description:"",
my_library_remove_folder_message_2:"\u00bfEst\u00e1s seguro de que deseas borrar esta carpeta? Todas tus lecciones tambi\u00e9n ser\u00e1n borradas.",
topbar_home_tooltip:"Men\u00fa Principal",
topbar_logo_tooltip:"Ofertas Personalizadas",
topbar_create_tooltip:"Crear",
topbar_cart_tooltip:"Carro",
topbar_avatar_tooltip:"Cuenta de Nearpod",
delete_folder_message_2:"\u00bfEst\u00e1s seguro de que deseas borrar esta carpeta? Todas tus lecciones tambi\u00e9n ser\u00e1n borradas.",
goals_congratulation_card_title:"Desaf\u00edo completado",
goals_congratulation_card_description:"\u00a1Felicidades, te ganaste una insignia!",
topbar_quicklaunch_tooltip:"Inicio R\u00e1pido",
flocabulary_limit_reached_overlay_email_body_2:"",
goals_collaborateCard_title_50:"Inicia una clase con Colaborativo!",
goals_collaborateCard_description_50:"Haz click aqu\u00ed para lanzar la actividad y facilitar la lluvia de ideas",
goals_collaborateCard_title_0:"Inicia una clase con Colaborativo!",
goals_collaborateCard_description_0:"Crealo ahora para facilitar la lluvia de ideas",
topbar_quickLaunch_tooltip_text:"Lanza tus actividades sin una presentaci\u00f3n. Slides no requeridos!\\n\\nCrea r\u00e1pidamente actividades como Pregunta Abierta o Dibuja y comp\u00e1rtela inmediatamente con tus estudiantes.",
topbar_quickLaunch_tooltip_button:"\u00a1Entendido!",
global_slides_timer:"Temporizador",
topbar_quicklaunch_title:"Inicio R\u00e1pido",
global_myActivities:"Mis Actividades",
icon_validate_invalid_type:"Tipo de archivo inv\u00e1lido. Por favor sube un",
video_preview_credits:"Cr\u00e9ditos",
video_preview_grade:"Nivel",
video_preview_grades_plural_part:"es",
goals_timeToClimbCard_description_0:"Crea una ahora para liderar la revisi\u00f3n gamificada",
goals_timeToClimbCard_title_0:"Cuestionario gamificado",
goals_collaborate_card_button:"Crea uno ahora",
goals_timeToClimbCard_title_50:"Cuestionario gamificado",
goals_timeToClimbCard_description_50:"Haga clic aqu\u00ed para experimentar la version gamificada",
goals_timeToClimbCard_title_100:"Desaf\u00edo completado",
goals_timeToClimbCard_description_100:"\u00a1Felicidades, te ganaste una insignia!",
goals_oeqCard_description_0:"Crea un cuestionario interactivo para comenzar tu clase",
goals_oeqCard_title_0:"Cuestionario interactivo",
goals_oeqCard_title_50:"Cuestionario interactivo",
goals_oeqCard_description_50:"Haz click aqu\u00ed para experimentar un cuestionario interactivo",
googleSlides_copyPasteTooltip_text:"Nota: Las diapositivas de Nearpod no pueden ser copiadas y pegadas",
goals_oeq_referenceMedia_required:"Tu pregunta abierta interactiva requiere una imagen.",
goals_oeqCard_description_100:"\u00a1Felicidades, te ganaste una insignia!",
goals_oeqCard_title_100:"Desaf\u00edo completado",
quicklaunch:"Inicio Rapido",
flocabulary_no_results_search:"Hola! Tenemos excelentes videos pero ninguno con '{_query_}'. Por favor intenta con otras palabras.",
onboarding_collaborate_step1_title_part1_4:"Bienvenido a Nearpod!",
onboarding_collaborate_step1_button_text_4:"Impresionante, \u00a1comencemos!",
onboarding_collaborate_step1_title_part2_5:"\u00a1Comencemos con una actividad Colaborativa!",
global_university:"Universidad",
onboarding_collaborate_demo_text_2:"\u00bfEst\u00e1s listo para realizar una pregunta a tus alumnos?",
onboarding_collaborate_step2_placeholder_4:"Escribe tu pregunta aqu\u00ed",
time_to_climb_title_part1_v1:"\u00a1Bienvenido a Nearpod!",
time_to_climb_title_part2_v1:"Consigue tu juego con nuestro nuevo cuestionario gamificado.",
time_to_climb_text_part1_v1:"Comience ahora con lecciones prefabricadas GRATUITAS",
time_to_climb_text_part2_v1:"disponible para todos los grados y materias!",
time_to_climb_primaryButton_v1:"Obt\u00e9n lecciones",
quicklaunch_launch_error_confirm:"Algo salio mal y tu lecci\u00f3n esta tardando mas en guardarse de lo esperado. Por favor vuelva a intentar.",
topbar_home_tooltip_2:"Mi Biblioteca",
interactive_video_select_video_id:"Video ID",
interactive_video_select_duration:"Duraci\u00f3n",
interactive_video_select_credits:"Creditos",
homework_share_code_text2:"\u00danete con este CODE en join.nearpod.com o en la app",
reference_media_addReferenceImage:"Agregar imagen de referencia",
quick_launch_timer_title:"Temporizador de Inicio R\u00e1pido",
admin_dashboard_toolbar_hint_text:"\u00a1Prueba nuestro nuevo Panel de Administrador!",
admin_dashboard_toolbar_hint_button:"\u00a1Echa un vistazo!",
creationTool_question_missingQuestionTextOrImage:"Por favor incluye un texto o una imagen para esta pregunta",
SignUpEmailTermsError2:"",
logIn_title_2:"Profesores",
logIn_subtitle:"Ingreso",
signup_teacher_subtitle:"Registrate gratis",
signup_teacher_separator:"O",
signup_student_title:"Estudiantes",
signup_student_subtitle:"\u00danete a una lecci\u00f3n",
signup_student_text_part1:"\u00bfNo tienes un C\u00d3DIGO?",
signup_student_text_part2:"Prueba Nearpod usando ",
signup_student_text_part3:"MAGIC",
quick_launch_timer_start:"Empezar Temporizador",
quick_launch_timer_cancel:"Cancelar Temporizador",
signUp_form_mustAcceptTerms2:"Debes confirmar tu edad y aceptar los T&C.",
signUp_logIn_label_2:"\u00bfYa tienes una cuenta? ",
signUp_terms_start_2:"Acepto los ",
signUp_terms_end_2:" y tengo m\u00e1s de 13 a\u00f1os de edad.",
logIn_signUp_label_2:"\u00bfNo tienes un cuenta? ",
oeq_panel_title:"Pregunta abierta",
quiz_panel_title:"Cuestionario",
poll_panel_title:"Encuesta",
quick_launch_timer_controls_pause:"Pausar",
quick_launch_timer_controls_restart:"Reiniciar",
quick_launch_timer_controls_add_time:"Agregar \\n30 segundos",
quick_launch_timer_controls_remove_time:"Sacar \\n30 segundos",
mcq_panel_title:"Pregunta de Opci\u00f3n M\u00faltiple",
quick_launch_timer_controls_resume:"Resumir",
quick_launch_timer_remove_time_toast:"30 segundos sacados",
quick_launch_timer_add_time_toast:"30 segundos agregados",
quick_launch_timer_pause_time_toast:"Temporizador pausado. Presion\u00e1 Resumir para continuar",
quick_launch_timer_resume_time_toast:"Temporizador resumido",
interactive_video_foc_multiple_choice_button:"Mostrar Soluci\u00f3n",
interactive_video_look_at_teacher_title:"\u00a1Los ojos al frente!",
interactive_video_look_at_teacher_description:"El video se reproducir\u00e1 en el dispositivo de tu profesor. Regresa aqu\u00ed cuando sea el momento de una actividad.",
quicklaunch_cancel_timer_subtitle:"\u00bfEst\u00e1s seguro que deseas cancelar?",
quicklaunch_cancel_timer_not_now_button:"No Ahora",
quicklaunch_cancel_timer_confirm_button:"Si, Cancelar",
signup_with_office:"Office 365",
quicklaunch_restart_timer_title:"Reiniciar Temporizador",
quicklaunch_restart_timer_subtitle:"\u00bfEst\u00e1s seguro que deseas reiniciar?",
quicklaunch_restart_timer_confirm_button:"Si, Reiniciar",
signup_with:"Reg\u00edstrate con",
signup_with_google:"Google",
quick_launch_timer_confirm_cancel_modal_toast:"Temporizador cancelado",
teachers_title:"Profesores",
signup_with_clever:"Clever",
signup_with_classlink:"Classlink",
quick_launch_timer_confirm_restart_modal_toast:"Temporizador reiniciado!",
interactive_video_ls_student_column_header:"Estudiante",
interactive_video_ls_answer_column_header:"Respuesta",
interactive_video_ls_participation_column_header:"Participaci\u00f3n",
interactive_video_ls_no_answers_yet:"A\u00fan no hay respuestas",
add_dropdown_interactiveVideo:"Video Interactivo",
interactive_video_student_oeq_answer_placeholder:"\u00bfListo? Escribe tu respuesta aqu\u00ed.",
interactive_video_student_oeq_submit:"Enviar",
navigationMenu_upgrade_label:"Actualiza",
navigation_menu_account:"Cuenta de Nearpod",
interactive_video_upload_success:"Video subido",
interactive_video_creation_replaceVideo:"Reemplazar Video",
interactive_video_topbar_settings:"Configuraci\u00f3n",
navigationMenu_notificationPreferences_label:"Administrar notificaciones",
navigationMenu_notificationPreferences_enableEmailNotification_text:"Notificaciones de correo electr\u00f3nico",
navigationMenu_notificationPreferences_enableEmailNotification_description:"Reciba notificaciones por correo electr\u00f3nico de recomendaciones, ofertas, actividad estudiantil y su actividad semanal.",
navigationMenu_notificationPreferences_note:"Siempre recibir\u00e1s notificaciones por correo electr\u00f3nico de lecciones compartidas.",
navigationMenu_account_label:"Administrar cuenta",
interactive_video_creation_premade:"No tienes un video para utilizar?",
interactive_video_creation_premade_link:"Proba uno de nuestros videos!",
onboarding_collaborate_step1_button_text_5:"\u00a1Vamos!",
onboarding_collaborate_step1_title_part2_6:"Preparate para darle interacci\u00f3n a todas tus presentaciones.",
onboarding_collaborate_step2_title_3:"Create tu propia activdad Colaborativa!",
onboarding_collaborate_step2_placeholder_5:"\u00bfQu\u00e9 quieres preguntarle a tus estudiantes?",
onboarding_collaborate_step2_button_3:"Guardar",
navigationMenu_notificationPreferences_updateEmailNotification_success:"Su configuraci\u00f3n de notificaciones por correo electr\u00f3nico se ha guardado exitosamente.",
onboarding_collaborate_step2_animation_title_4:"Guardando tu actividad y llevandote a tu biblioteca...",
interactive_video_title:"Video Interactivo sin t\u00edtulo",
add_to_districtLibrary:"Agregar al Distrito",
add_to_schoolLibrary:"Agregar a la Escuela",
navigationMenu_help_label:"Ayuda",
navigationMenu_helpCenter_label:"Centro de Ayuda",
navigationMenu_teacherResources_label:"Recursos de Profesor",
navigationMenu_whatsNew_label:"Nuevo",
navigationMenu_communities_label:"Comunidades",
navigationMenu_pricing_label:"Precios",
navigationMenu_contactUs_label:"Cont\u00e1ctanos",
add_activity_at:"Agregar Actividad en",
userSchoolProfile_overlay_title:"Cu\u00e9ntanos acerca de ti.",
userSchoolProfile_overlay_subtitle:"En base a esta informaci\u00f3n, obtendr\u00e1s consejos, ofertas y lecciones gratuitas.",
userSchoolProfile_overlay_mainButton_text:"Actualizar",
interactive_video_oeq_submission_no_answer:"No hay respuesta",
userSchoolProfile_overlay_school_title:"Escuela",
userSchoolProfile_overlay_school_placeholder:"Escribe el nombre de tu escuela",
userSchoolProfile_overlay_form_grades_label:"Niveles",
userSchoolProfile_overlay_form_grades_placeholder:"Selecciona uno o m\u00e1s niveles",
userSchoolProfile_overlay_school_notFound:"\u00a1Haznos saber!",
interactive_video_collapse_tooltip:"Colapsar",
interactive_video_expand_tooltip:"Expandir",
userSchoolProfile_overlay_form_role_label:"Rol",
userSchoolProfile_overlay_form_role_placeholder:"Selecciona tu rol principal",
interactive_video_settingsModal_title:"Detalles del video interactivo",
interactive_video_settingsModal_inputPlaceholder:"Introduce el t\u00edtulo del video",
interactive_video_settingsModal_toggle:"Agregar materia y nivel(es)",
interactive_video_settingsModal_submit:"Salvar y salir",
userSchoolProfile_overlay_form_subjects_label:"Materias",
userSchoolProfile_overlay_form_subjects_placeholder:"Selecciona una o m\u00e1s materias",
interactive_video_student_oeq_submit_confirmation_title:"\u00bfEst\u00e1s seguro?",
interactive_video_student_oeq_submit_confirmation_text:"Una vez que env\u00edes tu respuesta, no podr\u00e1s editarla.",
interactive_video_student_sp_submit_success_title:"\u00a1Listo!",
interactive_video_student_oeq_submit_success_text:"Tu respuesta fue enviada.\\nEl video continuar\u00e1 en el dispositivo de tu profesor.",
interactive_video_student_oeq_submit_confirmation_cancel:"Revisar respuesta",
interactive_video_student_oeq_submit_confirmation_accept:"Enviar",
preview_video_embedded_activities_Poll:"Encuesta",
preview_video_embedded_activities_MCQ:"Pregunta de Opci\u00f3n M\u00faltiple",
preview_video_embedded_activities_OEQ:"Pregunta Abierta",
preview_video_embedded_activities_title:"\\nEmbedded Activities:\\n",
flipgrid_creationTool_student_label:"Inserte el enlace para unirse al tema",
flipgrid_creationTool_student_helper_title:"Ingresa la URL de flipgrid del Estudiante",
flipgrid_creationTool_student_helper_description
:"Desde la grilla, selecciona \u2018Share\u2019 y luego haz click para copiar el link",
flipgrid_creationTool_teacher_label:"Inserte la URL del tema desde el navegador",
flipgrid_creationTool_teacher_helper_title:"Ingresa la URL de flipgrid del Profesor",
flipgrid_creationTool_teacher_helper_description:"Dir\u00edgete al panel de control de tu grilla y copia la URL del explorador",
global_slides_flipgrid:"Flipgrid",
my_account_profile_image_save_success:"Imagen de perfil subida correctamente.",
navigationMenu_endImpersonate:"Finalizar impersonalizacion",
interactive_video_activityPicker_title:"Agregar actividad",
student_lead_welcome_title:"Bienvenido a tu lecci\u00f3n",
student_lead_login_title:"Ingreso de Estudiante",
student_lead_welcome_message:"\u00bfTienes una cuenta? ",
student_lead_welcome_message_link:"Ingresa aqu\u00ed",
student_lead_login_message:"\u00bfNo tienes una cuenta? ",
student_lead_login_message_link:"\u00danete como invitado",
student_lead_welcome_nameInput:"Nombre",
student_lead_welcome_optionalInput:"Otro nombre opcional",
student_lead_welcome_submitButton:"\u00danete a la lecci\u00f3n",
student_lead_welcome_nameInput_error:"Por favor ingresa tu nombre aqu\u00ed",
onboarding_distance_learning_title_part2:"Crea experiencias de aprendizaje din\u00e1micas e interactivas para tus estudiantes",
onboarding_distance_learning_button_text:"\u00a1Vamos!",
onboarding_distance_learning_title_part1:"Mant\u00e9n a tus estudiantes interesados en aprender... donde sea que est\u00e9n",
interactive_video_toggle_modal_subtitle_first:"\u00bfTe gustar\u00eda activar el Modo Interactivo?",
interactive_video_toggle_modal_subtitle_second:"El video se detendr\u00e1 en los momentos clave para proporcionar preguntas para la discusi\u00f3n y exploraci\u00f3n del tema.",
interactive_video_toggle_modal_title:"Este es un Video Interactivo!",
firstLessonTooltip_liveLesson_text2:"Mueve el cursor por encima de tu lecci\u00f3n y elige entre lanzar una Lecci\u00f3n en Vivo o un modo Student-Paced. ",
myLibrary_silverstudentPaced_title:"Accede a Student-Paced para acompa\u00f1ar a tus alumnos durante COVID-19",
myLibrary_silverstudentPaced_subtitle:"Para ayudar durante este tiempo de cierre de colegios, Nearpod ha habilitado Student-Paced para usuarios Silver hasta el 30 de Abril.",
myLibrary_silverstudentPaced_button:"Accede!",
lessons_list_npp_action_live_lesson_with_zoom:"Sesi\u00f3n Live | Zoom",
school_trial_welcome_title_part1_2:"\u00bfListo para desbloquear todo el poder de Nearpod?",
admin_onboarding_invite_teachers_title2_2:"\u00a1Presiona abajo para actualizar a estos profesores tambi\u00e9n!",
admin_onboarding_invite_teachers_textButton_2:"Actualizar colegas",
admin_onboarding_express_text_2:"\u00bfQuieres invitar m\u00e1s profesores?",
admin_onboarding_express_add_colleague_2:"Agrega a un colega",
admin_onboarding_express_colleague_invitation_2:"Ser\u00e1n invitados a unirse a tu escuela Nearpod.",
admin_onboarding_invite_teachers_confirm_btn_one_2:"Continuar",
admin_onboarding_outcome_title_part1_2:"\u00bfQuieres tener m\u00e1s profesores de tu escuela en Nearpod?",
admin_onboarding_outcome_title_part2_2:"Refiere a tu administrador y deja que nos encarguemos del resto.",
admin_onboarding_outcome_refer_button_2:"Comienza",
admin_onboarding_express_congrats_title_2:"\u00a1Ya est\u00e1 todo listo!",
admin_onboarding_express_congrats_subtitle_2:"Ahora tienes acceso a todas las herramientas de la edici\u00f3n school de Nearpod, incluyendo la biblioteca de lecciones y el modo Homework.",
admin_onboarding_express_congrats_button_2:"Comienza",
myLibrary_studentPaced_viewProgress:"Ver Progreso",
lessons_list_more_actions_share_label:"Compartir Con Profesores",
interactive_video_interactive_mode_toggle:"Modo Interactivo",
interactive_video_exit_confirm_message:"\u00bfSeguro que desea salir?",
interactive_video_exit_tooltip:"Cerrar (x)",
navigationMenu_manage_label:"Panel de Admin",
collaborate_moderateStudentPaced_text:"Ahora podr\u00e1 moderar las pizarras de Colaborativo! en lecciones de modo estudiante.",
preview_front_of_classroom_button:"Frente de la Clase",
preview_front_of_classroom_description:"Comparte desde tu dispositivo a la pizarra interactiva",
preview_all_devices_button:"Todos los Dispositivos",
preview_all_devices_description:"Control del ritmo en su dispositivo, los estudiantes responden a las preguntas en sus dispositivos",
preview_assign_student_paced_button:"Asignar a ritmo de estudiante",
preview_assign_student_paced_description:"Los estudiantes completan la asignatura por su cuenta",
preview_teach_button:"Ense\u00f1ar",
interactive_video_details:"Detalles de video interactivo",
reference_media_addReference:"Agregar materiales, videos o audios",
navigationMenu_settings_label:"Configuraciones del profesor",
myLibrary_silverstudentPaced_subtitle2:"Durante este per\u00edodo de colegios cerrados, Nearpod proporciona acceso a Student-Paced a todos los maestros hasta el 30 de Junio.",
interactive_video_student_sp_submit_success_continue:"Continuar",
interactive_video_student_sp_submit_success_text:"Tu respuesta fue enviada.",
myLibrary_lessonLaunchNotReady_title:"Lo lamentamos! Su lecci\u00f3n no est\u00e1 lista a\u00fan.",
myLibrary_lessonLaunchNotReady_messageWithTime:"Por favor vuelva a intentarlo en {_seconds_} segundos.",
myLibrary_lessonLaunchNotReady_message:"Por favor vuelva a intentarlo.",
interactive_video_activity_updated:"Actividad Actualizada",
lead_page_waiting_modal_title:"\u00a1Bienvenido!",
lead_page_waiting_modal_text:"Por favor espera a que tu profesor comience la lecci\u00f3n.",
fillInTheBlanks_session_header_title:"Completar los espacios",
fillInTheBlanks_session_header_button:"Ver Respuestas",
fillInTheBlanks_session_dashboard_student:"Estudiante",
fillInTheBlanks_session_dashboard_matches:"Puntaje",
fillInTheBlanks_session_dashboard_title:"Resultados de la clase",
video_quality:"Calidad de Video",
interactive_video_activity_added:"Actividad Agregada",
create_lesson_inNearpod:"Lecci\u00f3n en Nearpod",
poll_submit_required_text:"Ups! Al parecer no has contestado esta pregunta. Por favor env\u00eda tu elecci\u00f3n antes de continuar.",
oeq_submit_required_text:"Ups! Al parecer no has contestado esta pregunta. Por favor env\u00eda una respuesta antes de continuar.",
quiz_submit_required_text:"Ups! Al parecer no has contestado todas las preguntas. Por favor env\u00eda tus respuestas antes de continuar.",
qa_submit_required_text:"Ups! Parece que no has contestado la pregunta. Por favor env\u00eda una respuesta antes de continuar.",
drawit_submit_required_text:"Ups! Esta p\u00e1gina est\u00e1 en blanco. Por favor env\u00eda un dibujo antes de continuar.",
requiredActivities_toggle_label:"Respuestas obligatorias",
interactive_video_reports_title:"Reporte de Video",
navigationMenu_upgrade_label2:"Actualizar cuenta",
navigationMenu_settings_label2:"Configuraciones de las lecciones",
navigationMenu_help_label2:"Ayuda & FAQs",
navigationMenu_helpCenter_label2:"FAQs",
interactive_video_toggle_modal_subtitle:"\u00bfTe gustar\u00eda activar el Modo Interactivo\\nEl video se detendr\u00e1 en los momentos clave para proporcionar preguntas para la discusi\u00f3n y exploraci\u00f3n del tema.",
interactive_video_activity_deleted:"Actividad Borrada",
interactive_video_student_oeq_back_to_video:"Volver al video",
interactive_video_student_oeq_back_to_video_confirmation_accept:"Si",
interactive_video_student_oeq_back_to_video_confirmation_cancel:"Cancelar",
interactive_video_student_oeq_back_to_video_confirmation_text:"Volver\u00e1s al video.",
interactive_video_student_oeq_back_to_video_confirmation_title:"\u00bfEst\u00e1s seguro?",
global_slides_mcq:"Pregunta de opci\u00f3n m\u00faltiple",
interactive_video_previousActivity_tooltip:"Actividad previa",
interactive_video_nextActivity_tooltip:"Pr\u00f3xima actividad",
my_account_menu_navigation_payment:"Detalles del pago",
my_account_payment_title:"Detalles del pago",
my_account_payment_content_subtitle:"Detalles del pago",
my_account_payment_content_description:"Administra tu suscripci\u00f3n y tus m\u00e9todos de pago.",
my_account_payment_content_button:"Administrar detalles de pago",
interactive_video_activity_delete_confirm:"Si, Borrar",
interactive_video_activity_delete_confirmation:"Est\u00e1s seguro que deseas borrar esta actividad?",
delete_activity_button_label:"Borrar Actividad",
desmos_title_BlankGraph:"Gr\u00e1fico en blanco",
do_not_show_again:"No mostrar de nuevo",
create_toolbar_feedback_button:"Env\u00edanos Feedback",
mic_asking_permissions_title:"Darle acceso al micr\u00f3fono a Nearpod",
mic_asking_permissions_message:"Para darle acceso al micr\u00f3fono a Nearpod, por favor vaya a la configuraci\u00f3n de su dispositivo.",
mic_asking_permissions_cancel:"Cancelar",
mic_asking_permissions_goto_settings:"Ir a la configuraci\u00f3n",
interactive_video_student_mcq_submit_confirmation_accept:"Enviar",
interactive_video_student_mcq_submit_confirmation_text:"Una vez que env\u00edes tu respuesta, no podr\u00e1s editarla.",
interactive_video_student_mcq_submit_confirmation_title:"\u00bfEst\u00e1s seguro?",
interactive_video_student_mcq_submit_confirmation_cancel:"Revisar respuesta",
interactive_video_guest_modal_title:"Lo lamentamos!",
interactive_video_guest_modal_description:"La vista de estudiante no est\u00e1 soportada en esta diapositiva.",
mcq_answers_validation_minimum:"Por favor incluye al menos dos opciones de respuesta.",
mcq_answers_validation_maximum:"Las preguntas pueden contener solo hasta 15 opciones de respuesta.",
video_playback_speed:"Velocidad",
interactive_video_settings_playback_speed_normal:"Normal",
interactive_video_settings_playback_speed_slow:"Lento",
interactive_video_settings_playback_speed_slowest:"M\u00e1s lento",
oeq_student_recording_audio_recorder_disabled:"La grabaci\u00f3n de audio no est\u00e1 habilitada",
googleSlides_clickableLinks_linksList_title:"Selecciona el link que quieres visitar.",
interactive_video_student_mcq_submit:"Enviar",
interactive_video_student_mcq_back_to_video:"Volver al Video",
interactive_video_student_mcq_continue:"Continuar",
cookiesNotSupported_mainButton:"Habilitar cookies",
cookiesNotSupported_title:"Oops! Parece que tu navegador est\u00e1 bloqueando las cookies para Nearpod",
cookiesNotSupported_subtitle:"Luego de habilitar las cookies, haz click en Reintentar!",
cookiesNotSupported_secondaryButton:"Reintentar",
preview_all_devices_button_2:"Participaci\u00f3n En Vivo",
preview_all_devices_description_2:"Controla el ritmo en tu propio dispositivo; estudiantes responden a preguntas en sus dispositivos.",
preview_assign_student_paced_button_2:"Ritmo De Estudiante",
preview_assign_student_paced_description_2:"Los estudiantes completan la asignatura por su cuenta.",
preview_front_of_classroom_button_2:"Frente de la Clase",
preview_front_of_classroom_description_2:"Presenta desde tu dispositivo para que la clase lo vea.",
googleSlides_savePresentationFailed_alreadyPublished:"Su presentaci\u00f3n ya est\u00e1 guardada. Recargando...",
global_complete_fields:"Por favor completa los siguientes campos obligatorios.",
signup_emailAlreadyRegistered_error:"Ya existe una cuenta con este correo electr\u00f3nico. Por favor inicie sesi\u00f3n",
interactive_video_settingsModal_support_title:"Configuraciones de soporte",
interactive_video_settingsModal_support_update_poster:"Actualizar poster",
lessons_list_npp_action_launch_video_2:"Frente De Clase",
lessons_list_npp_action_live_participation:"Participar en Vivo",
preview_toolbar_share_button:"Share Preview",
preview_live_participation_button:"Participar en Vivo",
create_toolbar_help_placeholder_2:"En Nearpod siempre buscamos maneras de mejorar el producto, por favor dinos lo que piensas.",
interactive_video_activity_cancel_confirm:"\u00bfEst\u00e1s seguro de querer cancelar? Perder\u00e1s tus cambios.",
lessons_list_npp_status_almostThere:"Finalizando",
interactive_video_notSupported_modal_title:"Lo lamentamos!",
interactive_video_notSupported_modal_description:"Este contenido no est\u00e1 soportado en este tama\u00f1o de pantalla.",
interactive_video_teacher_mcq_title_answers:"Respuestas",
interactive_video_teacher_mcq_title_selected:"Seleccionado",
interactive_video_teacher_mcq_option_no_answer:"Sin respuesta",
interactive_video_teacher_mcq_results_correct:"Correctas",
interactive_video_teacher_mcq_results_incorrect:"Incorrectas",
interactive_video_teacher_mcq_results_no_answer:"Sin respuesta",
interactive_video_teacher_mcq_share:"Compartir Soluci\u00f3n",
interactive_video_teacher_mcq_unshare:"Dejar de compartir",
student_lead_welcome_title_part1:"Bienvenido a ",
student_lead_welcome_title_part2:"Tu Lecci\u00f3n",
student_lead_login_title_part1:"Ingreso de ",
student_lead_login_title_part2:"Estudiante",
help_box_send_feedback_title:"Env\u00edenos Su Feedback",
store_thumbnail_preview_text_folder:"Ver mas",
store_thumbnail_preview_text_bundle:"Vista Previa Bundle",
store_thumbnail_preview_text_lesson:"Vista Previa Leccion",
nickelTour_button_complete_text:"Empezar!",
nickelTour_button_common_text:"Siguiente",
nickelTour_lessonInteractive_title:"Haz cualquier lecci\u00f3n interactiva",
nickelTour_lessonInteractive_description:"Con Nearpod, puedes agregar evaluaciones formativas directamente en tu lecci\u00f3n para impulsar la participaci\u00f3n de los estudiantes.",
nickelTour_preMadeLessons_title:"No es necesario planificar desde cero",
nickelTour_preMadeLessons_description:"Comienza con un recurso que ya tenga o consulte nuestras lecciones prefabricadas y alineadas con los est\u00e1ndares.",
nickelTour_reports_title:"Desbloquea la comprensi\u00f3n del estudiante",
nickelTour_reports_description:"Obt\u00e9n informaci\u00f3n en tiempo real sobre los conocimientos de los estudiantes y accede a los reportes despu\u00e9s de tu lecci\u00f3n.",
interactive_video_settingsModal_support_transcript:"Handout: Transcript",
interactive_video_settingsModal_support_question:"Handout: Video Questions",
interactive_video_student_live_submit_success_title:"\u00a1Listo!",
interactive_video_student_live_submit_success_text:"Tu respuesta fue enviada.",
interactive_video_banner_title:"Esto es una vista previa",
interactive_video_student_sp_oeq_submit_success_continue:"Continuar",
interactive_video_student_sp_oeq_submit_success_text:"Tu respuesta fue enviada.",
interactive_video_student_oeq_submit_success_title:"\u00a1Listo!",
nickelTour_tooltip_button:"\u00a1Echale un vistazo!",
nickelTour_tooltip_description:"Inicia una discusi\u00f3n en clase con un tablero colaborativo.",
interactive_video_teacher_breakpointReached_title:"Listos para comenzar?",
interactive_video_teacher_breakpointReached_message:"Al seleccionar \"Comenzar\" el video se pausar\u00e1 donde est\u00e9n los estudiantes y se mostrar\u00e1 la actividad.",
interactive_video_teacher_breakpointReached_confirm:"Comenzar",
interactive_video_teacher_breakpointReached_dismiss:"Volver",
confirm_storage_paywall_button_text:"Actualizar",
goals_collaborateCard_description_50_v2:"Ahora experimenta la magia invitando a tus estudiantes a participar",
createToolbar_suggestionsButton:"Env\u00edanos Sugerencias",
helpBox_sendSuggestionsTitle:"Env\u00edenos Sus Sugerencias",
interactive_video_teacher_breakpointReached_apply:"Aplicar a todas las actividades",
schoolProfile_overlay_title:"Cu\u00e9ntanos un poco m\u00e1s acerca de ti",
schoolProfile_overlay_subtitle:"Por favor completa tu perfil mientras terminamos de configurar tu biblioteca.",
schoolProfile_overlay_school_label:"Escuela",
schoolProfile_overlay_school_placeholder:"Escribe el nombre de tu escuela",
schoolProfile_overlay_school_notFound:"\u00a1Haznos saber!",
schoolProfile_overlay_role_label:"Rol",
schoolProfile_overlay_role_placeholder:"Selecciona tu rol principal",
schoolProfile_overlay_mainButton_text:"\u00a1Vamos!",
nickelTour_tooltip_description_2:"Los tableros de actividad Colaborativa! son geniales para juntar las ideas y opiniones de tu clase.",
max_presentation_size_reached__upgrade_button_text:"Actualizar",
max_presentation_size_reached__contact_button_text:"OK",
max_presentation_size_reached__upgrade_text:"Esta presentaci\u00f3n excede los {_maxSizeOfPresentations_}MB de tama\u00f1o l\u00edmite por presentaci\u00f3n en su tipo de cuenta.",
max_presentation_size_reached__contact_text:"Esta presentaci\u00f3n ha excedido el l\u00edmite de tu plan. El plan actual soporta hasta {_maxSizeOfPresentations_}MB. Por favor cont\u00e1ctanos enviando un correo a support@nearpod.com para saber m\u00e1s acerca de c\u00f3mo expandir estos l\u00edmites.",
video_picker_tab_youtube:"YouTube",
video_picker_tab_video_library:"Biblioteca de Videos",
video_picker_tab_video_upload_video:"Subir un video",
interactive_video_teacher_breakpointReached_dismiss_2:"Volver al video",
schoolProfile_overlay_title_2:"Por favor cu\u00e9ntanos un poco m\u00e1s acerca de ti",
schoolProfile_overlay_subtitle_2:"H\u00e1znos saber tu escuela y tu rol para que podamos configurar tu biblioteca.",
schoolProfile_overlay_mainButton_text_2:"Listo!",
myLibrary_silverstudentPaced_subtitle3:"Durante este per\u00edodo de colegios cerrados, Nearpod proporciona acceso a Student-Paced a todos los maestros hasta el 31 de Octubre.",
search_box_placeholder_text_videos:"Buscar videos",
main_header_dropdown_videosLibrary:"Librer\u00eda de videos",
video_settings_untitled_error:"Coloc\u00e1 un t\u00edtulo a tu video",
nearpod_library:"Biblioteca de Nearpod",
paywalls_not_enough_space:"Haz alcanzado el m\u00e1ximo almacenamiento de {_maxStorage_}MB de tu licencia. Actualiza ahora para aumentar tu espacio de almacenamiento.",
paywalls_not_enough_space_upgrade:"Actualizar",
paywalls_not_enough_space_contact:"Cont\u00e1ctanos",
nearpod_library_search_box_placeholder_text:"Buscar lecciones en la Biblioteca Nearpod",
interactive_video_upload_error:"Hubo un error procesando este video. Por favor, intenta nuevamente o intenta con un video diferente.",
interactive_video_reports_info_message:"Clickea en los puntos azules para revisar las respuestas de los estudiantes para cada pregunta. Navega entre las distintas preguntas con las flechas de la esquina superior derecha.",
interactive_video_reports_info_title:"Bienvenido al reporte de video",
store_search_noresults_line2_urllink_default:"mailto:feedback@nearpod.com?subject=I got no results on my Nearpod Library search!",
store_search_noresults_line2_urllinkurl_flocabulary:"https:\\\/\\\/www.flocabulary.com",
add_dropdown_interactiveVideo_new:"Video",
interactive_video_teacher_oeq_share_participant_submission:"Compartir",
interactive_video_teacher_oeq_unshare_participant_submission:"Dejar de compartir",
handouts_item_title_transcript:"Transcript",
handouts_item_title_video_questions:"Video Questions",
interactive_video_reports_info_continue
:"Continuar",
interactive_video_cancel_confirm:"Est\u00e1s seguro que deseas cancelar? Perder\u00e1s tus cambios.",
interactive_video_uploadingOverlay_processingMessage_1:"\u00a1Si\u00e9ntate y rel\u00e1jate, tu video estar\u00e1 listo en breve!",
interactive_video_uploadingOverlay_processingMessage_2:"Si quieres intentar m\u00e1s tarde, puedes cancelar en cualquier momento.",
interactive_video_uploadingOverlay_cancelButton:"Cancelar subida de video",
interactive_video_uploadingOverlay_uploading:"Subiendo...",
interactiveVideo_handouts_transcript:"Transcripci\u00f3n",
interactiveVideo_handouts_videoQuestions:"Preguntas",
store_picker_search_noresults:"\u00a1Hola! Tenemos incre\u00edbles lecciones y videos pero ninguno con '%s'.",
interactive_video_topbar_button_back:"Back",
video_topbar_button_back	:"Back",
student_lead_welcome_message_2:"Ya tienes una cuenta? ",
student_lead_welcome_message_link_2:"Ingresa",
student_lead_welcome_submitButton_2:"\u00danete",
main_topBar_addButton_label:"Nuevo",
main_topBar_quickLaunchButton_label:"Inicio R\u00e1pido",
navigationMenu_nearpodBlog_label:"Nearpod Blog",
interactive_video_empty_video_save:"Oops! No has subido un video. Agrega un video o clickea cancelar para salir del editor de video.",
first_lesson_overlay_loading_subtitle1_live_participation:"Mueve el mouse y selecciona Participaci\u00f3n Live.\\n",
lessons_list_npp_live_participation_session_tooltip:"Desl\u00edzate sobre la imagen de la lecci\u00f3n para lanzarla. Selecciona \"Vista Previa\" para verla antes de lanzarla.",
my_library_launch_live_participation_new:"Lanza una nueva participaci\u00f3n live",
no_access_video_library_content_tab:"Ups! Usted no tiene acceso al contenido de la libreria de videos. Por favor elija la pesta\u00f1a de \"Youtube\" o \"Subir Video\" para continuar. ",
code_palceholder_2:"C\u00d3DIGO...",
navigationSidebar_resources_title:"RECURSOS",
create_lesson_thumbnail_inVideo:"Video",
create_lesson_thumbnail_inVideo_description:"Comience con uno de nuestros videos o cree el suyo propio.",
create_lesson_thumbnail_inNearpod_description:"Crea una nueva lecci\u00f3n o sube un PowerPoint.",
create_lesson_thumbnail_inGoogleSlides_description:"Agregue el poder de Nearpod a sus diapositivas.",
cart_button_decorator_cartButtonText_adding:"Agregando",
navigationSidebar_materials_title:"MIS MATERIALES",
navigationSidebar_nearpod_content_title:"CONTENIDO DE NEARPOD",
interactive_video_settings_updated_banner:"Detalles del video actualizados",
navigationSidebar_b2bLibraries_title:"BIBLIOTECAS COMPARTIDAS",
interactive_video_participation_lowercase:"participaci\u00f3n",
student_accounts_sso_noAccountConfirm_title:"Error",
student_accounts_sso_noAccountConfirm_subTitle:"Esta cuenta de estudiante de Nearpod no existe.",
student_accounts_sso_noAccountConfirm_button:"Ok, entendido!",
navigationMenu_personalizedNews_label:"Noticias Personalizadas",
navigationSidebar_b2bLibraries_managelink_text:"Administrar >",
picker_search_noresults_empty_search:"\u00a1Hola! Tenemos incre\u00edbles videos pero ninguno que se corresponda con tu b\u00fasqueda.",
student_autofillName_getName_title:"Obtener mi nombre de...",
student_autofillName_getName_info_subtitle:"La \u00fanica informaci\u00f3n que obtendremos de tu cuenta son tus nombres y apellidos.",
interactive_video_activityPicker_title_new:"Actividades",
navigationSidebar_materials_publicLibrary_text:"Mi Biblioteca P\u00fablica",
interactive_video_blocked_title:"Es el momento de ver un video!",
interactive_video_blocked_message:"Para reproducirlo, haz click en el bot\u00f3n y el video se abrir\u00e1 en un nuevo tab.",
interactive_video_blocked_button:"Lanzar este video",
uploader_max_video_size:"Este archivo es demasiado grande. El tama\u00f1o m\u00e1ximo de archivo es de %s MB.",
lessons_list_header_action_share_tooltip:"Esta carpeta no puede ser compartida porque contiene una presentaci\u00f3n no guardada o contenido premium.",
video_preview_extra_information_related_videos:"Videos Relacionados",
student_autofillName_confirmName_title:"\u00bfEres t\u00fa?",
student_autofillName_confirmName_link:"Regresar",
student_autofillName_confirmName_button:"S\u00ed, continuar",
student_autofillName_getName_info_subtitle_2:"La \u00fanica informaci\u00f3n que obtendremos de tu cuenta es tu nombre y apellido.",
signUp_form_password_error:"M\u00ednimo 6 caracteres, sin palabras comunes.\\n",
lead_page_quickTourExtended_modal_title:"Bienvenido a la vista de Estudiante",
lead_page_quickTourExtended_modal_text:"Vuelve a la pesta\u00f1a anterior para ver la vista de Profesor y comparar.",
onboarding_collaborate_transition_animation_title_part1:"\u00a1Acabas de realizar tu primer actividad en Nearpod!",
onboarding_collaborate_transition_animation_title_part2:"Ahora, veamos que experimentar\u00e1n tus estudiantes.",
my_library_add_lessons_to_pl_modal:"A\u00f1adir Aqu\u00ed",
video_picker_max_upload_file_size:"El tama\u00f1o m\u00e1ximo de archivo es: %smb",
mylibrary_dnd_npp_text_2:"Arrastrar a carpeta",
navigationSidebar_b2bLibraries_manageDistrict_text:"Administrar Distrito",
navigationSidebar_b2bLibraries_manageSchool_text:"Administrar Escuela",
schoolProfile_overlay_subtitle_3:"H\u00e1znos saber tu rol para que podamos configurar tu biblioteca.",
video_picker_tab_my_videos:"Mis Videos",
lessons_list_npp_action_teach:"Ense\u00f1ar",
lessons_list_npp_action_live_zoom:"Live + Zoom",
my_library_teach_modal_title:"Eleg\u00ed tu modo de ense\u00f1anza",
lesson_collaborate_disabled_confirm_alert_title:"Esta lecci\u00f3n tiene un Tablero Colaborativo",
lesson_collaborate_disabled_confirm_alert_message:"Los Tableros Colaborativos est\u00e1n actualmente desactivados para lecciones Student-Paced. Estudiantes no podr\u00e1n participar en esta actividad. Abre tus configuraciones para habilitar Tableros Colaborativos para Student-Paced o continua con tu lecci\u00f3n.",
lesson_collaborate_disabled_confirm_btn_continue
:"Continuar",
lesson_collaborate_disabled_confirm_btn_settings:"Abrir Configuraciones",
my_library_teach_modal_live_participation_tooltip:"Controla el ritmo en tu dispositivo; los estudiantes responden preguntas en sus dispositivos.",
my_library_teach_modal_live_zoom_tooltip:"Dirige la lecci\u00f3n mientras ense\u00f1as con zoom.",
my_library_teach_modal_student_paced_tooltip:"Los estudiantes completan la tarea por s\u00ed solos.",
my_library_teach_modal_front_of_class_tooltip:"Presenta a la clase desde tu dispositivo. ",
global_slides_collaborateBoard:"Tablero Colaborativo",
nickelTour_tooltip_description_collaborateBoard:"Los Tableros Colaborativos son geniales para juntar las ideas y opiniones de tu clase.",
onboarding_collaborateBoard_demo_button:"Crea un Tablero Colaborativo",
onboarding_collaborateBoard_step1_title_part2:"Comencemos con un Tablero Colaborativo",
onboarding_collaborateBoard_step2_title:"Create tu propio Tablero Colaborativo",
private_library_title_schoolLibrary_2:"A\u00f1adir Lecci\u00f3n a la Biblioteca de la Escuela",
private_library_title_districtLibrary_2:"A\u00f1adir Lecci\u00f3n a la Biblioteca del Distrito",
interactive_video_settings_playback_speed_fast:"R\u00e1pido",
interactive_video_settings_playback_speed_fastest:"M\u00e1s r\u00e1pido",
interactive_video_blank_prompt_title:"\u00a1Espera!",
interactive_video_blank_prompt_message
:"No has respondido la pregunta.",
interactive_video_limitReached_modal_description:"Esta actividad ha alcanzado el m\u00e1ximo n\u00famero de estudiantes. Por favor espera que tu maestro avance a la pr\u00f3xima diapositiva.",
interactive_video_limitReached_modal_title:"Lo lamentamos!",
my_library_teach_modal_settings:"Configuraci\u00f3n de Lecciones",
my_library_teach_modal_resume_active_session:"Resumir Sesi\u00f3n Activa",
goals_collaborateCard_title_0_2:"Inicia una clase con Colaborativo",
my_library_teach_modal_view_active_sessions:"Ver Sesiones Activas",
goals_collaborateCard_title_50_2:"Inicia una clase con Colaborativo",
interactive_video_trimming_trim:"Recortar",
interactive_video_trimming_cancel:"Cancelar",
poll_multiple_options_info:"Permitir que los estudiantes seleccionen m\u00faltiples opciones",
poll_multiple_options_tooltip:"Si no se selecciona, la respuesta de la encuesta se limitar\u00e1 a una sola opci\u00f3n por alumno.",
student_accounts_sso_confirmLogin_title:"Confirmar Cuenta",
student_accounts_sso_confirmLogin_button:"Continuar",
student_accounts_sso_confirmLogin_link:"Cerrar Sesi\u00f3n",
student_accounts_sso_confirmLogin_subtitle:"Ya has ingresado con esta cuenta anteriormente. Deseas continuar?",
video_preview_extra_information_credits:"Cr\u00e9ditos",
alert_title_iv_welcome_modal:"Videos",
alert_message_iv_welcome_modal:"Cre\u00e1 tus propios videos interactivos con Nearpod! Comenz\u00e1 con uno de nuestros videos, sub\u00ed los tuyos o busc\u00e1 en YouTube. Luego, embeb\u00e9 preguntas para chequear la comprensi\u00f3n del estudiante.",
doit_button_iv_welcome_modal:"\u00a1Hag\u00e1moslo!",
login_notification_school_join_message_2:"Felicitaciones! Como usuario Nearpod School, tienes acceso a funcionalidades avanzadas y premium como bibliotecas privadas para escuela y notas para estudiantes.",
interactive_video_editor_welcome_tour_modal:"Realice videos interactivos con Nearpod! Ahora puedes agregar actividades a cualquier video para verificar su comprensi\u00f3n.",
interactive_video_editor_welcome_tour_step_1:"Agregue actividades en cualquier momento del video.",
interactive_video_editor_welcome_tour_step_2
:"Las actividades son puntos que aparecen en la l\u00ednea de tiempo. Una vez agregados, selecci\u00f3nelos para editarlos o haga clic y mantenga presionado para arrastrarlos.",
interactive_video_editor_welcome_tour_step_3:"Utilice el bot\u00f3n de \"Configuraci\u00f3n\" para agregar o actualizar el nombre, el nivel y la materia del video.",
global_skip_tour:"Omitir Recorrido",
interactive_video_limitReached_modal_descriptionHomework:"Esta actividad ha alcanzado el m\u00e1ximo n\u00famero de estudiantes. Por favor selecciona la flecha para avanzar a la siguiente diapositiva.",
interactive_video_blank_prompt_review:"Revisar Respuesta",
interactive_video_blank_prompt_submit
:"Enviar",
interactive_video_upload_credits_success:"Creditos agregados",
interactive_video_embed_in_slide_button:"Insertar en diapositivas",
interactive_video_prevent_skip_prompt_title:"\u00a1Espera!",
interactive_video_prevent_skip_prompt_message:"Ups! Al parecer no has contestado esta pregunta. Por favor env\u00eda una respuesta antes de continuar.",
interactive_video_prevent_skip_prompt_continue:"Entendido!",
global_error:"Ha ocurrido un error",
video_preview_extra_information_standards:"Est\u00e1ndares",
main_topBar_addButton_label_2:"Crear",
requiredActivitiesAndSkipping_toggle_label:"Respuestas obligatorias y prevenir saltos",
interactive_video_student_live_submit_confirmation_edit:"Editar Respuesta",
create_menu_slides_title:"Diapositivas",
create_menu_slides_description:"Combin\u00e1 contenido, video y actividades",
create_menu_videos_title:"Videos",
create_menu_videos_description:"Agreg\u00e1 actividades a cualquier video",
create_menu_google_slides_title:"Google Slides",
create_menu_google_slides_description:"Cre\u00e1 lecciones en Google Slides",
my_account_payment_content_text:"Administra tu suscripci\u00f3n y tus m\u00e9todos de pago.",
mylibrary_header_add_folder:"+ Carpeta",
interactive_video_submissions_required_title:"\u00a1Espera!",
interactive_video_submissions_required_text:"\u00a1Ups! Parece que no has terminado de ver el video y contestar las preguntas. Por favor, termina de ver el video y contesta todas las preguntas antes de continuar.",
interactive_video_trim_video_notification_message:"El video y las actividades del \u00e1rea recortada no se borrar\u00e1n. Puedes volver en cualquier momento para recuperarlas.",
my_library_explore_library_thumbnail:"EXPLORA LA BIBLIOTECA DE NEARPOD",
picker_search_youtube_noresults_title:"Whoops!",
picker_search_youtube_noresults_message:"Parece que YouTube no tiene exactamente lo que est\u00e1s buscando. Int\u00e9ntalo de nuevo.",
interactive_video_trimming_video_trimed:"Video Recortado",
create_menu_slides_title_2:"Lecciones",
login_notification_district_join_message_2:"Felicitaciones! Como usuario Nearpod District, tienes acceso a funcionalidades avanzadas y premium como bibliotecas privadas para distrito y notas para estudiantes.",
video_captions:"Subt\u00edtulos",
reference_media_audio_recorder_attached:"Grabaci\u00f3n Adjuntada",
navigationSidebar_b2bLibraries_manageNearpod_text:"Administrar Nearpod",
video_picker_tab_my_videos_message_without_videos:"Actualmente no tienes ning\u00fan video guardado en Mi biblioteca. Cuando guarde videos en Mi biblioteca, aparecer\u00e1n aqu\u00ed.",
audio_recorder_delete_confirm_text:"Est\u00e1s seguro de que quieres eliminar esta grabaci\u00f3n? Perder\u00e1s todos los cambios.",
audio_recorder_delete_confirm_cancel:"Cancelar",
audio_recorder_delete_confirm_confirm:"Si, Eliminar",
interactive_video_trimtool_save_modal_goBack:"Volver",
interactive_video_trimtool_save_modal_trimAndSave:"Recortar y Guardar",
interactive_video_trimtool_save_modal_title:"Espera! Parece que ten\u00e9s cambios sin guardar. \u00bfDese\u00e1s mantener estos cambios y guardar tu video?",
custom_audio_player_uploading:"Subiendo",
custom_audio_player_delete_confirm_text:"Est\u00e1s seguro de que quieres eliminar? Perder\u00e1s tu grabaci\u00f3n.",
custom_audio_player_delete_confirm_cancel:"Cancelar",
custom_audio_player_delete_confirm_confirm:"Si, Eliminar",
timeToClimb_creation_deleteQuestion_confirm:"\u00bfEst\u00e1s seguro de que quieres borrar esta pregunta?",
google_slides_unauthorized_create_title:"\u00a1Atenci\u00f3n!",
google_slides_unauthorized_create_message:"El complemento de Google Slides para crear lecciones solo est\u00e1 disponible para profesores con Nearpod Gold o mejor. \u00bfNo est\u00e1s preparado para actualizar? Todav\u00eda puedes subir tus Diapositivas de Google y agregar actividades en Nearpod.",
google_slides_unauthorized_create_createInNearpod:"Crear en Nearpod",
google_slides_unauthorized_create_goGold:"Actualizar cuenta",
addon_not_supported_subtitle:"Crear lecciones con el complemento de Google Slides est\u00e1 disponible para profesores con Nearpod Gold o superior. Para acceder al complemento, necesitar\u00e1s actualizar tu cuenta. No estas listo para actualizar? Puedes subir tus Google Slides y agregar actividades en Nearpod.",
addon_not_supported_upgrade:"Aprende Sobre Actualizar",
addon_not_supported_go_to_nearpod:"Crear en Nearpod",
onboardingGuide_title:"Comienza con Nearpod",
my_library_no_lessons_result_link_3:"Intenta explorando la Librer\u00eda de Nearpod.",
onboardingGuide_lessonPreviewCard_title:"Mira como funciona",
onboardingGuide_lessonPreviewCard_text:"Experimenta Nearpod en esta lecci\u00f3n interactiva.",
onboardingGuide_exploreLessonsCard_title:"Explora lecciones",
onboardingGuide_exploreLessonsCard_text:"Obtenga una vista previa de miles de lecciones predefinidas alineadas con los est\u00e1ndares.",
onboardingGuide_lessonBuilderCard_title:"Constructor de lecciones",
onboardingGuide_lessonBuilderCard_text:"Sube tus recursos existentes o comienza a construir desde cero.",
onboardingGuide_launchTourCard_title:"Inicie el recorrido",
onboardingGuide_launchTourCard_text:"Elija un modo de ense\u00f1anza y comparta la lecci\u00f3n con su clase.",
google_slides_unauthorized_edit_title:"Esta lecci\u00f3n fue creada usando el complemento de Google Slides",
google_slides_unauthorized_edit_message:"Al editar esta lecci\u00f3n, estar\u00e1s editando una versi\u00f3n de Nearpod de la misma.",
google_slides_unauthorized_edit_learnMore:"M\u00e1s Informaci\u00f3n",
google_slides_unauthorized_edit_editInNearpod:"Editar en Nearpod",
onboardingGuide_dismiss_confirm_title:"Descartar Gu\u00eda?",
onboardingGuide_dismiss_confirm_message:"Para volver a ver la gu\u00eda simplemente selecci\u00f3nala en Ayuda & FAQs en tu menu de perfil.",
onboardingGuide_dismiss_button_text:"Descartar Tips",
onboardingGuide_dismiss_confirm_dismiss:"Descartar",
onboardingGuide_navstack_button:"Gu\u00eda de Inicio",
video_picker_tab_my_videos_message_without_results:"\u00a1Hola! Tienes lecciones maravillosas en tu librer\u00eda pero ninguna con",
oeq_error_chars_exceed:"\u00a1Ups! Hubo un problema al guardar tu pregunta.",
oeq_error_shorten_chars:"Su pregunta excede la longitud m\u00e1xima de 1,000 caracteres. Ac\u00f3rtelo e intente guardar de nuevo.",
lessonPreview_header_title:"Vista previa",
lessonPreview_teacher_device_title:"Dispositivo del profesor",
lessonPreview_student_device_title:"Dispositivo del estudiante",
create_lesson_thumbnail_text:"Crea una Lecci\u00f3n",
my_library_delete_lesson_confirm_message:"Borrar esta lecci\u00f3n har\u00e1 que se borren todos los reportes, expiren todos los CODES activos, la quitar\u00e1 de todas las carpetas e invalidar\u00e1 cualquier link compartido.",
my_library_active_session_message_1:"Como usuario Silver, solo podes tener una Participaci\u00f3n en Vivo al mismo tiempo.",
my_library_active_session_resume:"Reanudar",
my_library_active_session_start:"Nueva Sesi\u00f3n",
lessonPreview_header_exit:"Salir de vista previa",
googleSlides_shareConfirm_titleNew:"Esta lecci\u00f3n fue creada usando el complemento de Google Slides",
googleSlides_shareConfirm_messageNew
:"Las copias compartidas de esta lecci\u00f3n solo ser\u00e1n editables en Nearpod.",
terms_and_conditions_suffix:" de Nearpod cambiaron. Por favor revise y acepte los cambios para seguir usando Nearpod.",
terms_and_conditions_start:"Acepto los ",
terms_and_conditions_link:"t\u00e9rminos y condiciones de Nearpod",
terms_and_conditions_end:" y tengo m\u00e1s de 13 a\u00f1os de edad.",
terms_and_conditions_success:"Los Terminos y Condiciones y la Politica de Privacidad fue aceptada",
terms_and_conditions_error:"Hubo un error",
help_feedback_suggestion_button:"Enviar sugerencia",
addon_not_supported_title:"\u00a1Atenci\u00f3n!",
oeq_error_reviewInformation:"Por favor revise la informaci\\u00f3n ingresada",
oeq_helper_message:"Por favor ingrese hasta 1000 caracteres",
interactive_video_embed_in_lesson_button:"Insertar en la lecci\u00f3n",
terms_and_conditions_terms:"Terminos y Condiciones",
terms_and_conditions_policy:"Politica de Privacidad",
terms_and_conditions_connector:" y ",
terms_and_conditions_prefix:"Los ",
google_slides_unauthorized_create_messageNew:"El complemento de Google Slides para crear lecciones solo est\u00e1 disponible para profesores con Nearpod Gold o mejor. \u00bfNo est\u00e1s preparado para actualizar? Todav\u00eda puedes subir tus presentaciones de Google Slides y agregar actividades en Nearpod.",
addon_not_supported_message:"Crear lecciones con el complemento de Google Slides est\u00e1 disponible para profesores con Nearpod Gold o superior. Para acceder al complemento, necesitar\u00e1s actualizar tu cuenta. No estas listo para actualizar? Puedes subir tus presentaciones de Google Slides y agregar actividades en Nearpod.",
navigation_sidebar_my_lessons:"Mis Lecciones",
onboardingGuide_exploreLessonsCard_text_2:"Obtenga una vista previa de miles de lecciones predefinidas.",
onboardingGuide_lessonBuilderCard_title_2:"Crea lecciones",
quiz_helper_message:"Por favor ingrese hasta 1000 caracteres",
rich_text_error_shorten_chars_helper:"Su pregunta excede la longitud m\u00e1xima de {_maxLength_} caracteres.",
my_library_lessons_title_2:"Mis Lecciones",
onboardingGuide_lessonPreviewCard_title_2:"Vista previa",
interactive_video_streamMode_title:"Este es un video. \u00bfC\u00f3mo deber\u00eda reproducirse?",
interactive_video_streamMode_option_teacherPlays_title:"Controlado por el profesor",
interactive_video_streamMode_option_studentPlays_title
:"Controlado por los estudiantes",
activity_banks_search_placeholder_ttc:"Buscar actividades Time to Climb",
activity_banks_activity_grades:"Nivel(es)",
activity_banks_title_ttc:"Explora la librer\u00eda de Time to Climb",
activity_banks_loadingActivities:"Cargando m\u00e1s actividades",
activity_banks_noResults:"\u00a1Hola! Tenemos algunas actividades geniales pero ninguna con",
activity_banks_filters_clear:"Limpiar",
activity_banks_filters_apply:"Aplicar",
activity_banks_filters_back:"Atr\u00e1s",
activity_banks_replaceConfirm_title:"\u00bfEst\u00e1s seguro?",
activity_banks_replaceConfirm_message:"Si reemplazas esta actividad perder\u00e1s todos tus cambios.",
activity_banks_replaceConfirm_backButton:"No, volver",
activity_banks_replaceConfirm_replaceButton:"Reemplazar",
poll_helper_message:"Por favor ingrese hasta 1000 caracteres",
global_review_information_error:"Por favor revise la informaci\\u00f3n ingresada",
activity_banks_noResults_firstLine:"\u00a1Hola!",
activity_banks_noResults_secondLine:"Tenemos algunas actividades geniales pero ninguna con",
interactive_video_check_progress_tooltip:"Los estudiantes avanzar\u00e1n en el video a su propio ritmo. Haz click en los puntos azules para ver las respuestas de los estudiantes a las preguntas del video.",
interactive_video_streamMode_option_studentPlays_desc:"Los estudiantes ven el video y responden las preguntas a su propio ritmo.",
interactive_video_streamMode_option_teacherPlays_desc:"El video es reproducido en el dispositivo del profesor. Las preguntas se muestran en los dispositivos de los estudiantes.",
interactive_video_streamMode_continue:"Continuar",
activity_banks_title_drawIt:"Explora la librer\u00eda de Dibujo",
activity_banks_search_placeholder_drawIt:"Buscar actividades de Dibujo",
postal_code:"C\u00f3digo Postal",
state_province:"Estado o Provincia",
activity_banks_title_matchingPairs:"Explora la librer\u00eda de Buscando Pares",
activity_banks_search_placeholder_matchingPairs:"Buscar actividades de Buscando Pares",
store_search_filter_activities:"Actividades",
global_form_invalidPostalCode:"Por favor ingrese un c\u00f3digo postal v\u00e1lido",
gs_paywallModal_title:"Dos maneras de crear lecciones de Nearpod con Google Slides",
gs_paywallModal_list_1
:"Sube Diapositivas de Google en Nearpod en Crear > Lecciones, luego Subir (GRATIS)",
gs_paywallModal_list_2:"Usa el complemento de Nearpod y crea en Diapositivas de Google (planes Gold y superiores)",
gs_paywallModal_upgradeText:"Actual\u00edzate por 30 d\u00edas el c\u00f3digo:",
gs_paywallModal_button:"Prueba Gold GRATIS",
gs_paywallModal_disclaimer:"El c\u00f3digo Gold no funcionar\u00e1 si has usado un c\u00f3digo previamente.",
activity_banks_activity_grade:"Nivel",
gs_paywallModal_list_1_part1:"Sube Diapositivas de Google en Nearpod en Crear > Lecciones, luego Subir (",
gs_paywallModal_list_1_part2:"Gratis",
gs_paywallModal_list_1_part3:")",
gs_paywallModal_list_2_part1:"Usa el complemento de Nearpod y crea en Diapositivas de Google (",
gs_paywallModal_list_2_part2:"planes Gold y superiores",
gs_paywallModal_list_2_part3:")",
no_access_video_library_content_tab_message:"Su escuela o distrito no tiene acceso a la biblioteca de videos. A\u00fan puede crear sus propias lecciones en video interactivas seleccionando las pesta\u00f1as \"YouTube\", \"Mis videos\" o \"Subir un video\" para elegir o cargar videos en Nearpod.",
picker_search_youtube_video_placeholder:"Busca videos con YouTube Safe Search o pega un link",
npp_activity_grades:"Nivel(es)",
whiteboard_button_open:"Abrir Pizarra",
whiteboard_button_close:"Cerrar Pizarra",
whiteboard_annotation_button_label:"Dibuja o escribe en esta diapositiva. Los alumnos lo ver\u00e1n en tiempo real."}
}